/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Wishlist_Wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/Wishlist/Wishlist */ "./resources/scripts/components/Wishlist/Wishlist.ts");
/* harmony import */ var _scripts_components_Wishlist_WishlistButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/Wishlist/WishlistButton */ "./resources/scripts/components/Wishlist/WishlistButton.ts");
/* harmony import */ var _scripts_components_Wishlist_VariantSelecter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scripts/components/Wishlist/VariantSelecter */ "./resources/scripts/components/Wishlist/VariantSelecter.ts");
/* harmony import */ var _scripts_components_Slider_Slider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./scripts/components/Slider/Slider */ "./resources/scripts/components/Slider/Slider.ts");
/* harmony import */ var _scripts_components_ExpectedDelivery_updateCartDelivery__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./scripts/components/ExpectedDelivery/updateCartDelivery */ "./resources/scripts/components/ExpectedDelivery/updateCartDelivery.ts");
/* harmony import */ var _scripts_components_Header_HeaderDrawer__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./scripts/components/Header/HeaderDrawer */ "./resources/scripts/components/Header/HeaderDrawer.ts");
/* harmony import */ var _scripts_components_Scrollbar_Scrollbar__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./scripts/components/Scrollbar/Scrollbar */ "./resources/scripts/components/Scrollbar/Scrollbar.ts");
/* harmony import */ var _scripts_components_Collection_ReadMoreCollection__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./scripts/components/Collection/ReadMoreCollection */ "./resources/scripts/components/Collection/ReadMoreCollection.ts");
/* harmony import */ var _scripts_components_Product_ProductSidebar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./scripts/components/Product/ProductSidebar */ "./resources/scripts/components/Product/ProductSidebar.ts");
/* harmony import */ var _scripts_components_ClubBisgaard_ClubBisgaard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./scripts/components/ClubBisgaard/ClubBisgaard */ "./resources/scripts/components/ClubBisgaard/ClubBisgaard.ts");
/* harmony import */ var _scripts_components_Sizeguide_Sizeguide__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./scripts/components/Sizeguide/Sizeguide */ "./resources/scripts/components/Sizeguide/Sizeguide.ts");
/* harmony import */ var _scripts_components_GlobalSizeGuide_GlobalSizeGuide__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./scripts/components/GlobalSizeGuide/GlobalSizeGuide */ "./resources/scripts/components/GlobalSizeGuide/GlobalSizeGuide.ts");
/* harmony import */ var _scripts_components_TradeConditions_TradeConditions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./scripts/components/TradeConditions/TradeConditions */ "./resources/scripts/components/TradeConditions/TradeConditions.ts");
/* harmony import */ var _scripts_components_ChooseVariantSize_ChooseVariantSize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./scripts/components/ChooseVariantSize/ChooseVariantSize */ "./resources/scripts/components/ChooseVariantSize/ChooseVariantSize.ts");
/* harmony import */ var _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./scripts/components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* harmony import */ var _scripts_components_Bundles_Bundles__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./scripts/components/Bundles/Bundles */ "./resources/scripts/components/Bundles/Bundles.ts");
/* harmony import */ var _scripts_components_ReloadCart_reloadCart__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./scripts/components/ReloadCart/reloadCart */ "./resources/scripts/components/ReloadCart/reloadCart.ts");
/* harmony import */ var _scripts_components_CookieConsent_RecallConsent__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./scripts/components/CookieConsent/RecallConsent */ "./resources/scripts/components/CookieConsent/RecallConsent.ts");
/* harmony import */ var _scripts_components_ShowMoreVariants_ShowMoreVariants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/ShowMoreVariants/ShowMoreVariants */ "./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts");
/* harmony import */ var _scripts_components_SiblingsSlider_SiblingsSlider__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./scripts/components/SiblingsSlider/SiblingsSlider */ "./resources/scripts/components/SiblingsSlider/SiblingsSlider.ts");
/* harmony import */ var _scripts_components_SubCollectionSlider_SubCollectionSlider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/SubCollectionSlider/SubCollectionSlider */ "./resources/scripts/components/SubCollectionSlider/SubCollectionSlider.ts");
/* harmony import */ var _scripts_components_SliderDots_SliderDots__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/SliderDots/SliderDots */ "./resources/scripts/components/SliderDots/SliderDots.ts");
/* harmony import */ var _scripts_components_Filter_Filter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./scripts/components/Filter/Filter */ "./resources/scripts/components/Filter/Filter.ts");
/* harmony import */ var _scripts_components_AvailabilityFilter_AvailabilityFilter__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./scripts/components/AvailabilityFilter/AvailabilityFilter */ "./resources/scripts/components/AvailabilityFilter/AvailabilityFilter.ts");
/* Wishlist */

/* WishlistButton */

/* VariantSelector */

/* SliderSection */

/* CartDelivery */

/* HeaderDrawer */

/* Scrollbar */

/* ReadMoreCollection */

/* ProductSidebar */

/* ClubBisgaard */

/* Sizeguide */


/* TradeConditions */

/* ChooseVariantSize */

/* Geolocator */

/* Bundles */

/* ReloadCart */

/* RecallConsent */

/* ShowMoreVariants */

/* SiblingsSlider */

/* SubCollectionSlider */



/* AvailabilityFilter */

customElements.define('slider-dots', _scripts_components_SliderDots_SliderDots__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define('subcol-slider', _scripts_components_SubCollectionSlider_SubCollectionSlider__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define('show-more-variants', _scripts_components_ShowMoreVariants_ShowMoreVariants__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define('wishlist-component', _scripts_components_Wishlist_Wishlist__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define('wishlist-button', _scripts_components_Wishlist_WishlistButton__WEBPACK_IMPORTED_MODULE_4__["default"]);
customElements.define('variant-selector', _scripts_components_Wishlist_VariantSelecter__WEBPACK_IMPORTED_MODULE_5__["default"]);
customElements.define('geolocator-component', _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_6__["default"]);
customElements.define('choose-variant-size', _scripts_components_ChooseVariantSize_ChooseVariantSize__WEBPACK_IMPORTED_MODULE_7__["default"]);
customElements.define('trade-conditions', _scripts_components_TradeConditions_TradeConditions__WEBPACK_IMPORTED_MODULE_8__["default"]);
customElements.define('sizeguide-component', _scripts_components_Sizeguide_Sizeguide__WEBPACK_IMPORTED_MODULE_9__["default"]);
customElements.define('global-sizeguide', _scripts_components_GlobalSizeGuide_GlobalSizeGuide__WEBPACK_IMPORTED_MODULE_10__["default"]);
customElements.define('club-bisgaard', _scripts_components_ClubBisgaard_ClubBisgaard__WEBPACK_IMPORTED_MODULE_11__["default"]);
customElements.define('cart-delivery', _scripts_components_ExpectedDelivery_updateCartDelivery__WEBPACK_IMPORTED_MODULE_12__["default"]);
customElements.define('slider-section', _scripts_components_Slider_Slider__WEBPACK_IMPORTED_MODULE_13__["default"]);
customElements.define('product-sidebar', _scripts_components_Product_ProductSidebar__WEBPACK_IMPORTED_MODULE_14__["default"]);
customElements.define('bundle-component', _scripts_components_Bundles_Bundles__WEBPACK_IMPORTED_MODULE_15__["default"]);
customElements.define('siblings-slider', _scripts_components_SiblingsSlider_SiblingsSlider__WEBPACK_IMPORTED_MODULE_16__["default"]);
customElements.define('filter-component', _scripts_components_Filter_Filter__WEBPACK_IMPORTED_MODULE_17__["default"]);
(0,_scripts_components_Header_HeaderDrawer__WEBPACK_IMPORTED_MODULE_18__["default"])();
(0,_scripts_components_Scrollbar_Scrollbar__WEBPACK_IMPORTED_MODULE_19__["default"])();
(0,_scripts_components_Collection_ReadMoreCollection__WEBPACK_IMPORTED_MODULE_20__["default"])();
var reloadCart = new _scripts_components_ReloadCart_reloadCart__WEBPACK_IMPORTED_MODULE_21__["default"]();
reloadCart.init();
(0,_scripts_components_CookieConsent_RecallConsent__WEBPACK_IMPORTED_MODULE_22__["default"])();
var availabilityFilter = new _scripts_components_AvailabilityFilter_AvailabilityFilter__WEBPACK_IMPORTED_MODULE_23__["default"]();
availabilityFilter.init();

/***/ }),

/***/ "./resources/scripts/components/AvailabilityFilter/AvailabilityFilter.ts":
/*!*******************************************************************************!*\
  !*** ./resources/scripts/components/AvailabilityFilter/AvailabilityFilter.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AvailabilityFilter)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * AvailabilityFilter
 * Automatically adds filter.v.availability=1 to all collection links
 * Excludes filter removal links to allow customers to remove the filter
 */
var AvailabilityFilter = /*#__PURE__*/function () {
  function AvailabilityFilter() {
    _classCallCheck(this, AvailabilityFilter);
    _defineProperty(this, "observer", null);
    _defineProperty(this, "filterParam", 'filter.v.availability=1');
    _defineProperty(this, "excludedSelectors", ['facet-remove', '.active-facets', '.facets', '.mobile-facets']);
    _defineProperty(this, "excludedClasses", ['active-facets__button', 'mobile-facets__clear']);
    this.addAvailabilityFilter = this.addAvailabilityFilter.bind(this);
    this.scanCollectionLinks = this.scanCollectionLinks.bind(this);
    this.handleMutations = this.handleMutations.bind(this);
    this.isExcludedLink = this.isExcludedLink.bind(this);
  }
  /**
   * Initialize the availability filter
   */
  return _createClass(AvailabilityFilter, [{
    key: "init",
    value: function init() {
      // Initial scan on DOM ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.scanCollectionLinks);
      } else {
        this.scanCollectionLinks();
      }
      // Watch for new links added to the DOM
      this.observer = new MutationObserver(this.handleMutations);
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    /**
     * Check if a link should be excluded from filtering
     */
  }, {
    key: "isExcludedLink",
    value: function isExcludedLink(link) {
      // Check if link has any of the excluded classes
      var hasExcludedClass = this.excludedClasses.some(function (className) {
        return link.classList.contains(className);
      });
      if (hasExcludedClass) {
        return true;
      }
      // Check if link is inside any excluded selector
      var isInsideExcludedSelector = this.excludedSelectors.some(function (selector) {
        return link.closest(selector);
      });
      if (isInsideExcludedSelector) {
        return true;
      }
      return false;
    }
    /**
     * Add availability filter to a single link
     */
  }, {
    key: "addAvailabilityFilter",
    value: function addAvailabilityFilter(link) {
      var href = link.href;
      // Check if it's a collection URL
      if (!href.includes('/collections/')) {
        return;
      }
      // Skip product URLs (they contain /collections/ but also /products/)
      if (href.includes('/products/')) {
        return;
      }
      // Skip if filter is already present - use this.filterParam
      if (href.includes(this.filterParam)) {
        return;
      }
      // Skip excluded links (removal buttons, etc.)
      if (this.isExcludedLink(link)) {
        return;
      }
      // Add the filter parameter
      var separator = href.includes('?') ? '&' : '?';
      link.href = "".concat(href).concat(separator).concat(this.filterParam);
    }
    /**
     * Scan all collection links on the page
     */
  }, {
    key: "scanCollectionLinks",
    value: function scanCollectionLinks() {
      var _this = this;
      var links = document.querySelectorAll('a[href*="/collections/"]');
      links.forEach(function (link) {
        return _this.addAvailabilityFilter(link);
      });
    }
    /**
     * Handle DOM mutations
     */
  }, {
    key: "handleMutations",
    value: function handleMutations(mutations) {
      var _this2 = this;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          // Check if the added node is a link
          if (node instanceof HTMLAnchorElement && node.href.includes('/collections/')) {
            _this2.addAvailabilityFilter(node);
          }
          // Check if the added node contains links
          if (node instanceof HTMLElement) {
            var links = node.querySelectorAll('a[href*="/collections/"]');
            links.forEach(function (link) {
              return _this2.addAvailabilityFilter(link);
            });
          }
        });
      });
    }
    /**
     * Destroy the observer
     */
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/Bundles/Bundles.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Bundles/Bundles.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BundleComponent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var BundleComponent = /*#__PURE__*/function (_HTMLElement) {
  function BundleComponent() {
    var _this;
    _classCallCheck(this, BundleComponent);
    _this = _callSuper(this, BundleComponent);
    _defineProperty(_this, "addToCartButton", _this.querySelector('#bundle-add-to-cart'));
    _defineProperty(_this, "bundleItems", Array.from(_this.querySelectorAll('.bundle-item')));
    _defineProperty(_this, "sizingInputs", Array.from(_this.querySelectorAll('.bundle-variant')));
    _defineProperty(_this, "productUrl", _this.getAttribute('data-producturl'));
    _this.handleAddBundleToCart = _this.handleAddBundleToCart.bind(_this);
    _this.getJwtToken = _this.getJwtToken.bind(_this);
    _this.isTokenExpired = _this.isTokenExpired.bind(_this);
    _this.decodeJwtToken = _this.decodeJwtToken.bind(_this);
    _this.refreshJwtToken = _this.refreshJwtToken.bind(_this);
    return _this;
  }
  _inherits(BundleComponent, _HTMLElement);
  return _createClass(BundleComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListeners();
      this.initializeBundleItems();
    }
  }, {
    key: "initializeBundleItems",
    value: function initializeBundleItems() {
      var _this2 = this;
      this.bundleItems.forEach(function (bundleItem) {
        var bundleSiblings = Array.from(bundleItem.querySelectorAll('.bundle-sibling'));
        var firstAvailableSibling = bundleSiblings.find(function (sibling) {
          return sibling.dataset.available === 'true';
        });
        if (firstAvailableSibling) {
          _this2.handleSiblingSelection(firstAvailableSibling);
        }
      });
      // Initialize button state
      this.updateAddToCartButtonState();
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this3 = this;
      this.bundleItems.forEach(function (bundleItem) {
        var bundleSiblings = Array.from(bundleItem.querySelectorAll('.bundle-sibling'));
        bundleSiblings.forEach(function (sibling) {
          sibling.addEventListener('click', function (event) {
            event.preventDefault();
            _this3.handleSiblingSelection(sibling);
          });
        });
        // Add event listeners for variant selection
        var sizeFieldsets = bundleItem.querySelectorAll('.bundle-sibling-sizes');
        sizeFieldsets.forEach(function (fieldset) {
          var radioInputs = fieldset.querySelectorAll('input[type="radio"]');
          radioInputs.forEach(function (input) {
            input.addEventListener('change', function () {
              _this3.updateAddToCartButtonState();
              // Hide error message when a size is selected
              _this3.hideErrorMessage();
            });
          });
        });
      });
      this.addToCartButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (_this3.addToCartButton.hasAttribute('disabled') && _this3.addToCartButton.getAttribute('disabled') === 'true') {
          _this3.showErrorMessage();
          return;
        }
        _this3.handleAddBundleToCart();
      });
    }
  }, {
    key: "handleSiblingSelection",
    value: function handleSiblingSelection(sibling) {
      var bundleItem = sibling.closest('.bundle-item');
      if (!bundleItem) return;
      var siblingsForProduct = Array.from(bundleItem.querySelectorAll('.bundle-sibling'));
      var sizeFieldsets = Array.from(bundleItem.querySelectorAll('.bundle-sibling-sizes'));
      var bundleProductTitle = bundleItem.querySelector('.bundle-product-title');
      var sizeGuides = Array.from(bundleItem.querySelectorAll('.product-side-guide'));
      var _sibling$dataset = sibling.dataset,
        id = _sibling$dataset.id,
        title = _sibling$dataset.title,
        available = _sibling$dataset.available;
      // If the product is not available, find and select the first available product
      if (available === 'false') {
        var firstAvailableSibling = siblingsForProduct.find(function (s) {
          return s.dataset.available === 'true';
        });
        if (firstAvailableSibling) {
          this.handleSiblingSelection(firstAvailableSibling);
          return;
        }
      }
      var sizeFieldset = sizeFieldsets.find(function (fieldset) {
        return fieldset.dataset.id === id;
      });
      // Select the sibling and deselect the others
      siblingsForProduct.forEach(function (_sibling) {
        _sibling.classList.remove('bundle-item-selected');
        _sibling.style.border = '1px solid #DDD';
      });
      sibling.classList.add('bundle-item-selected');
      sibling.style.border = '2px solid #96766B';
      // Hide all size fieldsets and show the one that corresponds to the selected sibling
      sizeFieldsets.forEach(function (fieldset) {
        fieldset.classList.add('!tw-hidden');
      });
      if (sizeFieldset) {
        sizeFieldset.classList.remove('!tw-hidden');
      }
      // Hide all size guides and show the one that corresponds to the selected sibling
      sizeGuides.forEach(function (sizeGuide) {
        sizeGuide.classList.add('!tw-hidden');
      });
      var sizeGuide = sizeGuides.find(function (guide) {
        return guide.dataset.id === id;
      });
      if (sizeGuide) {
        sizeGuide.classList.remove('!tw-hidden');
      }
      // Update the product title
      if (bundleProductTitle && title) {
        bundleProductTitle.textContent = title;
      }
      // Check if all required products are selected and update button state
      this.updateAddToCartButtonState();
    }
  }, {
    key: "updateAddToCartButtonState",
    value: function updateAddToCartButtonState() {
      var bundleItems = Array.from(this.querySelectorAll('.bundle-item'));
      var allProductsSelected = bundleItems.every(function (bundleItem) {
        var selectedSibling = bundleItem.querySelector('.bundle-sibling.bundle-item-selected');
        if (!selectedSibling) return false;
        var sizeFieldset = bundleItem.querySelector('.bundle-sibling-sizes:not([class*="!tw-hidden"])');
        if (!sizeFieldset) return false;
        var selectedVariant = sizeFieldset.querySelector('input[type="radio"]:checked');
        return !!selectedVariant;
      });
      if (allProductsSelected) {
        this.addToCartButton.removeAttribute('disabled');
        this.addToCartButton.textContent = this.addToCartButton.dataset.addToCartText || 'Add to cart';
        this.hideErrorMessage();
      } else {
        this.addToCartButton.setAttribute('disabled', 'true');
        this.addToCartButton.textContent = this.addToCartButton.dataset.bygBundleText || 'Byg bundle';
      }
    }
    // The method to add the bundle to the cart.
    // This methods should be called when the user clicks the "Add to cart" button
    // When called it gets the JWT token, and sends a POST request to the API to add the bundle to the cart
    // if the request is successfusl, it returns the bundle object, which contains the bundle and the variant
    // The variant should be added to the cart
  }, {
    key: "handleAddBundleToCart",
    value: function () {
      var _handleAddBundleToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var token, productId, metaobjectId, bundleItems, bundleComponents, shop, body, response, errorData, refreshedToken, retryResponse, retryErrorData, retryData, _bundle, _variant2, data, bundle, variant, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return this.getJwtToken(window.Shopify.shop);
            case 1:
              token = _context.v;
              productId = this.getAttribute('data-productid');
              metaobjectId = this.getAttribute('data-metaobjectid'); // Get all bundle items
              bundleItems = Array.from(this.querySelectorAll('.bundle-item')); // Collect selected variants from each bundle item
              bundleComponents = [];
              bundleItems.forEach(function (bundleItem) {
                var selectedSibling = bundleItem.querySelector('.bundle-sibling.bundle-item-selected');
                if (!selectedSibling) return;
                var sizeFieldset = bundleItem.querySelector('.bundle-sibling-sizes:not([class*="!tw-hidden"])');
                if (!sizeFieldset) return;
                var selectedVariant = sizeFieldset.querySelector('input[type="radio"]:checked');
                if (!selectedVariant) return;
                var variantId = selectedVariant.getAttribute('data-id');
                if (variantId) {
                  bundleComponents.push(variantId);
                }
              });
              // Validate that we have all required components
              if (!(bundleComponents.length === 0)) {
                _context.n = 2;
                break;
              }
              console.error('No variants selected');
              return _context.a(2);
            case 2:
              shop = window.Shopify.shop;
              body = {
                productId: productId,
                bundleComponents: bundleComponents,
                metaobjectId: metaobjectId,
                shop: shop
              };
              console.log('Adding bundle to cart:', body);
              _context.n = 3;
              return fetch('http://bundle-app.edition.dk/api/bundle', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(token)
                },
                body: JSON.stringify(body)
              });
            case 3:
              response = _context.v;
              if (response.ok) {
                _context.n = 11;
                break;
              }
              _context.n = 4;
              return response.json()["catch"](function () {
                return {};
              });
            case 4:
              errorData = _context.v;
              console.error('Bundle API error:', {
                status: response.status,
                statusText: response.statusText,
                error: errorData
              });
              if (!(response.status === 401)) {
                _context.n = 10;
                break;
              }
              console.log('Token expired. Attempting to refresh token...');
              _context.n = 5;
              return this.getJwtToken(window.Shopify.shop);
            case 5:
              refreshedToken = _context.v;
              _context.n = 6;
              return fetch('http://bundle-app.edition.dk/api/bundle', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(refreshedToken)
                },
                body: JSON.stringify(body)
              });
            case 6:
              retryResponse = _context.v;
              if (retryResponse.ok) {
                _context.n = 8;
                break;
              }
              _context.n = 7;
              return retryResponse.json()["catch"](function () {
                return {};
              });
            case 7:
              retryErrorData = _context.v;
              console.error('Bundle API retry error:', {
                status: retryResponse.status,
                statusText: retryResponse.statusText,
                error: retryErrorData
              });
              throw new Error(retryErrorData.message || 'Failed to add bundle to cart');
            case 8:
              _context.n = 9;
              return retryResponse.json();
            case 9:
              retryData = _context.v;
              _bundle = retryData.bundle, _variant2 = retryData.variant;
              _context.n = 10;
              return this.addVariantToCart(_variant2);
            case 10:
              throw new Error(errorData.message || 'Failed to add bundle to cart');
            case 11:
              _context.n = 12;
              return response.json();
            case 12:
              data = _context.v;
              bundle = data.bundle, variant = data.variant;
              console.log('data', data);
              _context.n = 13;
              return this.addVariantToCart(variant);
            case 13:
              _context.n = 15;
              break;
            case 14:
              _context.p = 14;
              _t = _context.v;
              console.error('Error adding bundle to cart:', _t);
            case 15:
              return _context.a(2);
          }
        }, _callee, this, [[0, 14]]);
      }));
      function handleAddBundleToCart() {
        return _handleAddBundleToCart.apply(this, arguments);
      }
      return handleAddBundleToCart;
    }()
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(variant) {
        var _this4 = this;
        var interval, response, pollForVariant, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              this.addToCartButton.setAttribute('disabled', 'true');
              this.addToCartButton.classList.add('loading');
              _context3.n = 1;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: variant,
                  quantity: 1
                })
              });
            case 1:
              response = _context3.v;
              if (response.ok) {
                _context3.n = 2;
                break;
              }
              throw new Error('Failed to add variant to cart');
            case 2:
              pollForVariant = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                  var pollingResponse, _yield$pollingRespons, variants, _t2;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        _context2.p = 0;
                        _context2.n = 1;
                        return fetch("".concat(_this4.productUrl, ".json"));
                      case 1:
                        pollingResponse = _context2.v;
                        if (pollingResponse.ok) {
                          _context2.n = 2;
                          break;
                        }
                        throw new Error('Network response was not ok');
                      case 2:
                        _context2.n = 3;
                        return pollingResponse.json();
                      case 3:
                        _yield$pollingRespons = _context2.v;
                        variants = _yield$pollingRespons.product.variants;
                        if (variants.some(function (_variant) {
                          return _variant.id === Number(variant);
                        })) {
                          clearInterval(interval);
                          _this4.toggleCartDrawer();
                        }
                        _context2.n = 5;
                        break;
                      case 4:
                        _context2.p = 4;
                        _t2 = _context2.v;
                        console.error('Error polling for variant:', _t2);
                      case 5:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[0, 4]]);
                }));
                return function pollForVariant() {
                  return _ref.apply(this, arguments);
                };
              }();
              interval = setInterval(pollForVariant, 1500);
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.error('Error adding variant to cart:', _t3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function addVariantToCart(_x) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "toggleCartDrawer",
    value: function toggleCartDrawer() {
      document.documentElement.dispatchEvent(new CustomEvent('edition:cart:reload', {
        bubbles: true
      }));
      var cartIconBubble = document.querySelector('#cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.click();
      }
      this.addToCartButton.classList.remove('loading');
      this.addToCartButton.removeAttribute('disabled');
    }
  }, {
    key: "getJwtToken",
    value: function () {
      var _getJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(shop) {
        var token, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              token = localStorage.getItem('jwtTokenBundle'); // If no token, or the token is expired, request a new one
              if (!(!token || this.isTokenExpired(token))) {
                _context4.n = 2;
                break;
              }
              console.log('Token expired or missing. Getting a new token...');
              _context4.n = 1;
              return this.refreshJwtToken(shop);
            case 1:
              token = _context4.v;
            case 2:
              return _context4.a(2, token);
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              console.error('Failed to get JWT token', _t4);
              return _context4.a(2, null);
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function getJwtToken(_x2) {
        return _getJwtToken.apply(this, arguments);
      }
      return getJwtToken;
    }() // Check if the token is expired
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(token) {
      var decodedToken = this.decodeJwtToken(token);
      if (decodedToken && decodedToken.exp) {
        var expiry = decodedToken.exp * 1000; // Convert to milliseconds
        return Date.now() > expiry;
      }
      return false;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "decodeJwtToken",
    value: function decodeJwtToken(token) {
      try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
        }).join(''));
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error('Failed to decode JWT token', e);
        return null;
      }
    }
    // Refresh the JWT token
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "refreshJwtToken",
    value: function () {
      var _refreshJwtToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(shop) {
        var response, data, jwtToken;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return fetch('http://bundle-app.edition.dk/api/auth', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  shop: shop
                }) // Send shop identifier
              });
            case 1:
              response = _context5.v;
              if (response.ok) {
                _context5.n = 2;
                break;
              }
              throw new Error('Failed to refresh token');
            case 2:
              _context5.n = 3;
              return response.json();
            case 3:
              data = _context5.v;
              jwtToken = data.token;
              localStorage.setItem('jwtTokenBundle', jwtToken);
              return _context5.a(2, jwtToken);
          }
        }, _callee5);
      }));
      function refreshJwtToken(_x3) {
        return _refreshJwtToken.apply(this, arguments);
      }
      return refreshJwtToken;
    }()
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage() {
      var _this5 = this;
      var errorMessage = this.querySelector('#bundle-error-message');
      if (errorMessage) {
        // Remove any existing classes first
        errorMessage.classList.remove('active');
        // Force a reflow to ensure the animation plays
        var reflowTrigger = errorMessage.offsetWidth;
        // Add the active class which will trigger the animation
        errorMessage.classList.add('active');
        setTimeout(function () {
          _this5.hideErrorMessage();
        }, 3000);
      }
    }
  }, {
    key: "hideErrorMessage",
    value: function hideErrorMessage() {
      var errorMessage = this.querySelector('#bundle-error-message');
      if (errorMessage) {
        // Remove the active class to trigger the fade out animation
        errorMessage.classList.remove('active');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ChooseVariantSize/ChooseVariantSize.ts":
/*!*****************************************************************************!*\
  !*** ./resources/scripts/components/ChooseVariantSize/ChooseVariantSize.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ChooseVariantSize)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var ChooseVariantSize = /*#__PURE__*/function (_HTMLElement) {
  function ChooseVariantSize() {
    var _this;
    _classCallCheck(this, ChooseVariantSize);
    _this = _callSuper(this, ChooseVariantSize);
    _defineProperty(_this, "hideChooseVariantBtn", void 0);
    _defineProperty(_this, "addToCartBtn", void 0);
    _this.hideChooseVariantBtn = null;
    _this.addToCartBtn = null;
    _this.hide_choose_variant_size = _this.hide_choose_variant_size.bind(_this);
    return _this;
  }
  _inherits(ChooseVariantSize, _HTMLElement);
  return _createClass(ChooseVariantSize, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.hideChooseVariantBtn = this.querySelector('#choose_variant_size');
      this.addToCartBtn = this.querySelector('#add_to_cart_btn');
      document.addEventListener('DOMContentLoaded', this.uncheckSelectedRadio);
      if (this.hideChooseVariantBtn) {
        document.addEventListener('variant:change', this.hide_choose_variant_size);
      }
    }
  }, {
    key: "hide_choose_variant_size",
    value: function hide_choose_variant_size() {
      if (this.hideChooseVariantBtn) {
        this.hideChooseVariantBtn.classList.add('tw-hidden');
      }
      if (this.addToCartBtn) {
        this.addToCartBtn.classList.remove('tw-hidden');
      }
    }
  }, {
    key: "uncheckSelectedRadio",
    value: function uncheckSelectedRadio() {
      var checkedRadios = this.querySelectorAll('input.SizeSwatch__Radio[checked]');
      var hasSelectedVariant = this.querySelector('input.SizeSwatch__Radio[selectedVariant]');
      if (hasSelectedVariant) {
        var selectedVariant = hasSelectedVariant.getAttribute('selectedVariant');
        if (selectedVariant === 'true') {
          return;
        }
      }
      checkedRadios.forEach(function (radio) {
        radio.checked = false;
        radio.removeAttribute('checked');
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/ClubBisgaard.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/ClubBisgaard.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ClubBisgaard)
/* harmony export */ });
/* harmony import */ var _Growave_Growave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Growave/Growave */ "./resources/scripts/components/ClubBisgaard/Growave/Growave.ts");
/* harmony import */ var _ClubBisgaardContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ClubBisgaardContent */ "./resources/scripts/components/ClubBisgaard/ClubBisgaardContent.ts");
/* harmony import */ var _ConfirmationModal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ConfirmationModal */ "./resources/scripts/components/ClubBisgaard/ConfirmationModal.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }



var ClubBisgaard = /*#__PURE__*/function (_HTMLElement) {
  function ClubBisgaard() {
    var _this;
    _classCallCheck(this, ClubBisgaard);
    _this = _callSuper(this, ClubBisgaard);
    _this.initClubBisgaardContent = _this.initClubBisgaardContent.bind(_this);
    _this.initGrowave = _this.initGrowave.bind(_this);
    return _this;
  }
  _inherits(ClubBisgaard, _HTMLElement);
  return _createClass(ClubBisgaard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initClubBisgaardContent();
      this.initGrowave();
      var logout = this.querySelector("a[href='/account/logout']");
      if (logout) {
        logout.addEventListener('click', function () {
          sessionStorage.removeItem('cachedCustomer');
          sessionStorage.removeItem('cachedSpendingRules');
          sessionStorage.removeItem('cachedActiveRewards');
          sessionStorage.removeItem('cachedActivityHistory');
          sessionStorage.removeItem('cachedEarningRules');
        });
      }
      customElements.define('confirmation-modal', _ConfirmationModal__WEBPACK_IMPORTED_MODULE_0__["default"]);
    }
    // initiate the Growave components
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "initGrowave",
    value: function initGrowave() {
      var growave = new _Growave_Growave__WEBPACK_IMPORTED_MODULE_1__["default"]();
      growave.init();
    }
    // initiate the ClubBisgaard content components
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "initClubBisgaardContent",
    value: function initClubBisgaardContent() {
      customElements.define('club-bisgaard-content', _ClubBisgaardContent__WEBPACK_IMPORTED_MODULE_2__["default"]);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/ClubBisgaardContent.ts":
/*!**************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/ClubBisgaardContent.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ClubBisgaardContent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var ClubBisgaardContent = /*#__PURE__*/function (_HTMLElement) {
  function ClubBisgaardContent() {
    var _this;
    _classCallCheck(this, ClubBisgaardContent);
    _this = _callSuper(this, ClubBisgaardContent);
    _defineProperty(_this, "tabs", Array.from(_this.querySelectorAll('li.club-bisgaard_tab')));
    _defineProperty(_this, "panels", Array.from(_this.querySelectorAll('div.club-bisgaard_panel')));
    _defineProperty(_this, "clubTabs", Array.from(_this.querySelectorAll('li.club-bisgaard_tab-club')));
    _defineProperty(_this, "clubPanels", Array.from(_this.querySelectorAll('div.club-bisgaard_panel-club')));
    _defineProperty(_this, "rewardsContainer", _this.querySelector('#rewards'));
    _defineProperty(_this, "rewardsTabs", Array.from(_this.rewardsContainer.querySelectorAll('.club-bisgaard-reward-options a')));
    _this.handleTabClick = _this.handleTabClick.bind(_this);
    _this.handleClubTabClick = _this.handleClubTabClick.bind(_this);
    _this.handleRewardTabClick = _this.handleRewardTabClick.bind(_this);
    return _this;
  }
  _inherits(ClubBisgaardContent, _HTMLElement);
  return _createClass(ClubBisgaardContent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function (event) {
          event.preventDefault();
          if (tab.dataset.type === 'logout') {
            window.location.href = '/account/logout';
          } else {
            _this2.handleTabClick(tab);
          }
        });
      });
      this.clubTabs.forEach(function (tab) {
        tab.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleClubTabClick(tab);
        });
      });
      this.rewardsTabs.forEach(function (tab) {
        tab.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleRewardTabClick(tab);
        });
      });
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(tab) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      this.tabs.forEach(function (tab) {
        tab.removeAttribute('aria-selected');
      });
      tab.setAttribute('aria-selected', 'true');
      var tabType = tab.dataset.type;
      this.panels.forEach(function (panel) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        panel.dataset.type === tabType ? panel.setAttribute('aria-hidden', 'false') : panel.setAttribute('aria-hidden', 'true');
      });
    }
  }, {
    key: "handleClubTabClick",
    value: function handleClubTabClick(tab) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      this.clubTabs.forEach(function (tab) {
        tab.removeAttribute('aria-selected');
      });
      tab.setAttribute('aria-selected', 'true');
      var tabType = tab.dataset.type;
      this.clubPanels.forEach(function (panel) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        panel.dataset.type === tabType ? panel.setAttribute('aria-hidden', 'false') : panel.setAttribute('aria-hidden', 'true');
      });
    }
  }, {
    key: "handleRewardTabClick",
    value: function handleRewardTabClick(tab) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      this.rewardsTabs.forEach(function (tab) {
        tab.removeAttribute('aria-selected');
      });
      tab.setAttribute('aria-selected', 'true');
      var panels = Array.from(this.rewardsContainer.querySelectorAll('.rewards-tab'));
      panels.forEach(function (panel) {
        panel.setAttribute('aria-hidden', 'true');
      });
      var panel = this.rewardsContainer.querySelector("#".concat(tab.dataset.target));
      if (panel) {
        panel.setAttribute('aria-hidden', 'false');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/ConfirmationModal.ts":
/*!************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/ConfirmationModal.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionConfirmationModal)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var EditionConfirmationModal = /*#__PURE__*/function (_HTMLElement) {
  function EditionConfirmationModal() {
    var _this;
    _classCallCheck(this, EditionConfirmationModal);
    _this = _callSuper(this, EditionConfirmationModal);
    _defineProperty(_this, "loader", _this.querySelector('.club-bisgaard_loader'));
    _defineProperty(_this, "confirmAction", _this.querySelector('#confirm-action'));
    _defineProperty(_this, "cancelAction", _this.querySelector('#cancel-action'));
    _defineProperty(_this, "confirmHandler", void 0);
    _defineProperty(_this, "cancelHandler", void 0);
    _this.toggleConfirmationBox = _this.toggleConfirmationBox.bind(_this);
    _this.initActions = _this.initActions.bind(_this);
    _this.handleConfirm = _this.handleConfirm.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.removeEventListeners = _this.removeEventListeners.bind(_this);
    return _this;
  }
  // eslint-disable-next-line class-methods-use-this
  _inherits(EditionConfirmationModal, _HTMLElement);
  return _createClass(EditionConfirmationModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {}
  }, {
    key: "toggleConfirmationBox",
    value: function toggleConfirmationBox() {
      this.classList.toggle('confirmation-box--visible');
    }
  }, {
    key: "initActions",
    value: function initActions(func) {
      var _this2 = this;
      this.confirmHandler = function (event) {
        event.preventDefault();
        _this2.handleConfirm(func);
      };
      this.cancelHandler = function (event) {
        event.preventDefault();
        _this2.handleCancel();
      };
      this.confirmAction.addEventListener('click', this.confirmHandler);
      this.cancelAction.addEventListener('click', this.cancelHandler);
    }
  }, {
    key: "handleConfirm",
    value: function () {
      var _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(func) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.loader.style.display = 'block';
              _context.n = 1;
              return func();
            case 1:
              this.loader.style.display = 'none';
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('Error', _t);
            case 3:
              _context.p = 3;
              this.toggleConfirmationBox();
              return _context.f(3);
            case 4:
              // remove the event listener
              this.removeEventListeners();
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2, 3, 4]]);
      }));
      function handleConfirm(_x) {
        return _handleConfirm.apply(this, arguments);
      }
      return handleConfirm;
    }()
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.toggleConfirmationBox();
      this.removeEventListeners();
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.confirmAction.removeEventListener('click', this.confirmHandler);
      this.cancelAction.removeEventListener('click', this.cancelHandler);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/Growave.ts":
/*!**********************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/Growave.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowave)
/* harmony export */ });
/* harmony import */ var _GrowaveGetCustomer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./GrowaveGetCustomer */ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomer.ts");
/* harmony import */ var _GrowaveGetEarningRules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GrowaveGetEarningRules */ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetEarningRules.ts");
/* harmony import */ var _GrowaveGetSpendingRules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./GrowaveGetSpendingRules */ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetSpendingRules.ts");
/* harmony import */ var _GrowaveGetCustomerActiveRewards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./GrowaveGetCustomerActiveRewards */ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerActiveRewards.ts");
/* harmony import */ var _GrowaveGetCustomerActivityHistory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./GrowaveGetCustomerActivityHistory */ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerActivityHistory.ts");
/* harmony import */ var _GrowaveGetCustomerWishlists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./GrowaveGetCustomerWishlists */ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerWishlists.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
// Initiate all growave components into one class






var EditionGrowave = /*#__PURE__*/function () {
  function EditionGrowave() {
    _classCallCheck(this, EditionGrowave);
    this.init = this.init.bind(this);
    this.initComponents = this.initComponents.bind(this);
  }
  return _createClass(EditionGrowave, [{
    key: "init",
    value: function init() {
      var _this = this;
      var getGrowaveCustomer = new _GrowaveGetCustomer__WEBPACK_IMPORTED_MODULE_0__["default"]();
      getGrowaveCustomer.init();
      // check if the customer data is already cached if it is not then wait for the customerDataFetched event
      if (sessionStorage.getItem('cachedCustomer')) {
        this.initComponents();
      } else {
        document.addEventListener('customerDataFetched', function () {
          _this.initComponents();
        });
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "initComponents",
    value: function initComponents() {
      var getGrowaveEarningRules = new _GrowaveGetEarningRules__WEBPACK_IMPORTED_MODULE_1__["default"]();
      getGrowaveEarningRules.init();
      var getGrowaveSpendingRules = new _GrowaveGetSpendingRules__WEBPACK_IMPORTED_MODULE_2__["default"]();
      getGrowaveSpendingRules.init();
      var getGrowaveActiveRewards = new _GrowaveGetCustomerActiveRewards__WEBPACK_IMPORTED_MODULE_3__["default"]();
      getGrowaveActiveRewards.init();
      var getGrowaveCustomerWishlists = new _GrowaveGetCustomerWishlists__WEBPACK_IMPORTED_MODULE_4__["default"]();
      getGrowaveCustomerWishlists.init();
      var getGrowaveCustomerActivityHistory = new _GrowaveGetCustomerActivityHistory__WEBPACK_IMPORTED_MODULE_5__["default"]();
      getGrowaveCustomerActivityHistory.init();
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomer.ts":
/*!*********************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomer.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowaveGetCustomer)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var EditionGrowaveGetCustomer = /*#__PURE__*/function () {
  function EditionGrowaveGetCustomer() {
    _classCallCheck(this, EditionGrowaveGetCustomer);
    _defineProperty(this, "clubBisgaard", document.querySelector('club-bisgaard'));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector('.club-bisgaard_loader'));
    this.init = this.init.bind(this);
    this.getCustomer = this.getCustomer.bind(this);
    this.displayCustomerData = this.displayCustomerData.bind(this);
  }
  return _createClass(EditionGrowaveGetCustomer, [{
    key: "init",
    value: function init() {
      var _this = this;
      // check if the customer data is already cached
      var cachedCustomer = sessionStorage.getItem('cachedCustomer');
      if (!cachedCustomer) {
        this.getCustomer(this.customerId);
      } else {
        var customer = JSON.parse(cachedCustomer);
        this.displayCustomerData(customer);
      }
      document.addEventListener('customerUpdated', function (event) {
        _this.getCustomer(_this.customerId);
      });
    }
  }, {
    key: "getCustomer",
    value: function () {
      var _getCustomer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var customeridParam, response, data, customer, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              customeridParam = "customerid=".concat(id);
              _context.n = 1;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-customer?".concat(customeridParam), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 1:
              response = _context.v;
              if (!response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.json();
            case 2:
              data = _context.v;
              customer = data;
              this.displayCustomerData(customer);
              sessionStorage.setItem('cachedCustomer', JSON.stringify(customer));
              _context.n = 4;
              break;
            case 3:
              console.error("HTTP-Error: ".concat(response.status));
              this.loader.style.display = 'none';
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error(_t);
              this.loader.style.display = 'none';
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function getCustomer(_x) {
        return _getCustomer.apply(this, arguments);
      }
      return getCustomer;
    }()
  }, {
    key: "displayCustomerData",
    value: function () {
      var _displayCustomerData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(customer) {
        var pointsBalance, pointsIndicator, birthday, acceptsEmailMarketing;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loader.style.display = 'block';
              try {
                pointsBalance = customer.pointsBalance === 0 ? '0' : customer.pointsBalance.toString();
                pointsIndicator = this.clubBisgaard.querySelector('#points_balance');
                if (pointsIndicator && pointsBalance) {
                  // Replace dot with comma in pointsBalance if present
                  pointsBalance = pointsBalance.replace('.', ',');
                  // If pointsBalance is not null, the customer has redeemed points.
                  // Subtract the redeemed points from the current points balance.
                  pointsIndicator.innerHTML = pointsBalance;
                  pointsIndicator.dataset.points = pointsBalance;
                  localStorage.setItem('customerPoints', pointsBalance);
                  document.dispatchEvent(new CustomEvent('customerDataFetched'));
                }
                // Set birthday attribute if the customer has a birthday set
                // eslint-disable-next-line prefer-destructuring
                birthday = customer.birthday;
                if (birthday !== null && birthday !== void 0 ? birthday : false) {
                  this.clubBisgaard.setAttribute('data-birthday', birthday);
                }
                // Set email marketing attribute if the customer has accepted email marketing
                // eslint-disable-next-line prefer-destructuring
                acceptsEmailMarketing = customer.acceptsEmailMarketing;
                if (acceptsEmailMarketing !== null && acceptsEmailMarketing !== void 0 ? acceptsEmailMarketing : false) {
                  this.clubBisgaard.setAttribute('data-marketing', 'true');
                }
              } catch (error) {
                console.error(error);
              } finally {
                this.loader.style.display = 'none';
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function displayCustomerData(_x2) {
        return _displayCustomerData.apply(this, arguments);
      }
      return displayCustomerData;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerActiveRewards.ts":
/*!**********************************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerActiveRewards.ts ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowaveGetCustomerActiveRewards)
/* harmony export */ });
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../utils/Animations */ "./resources/scripts/utils/Animations.ts");
/* harmony import */ var _utils_CartApiEndpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../utils/CartApiEndpoints */ "./resources/scripts/utils/CartApiEndpoints.ts");
/* harmony import */ var _utils_DiscountCode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/DiscountCode */ "./resources/scripts/utils/DiscountCode.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }



var EditionGrowaveGetCustomerActiveRewards = /*#__PURE__*/function () {
  function EditionGrowaveGetCustomerActiveRewards() {
    _classCallCheck(this, EditionGrowaveGetCustomerActiveRewards);
    _defineProperty(this, "clubBisgaard", document.querySelector('club-bisgaard'));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector('.club-bisgaard_loader'));
    _defineProperty(this, "rewardsSelector", document.querySelector('#rewards'));
    _defineProperty(this, "confirmationModal", document.querySelector('confirmation-modal'));
    this.init = this.init.bind(this);
    this.getActiveRewards = this.getActiveRewards.bind(this);
    this.displayActiveRewards = this.displayActiveRewards.bind(this);
  }
  return _createClass(EditionGrowaveGetCustomerActiveRewards, [{
    key: "init",
    value: function init() {
      var _this = this;
      // check if the active rewards are already cached
      var cachedActiveRewards = sessionStorage.getItem('cachedActiveRewards');
      if (!cachedActiveRewards) {
        this.getActiveRewards(this.customerId);
      } else {
        var activeRewards = JSON.parse(cachedActiveRewards);
        this.displayActiveRewards(activeRewards);
      }
      document.addEventListener('customerUpdated', function (event) {
        setTimeout(function () {
          _this.getActiveRewards(_this.customerId);
        }, 1500);
      });
    }
    // Get active rewards for the customer
  }, {
    key: "getActiveRewards",
    value: function () {
      var _getActiveRewards = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var customeridParam, response, data, activeRewards, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.loader.style.display = 'block';
              customeridParam = "customerid=".concat(id);
              _context.n = 1;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-active-rewards?".concat(customeridParam), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 1:
              response = _context.v;
              if (!response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.json();
            case 2:
              data = _context.v;
              activeRewards = data.rewards;
              this.displayActiveRewards(activeRewards);
              sessionStorage.setItem('cachedActiveRewards', JSON.stringify(activeRewards));
              _context.n = 4;
              break;
            case 3:
              console.error("HTTP-Error: ".concat(response.status));
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error(_t);
            case 6:
              _context.p = 6;
              this.loader.style.display = 'none';
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5, 6, 7]]);
      }));
      function getActiveRewards(_x) {
        return _getActiveRewards.apply(this, arguments);
      }
      return getActiveRewards;
    }()
  }, {
    key: "displayActiveRewards",
    value: function displayActiveRewards(rewards) {
      var _this2 = this;
      var pointsBalancesStorage = localStorage.getItem('customerPoints');
      var pointsBalance = Number(pointsBalancesStorage);
      // create active rewards selector for outputting the different active rewards
      var activeRewardsSelector = this.rewardsSelector.querySelector('#active-rewards');
      if (rewards.length === 0) {
        activeRewardsSelector.innerHTML = 'Du har ikke brugt nogle point på belønninger endnu.';
        return;
      }
      activeRewardsSelector.innerHTML = '';
      var activeRewardsList = document.createElement('ul');
      activeRewardsList.classList.add('spending-rules-grid');
      rewards.forEach(function (reward) {
        var rewardItem = document.createElement('li');
        // set iconSrc based on the reward type
        var iconSrc;
        var redeemRewardEle;
        if (reward.reward.type === 'free_product') {
          iconSrc = reward.reward.productImage;
        } else if (reward.spendingRule.icon) {
          iconSrc = reward.spendingRule.icon;
        } else {
          iconSrc = 'https://imgs.growave.io/qEMxIUmtCekFAGNHHuaYTghtUYzUdZAg-SD-DK6y_DY/rot:0/q:80/rs:auto:40:40/aHR0cHM6Ly9zc3dmaWxlcy5zMy5hbWF6b25hd3MuY29tL2NsaWVudDEzMzM2My9yZXdhcmRzLzY2ODI2YzZkMThjMmJfNjVkZjI5ZmE5OWI0ZV9kaXNjb3VudDEucG5n';
        }
        // set the custom element to redeem the reward
        if (reward.reward.type === 'free_product') {
          redeemRewardEle = "<a class=\"club-bisgaard_primary-btn button\" hred=\"#\" data-variantid=\"".concat(reward.reward.variantId, "\" data-discountcode=\"").concat(reward.reward.discountCode, "\">Brug bel\xF8nning</a>");
        } else {
          redeemRewardEle = "<a class=\"club-bisgaard_primary-btn button\" ref=\"#\" data-discountcode=\"".concat(reward.reward.discountCode, "\">Brug bel\xF8nning</a>");
        }
        // Create the reward item for the active rewards list
        rewardItem.innerHTML = "\n          <div class=\"rule-icon\">\n            <img src=\"".concat(iconSrc, "\"\n                alt=\"").concat(reward.spendingRule.title, "\"/>\n          </div>\n          <div>\n            <p class=\"rule-title\">").concat(reward.spendingRule.title, "</p>\n          </div>\n          <div>\n            <p class=\"rule-points tw-flex tw-flex-col\">\n            <span>Rabatkode</span>\n              ").concat(reward.reward.discountCode, "\n            </p>\n          </div>\n          <div class=\"tw-mt-auto\">\n            ").concat(redeemRewardEle, "\n          </div>\n\t\t    ");
        activeRewardsList.appendChild(rewardItem);
        rewardItem.querySelector('.club-bisgaard_primary-btn').addEventListener('click', function (event) {
          event.preventDefault();
          _this2.confirmationModal.toggleConfirmationBox();
          _this2.confirmationModal.initActions(function () {
            return _this2.redeemReward(event.target);
          });
        });
      });
      activeRewardsSelector.appendChild(activeRewardsList);
      // fade elements in
      Array.from(activeRewardsList.children).forEach(function (child, index) {
        (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_0__.fadeUp)(child, index, 750, 100);
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "redeemReward",
    value: function redeemReward(target) {
      var discountCode = target.dataset.discountcode;
      var variantId = target.dataset.variantid;
      if (variantId) {
        (0,_utils_CartApiEndpoints__WEBPACK_IMPORTED_MODULE_1__.addVariantToCart)(variantId);
      }
      if (discountCode) {
        (0,_utils_DiscountCode__WEBPACK_IMPORTED_MODULE_2__.fetchDiscountCode)(discountCode);
      }
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerActivityHistory.ts":
/*!************************************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerActivityHistory.ts ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowaveGetCustomerActivityHistory)
/* harmony export */ });
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../utils/Animations */ "./resources/scripts/utils/Animations.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var EditionGrowaveGetCustomerActivityHistory = /*#__PURE__*/function () {
  function EditionGrowaveGetCustomerActivityHistory() {
    _classCallCheck(this, EditionGrowaveGetCustomerActivityHistory);
    _defineProperty(this, "actvititySelector", document.querySelector('#history'));
    _defineProperty(this, "activityHistorySet", false);
    _defineProperty(this, "clubBisgaard", document.querySelector('club-bisgaard'));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector('.club-bisgaard_loader'));
    this.init = this.init.bind(this);
    this.getCustomerActivityHistory = this.getCustomerActivityHistory.bind(this);
    this.displayCustomerActivityHistory = this.displayCustomerActivityHistory.bind(this);
  }
  return _createClass(EditionGrowaveGetCustomerActivityHistory, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get activity history when the history tab is selected.
      // If the activity history has already been set, don't fetch it again.
      var activityHisotryTab = document.querySelector("li.club-bisgaard_tab-club[data-type='history']");
      activityHisotryTab.addEventListener('click', function () {
        if (_this.activityHistorySet === false) {
          _this.loader.style.display = 'block';
          // check if the activity history is already cached
          var cachedActivityHistory = sessionStorage.getItem('cachedActivityHistory');
          if (!cachedActivityHistory) {
            _this.getCustomerActivityHistory(_this.customerId);
          } else {
            var activityHistory = JSON.parse(cachedActivityHistory);
            _this.displayCustomerActivityHistory(activityHistory);
          }
          _this.activityHistorySet = true;
        }
      });
      document.addEventListener('customerUpdated', function (event) {
        setTimeout(function () {
          _this.getCustomerActivityHistory(_this.customerId);
        }, 2500);
      });
    }
  }, {
    key: "getCustomerActivityHistory",
    value: function () {
      var _getCustomerActivityHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var customeridParam, response, data, activties, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              customeridParam = "customerid=".concat(id);
              _context.n = 1;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-customer-activity-history?".concat(customeridParam), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 1:
              response = _context.v;
              if (!response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.json();
            case 2:
              data = _context.v;
              activties = data.activities;
              this.displayCustomerActivityHistory(activties);
              sessionStorage.setItem('cachedActivityHistory', JSON.stringify(activties));
              _context.n = 4;
              break;
            case 3:
              console.error("HTTP-Error ".concat(response.status));
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error(_t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function getCustomerActivityHistory(_x) {
        return _getCustomerActivityHistory.apply(this, arguments);
      }
      return getCustomerActivityHistory;
    }()
  }, {
    key: "displayCustomerActivityHistory",
    value: function displayCustomerActivityHistory(activities) {
      if (activities.length === 0) {
        this.actvititySelector.innerHTML = 'Ingen aktiviteter fundet.';
        this.loader.style.display = 'none';
        return;
      }
      var activityList = document.createElement('ul');
      console.log(activities);
      activities.forEach(function (activity) {
        if (activity.type === 'reward' || activity.type === 'refund' || activity.type === 'redeem' || activity.type === 'manual') {
          var activityItem = document.createElement('li');
          activityItem.classList.add('activity-item');
          var title;
          var points;
          var date;
          if (activity.type === 'reward') {
            title = activity.earningRule.title;
            points = "+ ".concat(activity.reward.points);
          } else if (activity.type === 'refund') {
            title = "".concat(activity.refundedActivity.earningRule.title, " (refunderet)");
            points = "- ".concat(activity.refundedActivity.reward.points);
          } else if (activity.type === 'redeem') {
            title = activity.spendingRule.title;
            points = "- ".concat(activity.spentPoints);
          } else if (activity.type === 'manual') {
            title = 'Manual Activity';
            points = activity.points;
          }
          date = activity.createdAt;
          var dateOptions = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
          };
          date = new Date(date).toLocaleDateString('da-DK', dateOptions);
          activityItem.innerHTML = "\n            <div class=\"activity-title\">\n              ".concat(title, "\n            </div>\n            <div class=\"activity-points\">\n              ").concat(points, " point\n            </div>\n            <div class=\"activity-date\">\n              ").concat(date, "\n            </div>\n          ");
          activityList.appendChild(activityItem);
        }
      });
      this.actvititySelector.appendChild(activityList);
      // fade elements in
      Array.from(activityList.children).forEach(function (child, index) {
        (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_0__.fadeUp)(child, index, 750, 50);
      });
      this.loader.style.display = 'none';
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerWishlists.ts":
/*!******************************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetCustomerWishlists.ts ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowaveGetCustomerWishlists)
/* harmony export */ });
/* harmony import */ var _utils_ProductApiEndpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/ProductApiEndpoints */ "./resources/scripts/utils/ProductApiEndpoints.ts");
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/Animations */ "./resources/scripts/utils/Animations.ts");
/* harmony import */ var _GrowaveWishlistActionsBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./GrowaveWishlistActionsBtn */ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveWishlistActionsBtn.ts");
/* harmony import */ var _GrowaveWishlistCreateBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./GrowaveWishlistCreateBtn */ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveWishlistCreateBtn.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }




var EditionGrowaveGetCustomerWishlists = /*#__PURE__*/function () {
  function EditionGrowaveGetCustomerWishlists() {
    _classCallCheck(this, EditionGrowaveGetCustomerWishlists);
    _defineProperty(this, "clubBisgaard", document.querySelector('club-bisgaard'));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector('.club-bisgaard_loader'));
    _defineProperty(this, "wishlistsSet", false);
    _defineProperty(this, "wishlistSelector", document.querySelector('#club-bisgaard_wishlist-lists'));
    _defineProperty(this, "confirmationModal", document.querySelector('confirmation-modal'));
    this.init = this.init.bind(this);
    this.getWishlists = this.getWishlists.bind(this);
    this.displayWishlists = this.displayWishlists.bind(this);
    this.unfavoriteProduct = this.unfavoriteProduct.bind(this);
    this.shareWishlist = this.shareWishlist.bind(this);
    customElements.define('wishlist-actions-btn', _GrowaveWishlistActionsBtn__WEBPACK_IMPORTED_MODULE_0__["default"]);
    customElements.define('wishlist-create-btn', _GrowaveWishlistCreateBtn__WEBPACK_IMPORTED_MODULE_1__["default"]);
  }
  return _createClass(EditionGrowaveGetCustomerWishlists, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get wishlists when the wishlsit tab is selected.
      // If the wishlists has already been set, don't fetch it again.
      var wishlistsTab = document.querySelector("li.club-bisgaard_li.club-bisgaard_tab[data-type='wishlist']");
      wishlistsTab.addEventListener('click', function () {
        if (_this.wishlistsSet === false) {
          _this.loader.style.display = 'block';
          _this.getWishlists(_this.customerId);
          _this.wishlistsSet = true;
        }
        // Add event listeners to the share buttons
        var shareBtns = Array.from(document.querySelectorAll('.wishlist-share-btn'));
        shareBtns.forEach(function (btn) {
          btn.addEventListener('click', function (event) {
            event.preventDefault();
            var growaveCustomerid = _this.clubBisgaard.dataset.growavecustomerid;
            // eslint-disable-next-line prefer-destructuring
            var media = btn.dataset.media;
            _this.shareWishlist(growaveCustomerid, media);
          });
        });
      });
      // Listen for the wishlist-created event to update the wishlists
      document.addEventListener('wishlist-created', function () {
        _this.loader.style.display = 'block';
        _this.getWishlists(_this.customerId);
      });
    }
  }, {
    key: "getWishlists",
    value: function () {
      var _getWishlists = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var customeridParam, response, data, wishlists, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              customeridParam = "customerid=".concat(id);
              _context.n = 1;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-customer-wishlists?".concat(customeridParam), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 1:
              response = _context.v;
              if (!response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.json();
            case 2:
              data = _context.v;
              // eslint-disable-next-line prefer-destructuring
              wishlists = data.wishlists;
              this.displayWishlists(wishlists);
              _context.n = 4;
              break;
            case 3:
              console.error("HTTP-Error: ".concat(response.status));
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error(_t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function getWishlists(_x) {
        return _getWishlists.apply(this, arguments);
      }
      return getWishlists;
    }()
  }, {
    key: "displayWishlists",
    value: function displayWishlists(wishlists) {
      var _this2 = this;
      if (wishlists.length === 0) {
        this.wishlistSelector.innerHTML = 'Ingen ønskesedler fundet.';
        this.loader.style.display = 'none';
      } else {
        this.wishlistSelector.innerHTML = '';
        wishlists.forEach(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(wishlist) {
            var wistlistItemsHtml, handles, productsInfo, wishlistProductsInfo, wishlistItem, chevronDown, unfavoriteBtns;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  _this2.clubBisgaard.dataset.growavecustomerid = wishlist.customer.shopifyCustomerId.toString();
                  if (!(wishlist.items.length === 0)) {
                    _context4.n = 1;
                    break;
                  }
                  wistlistItemsHtml = '<p>Denne ønskeseddel er tom.</p>';
                  _context4.n = 3;
                  break;
                case 1:
                  // Get the products in the wishlist by fetching the products from the restapi. We use the product ids in the wishlist items to get the products.
                  handles = wishlist.items.map(function (item) {
                    return item.product.handle;
                  });
                  _context4.n = 2;
                  return Promise.all(handles.map(/*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(handle) {
                      var productInfo;
                      return _regenerator().w(function (_context2) {
                        while (1) switch (_context2.n) {
                          case 0:
                            _context2.n = 1;
                            return (0,_utils_ProductApiEndpoints__WEBPACK_IMPORTED_MODULE_2__.getProduct)(handle);
                          case 1:
                            productInfo = _context2.v;
                            return _context2.a(2, productInfo);
                        }
                      }, _callee2);
                    }));
                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }()));
                case 2:
                  productsInfo = _context4.v;
                  // Filter the products in the wishlist items, so we only get the variants of the products that are in the wishlist.
                  // We also add the product image and handle to the variant object.
                  wishlistProductsInfo = productsInfo.map(function (product) {
                    var filteredVariants = product.variants.filter(function (variant) {
                      return wishlist.items.some(function (item) {
                        return item.product.variantId === variant.id;
                      });
                    }).map(function (variant) {
                      return _objectSpread(_objectSpread({}, variant), {}, {
                        productImage: product.image,
                        productHandle: product.handle,
                        productTitle: product.title
                      });
                    });
                    return filteredVariants;
                  }).flat();
                  wistlistItemsHtml = "\n            ".concat(wishlistProductsInfo.map(function (item) {
                    return "\n                <div class=\"wishlist-item-product-wrapper\">\n                  <a href=\"/products/".concat(item.productHandle, "?variant=").concat(item.id, "\" class=\"wishlist-item-product-link\">\n                    <div class=\"wishlist-item-product-img\">\n                      <img src=\"").concat(item.productImage.src, "\" alt=\"").concat(item.title, "\">\n                    </div>\n                    <div class=\"wishlist-item-product-info\">\n                      <p class=\"club-bisgaard_extra-small-heading\">\n                      ").concat(item.productTitle.replace('Bisgaard ', '').replace('bisgaard ', ''), "\n                      </p>\n                      <p class=\"club-bisgaard_extra-small-heading\">\n                        ").concat(item.price, " DKK\n                      </p>\n                    </div>\n                  </a>\n                  <div class=\"wishlist-item-unfavorite\" data-productid=\"").concat(item.product_id, "\">\n                  <svg viewBox=\"0 -1 32 32\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" fill=\"#90786b\" stroke=\"#90786b\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"> <defs> </defs> <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"> <g id=\"Icon-Set-Filled\" sketch:type=\"MSLayerGroup\" transform=\"translate(-102.000000, -882.000000)\" fill=\"#90786b\"> <path d=\"M126,882 C122.667,882 119.982,883.842 117.969,886.235 C116.013,883.76 113.333,882 110,882 C105.306,882 102,886.036 102,890.438 C102,892.799 102.967,894.499 104.026,896.097 L116.459,911.003 C117.854,912.312 118.118,912.312 119.513,911.003 L131.974,896.097 C133.22,894.499 134,892.799 134,890.438 C134,886.036 130.694,882 126,882\" id=\"heart-like\" sketch:type=\"MSShapeGroup\"> </path> </g> </g> </g></svg>\n                  </div>\n                </div>\n              ");
                  }).join(''), "\n          ");
                case 3:
                  wishlistItem = document.createElement('div');
                  wishlistItem.classList.add('club-bisgaard_wishlist-item');
                  wishlistItem.setAttribute('aria-hidden', 'false');
                  wishlistItem.setAttribute('data-wishlistid', wishlist.wishlistId.toString());
                  wishlistItem.setAttribute('data-growavecustomerid', wishlist.customer.shopifyCustomerId.toString());
                  wishlistItem.innerHTML = "\n          <div class=\"club-bisgaard_wishlist-item-header\">\n            <div class=\"club-bisgaard_wishlist-item-header_title\">\n              <svg fill=\"#90786b\" height=\"14px\" width=\"14px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 407.437 407.437\" xml:space=\"preserve\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"> <polygon points=\"386.258,91.567 203.718,273.512 21.179,91.567 0,112.815 203.718,315.87 407.437,112.815 \"></polygon> </g></svg>\n              <h4 class=\"club-bisgaard_extra-small-heading\">".concat(wishlist.wishlistTitle, "</h4>\n              <h4 class=\"wishlist-item-counter club-bisgaard_extra-small-heading\" data-itemscount=\"").concat(wishlist.items.length, "\">").concat(wishlist.items.length, "</h4>\n            </div>\n            <div class=\"club-bisgaard_wishlist-item-header_actions\">\n              <wishlist-actions-btn class=\"club-bisgaard_medium-heading\" href=\"#\">\n              ...\n              </wishlist-actions-btn>\n              <div class=\"club-bisgaard_wishlist-item-header_actions-dropdown\" aria-hidden=\"true\">\n                <a data-wishlistid=\"").concat(wishlist.wishlistId, "\" class=\"rename-wishlist\"href=\"#\">Omd\xF8b</a>\n                <a data-wishlistid=\"").concat(wishlist.wishlistId, "\" class=\"delete-wishlist\"href=\"#\">Slet</a>\n              </div>\n            </div>\n          </div>\n          <div class=\"club-bisgaard_wishlist-item-products-grid\">\n            ").concat(wistlistItemsHtml, "\n          </div>\n        ");
                  // fade in the wishlist item
                  _this2.wishlistSelector.appendChild(wishlistItem);
                  Array.from(wishlistItem.querySelectorAll('.wishlist-item-product-wrapper')).forEach(function (child, index) {
                    (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_3__.fadeIn)(child, index, 750, 50);
                  });
                  // Add event listener to the dropdown chevron
                  chevronDown = wishlistItem.querySelector('svg');
                  chevronDown.addEventListener('click', function () {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    wishlistItem.getAttribute('aria-hidden') === 'false' ? wishlistItem.setAttribute('aria-hidden', 'true') : wishlistItem.setAttribute('aria-hidden', 'false');
                  });
                  // Add event listener to the unfavorite button
                  unfavoriteBtns = Array.from(wishlistItem.querySelectorAll('.wishlist-item-unfavorite'));
                  unfavoriteBtns.forEach(function (btn) {
                    btn.addEventListener('click', /*#__PURE__*/function () {
                      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
                        return _regenerator().w(function (_context3) {
                          while (1) switch (_context3.n) {
                            case 0:
                              event.preventDefault();
                              _this2.confirmationModal.toggleConfirmationBox();
                              _this2.confirmationModal.initActions(function () {
                                return _this2.unfavoriteProduct(btn);
                              });
                            case 1:
                              return _context3.a(2);
                          }
                        }, _callee3);
                      }));
                      return function (_x4) {
                        return _ref3.apply(this, arguments);
                      };
                    }());
                  });
                case 4:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }());
        this.loader.style.display = 'none';
      }
    }
  }, {
    key: "unfavoriteProduct",
    value: function () {
      var _unfavoriteProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(target) {
        var productId, response, wishlistItemProduct, counter, currentCount, newCount, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              productId = target.dataset.productid;
              if (!productId) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return fetch('https://club-bisgaard.vercel.app/apiv1/wishlist-unfavorite-product', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  customerid: this.customerId,
                  productid: Number(productId)
                })
              });
            case 1:
              response = _context5.v;
              // If the response i ok, we remove the product from the wishlist and update the counter
              if (response.ok) {
                wishlistItemProduct = target.closest('.wishlist-item-product-wrapper');
                counter = target.closest('.club-bisgaard_wishlist-item').querySelector('.wishlist-item-counter');
                currentCount = Number(counter.dataset.itemscount);
                newCount = (currentCount - 1).toString();
                counter.dataset.itemscount = newCount;
                counter.textContent = newCount;
                wishlistItemProduct.remove();
              }
            case 2:
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t2 = _context5.v;
              console.error('Error', _t2);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function unfavoriteProduct(_x5) {
        return _unfavoriteProduct.apply(this, arguments);
      }
      return unfavoriteProduct;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "shareWishlist",
    value: function shareWishlist(growaveCustomerid, media) {
      var shareLink;
      var shareSite;
      var shareUrl;
      var shareTitle;
      var shareText;
      if (media === 'facebook') {
        shareSite = 'https://www.facebook.com/sharer/sharer.php';
        shareUrl = "?u=https://bisgaardshoes.dk/pages/wishlist?from_user_id=".concat(growaveCustomerid);
        shareTitle = '&p[title]=Se+min+ønskeseddel';
        shareLink = "".concat(shareSite).concat(shareUrl).concat(shareTitle);
      } else if (media === 'x') {
        shareSite = 'https://www.x.com/share';
        shareText = '?text=Se+min+ønskeseddel';
        shareUrl = "&url=https://bisgaardshoes.dk/pages/wishlist?from_user_id=".concat(growaveCustomerid);
        shareLink = "".concat(shareSite).concat(shareText).concat(shareUrl);
      } else if (media === 'pinterest') {
        shareSite = 'https://pinterest.com/pin/create/button/';
        shareUrl = "?url=https://bisgaardshoes.dk/pages/wishlist?from_user_id=".concat(growaveCustomerid);
        shareText = '&description=Se+min+ønskeseddel';
        shareLink = "".concat(shareSite).concat(shareUrl).concat(shareText);
      } else if (media === 'mail') {
        var mailBody = encodeURIComponent("https://bisgaardshoes.dk/pages/wishlist?from_user_id=".concat(growaveCustomerid));
        var mailtoLink = "mailto:?body=".concat(mailBody);
        shareLink = mailtoLink;
      }
      if (shareLink) {
        window.open(shareLink, '_blank');
      }
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetEarningRules.ts":
/*!*************************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetEarningRules.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowaveGetEarningRules)
/* harmony export */ });
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../utils/Animations */ "./resources/scripts/utils/Animations.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var EditionGrowaveGetEarningRules = /*#__PURE__*/function () {
  function EditionGrowaveGetEarningRules() {
    _classCallCheck(this, EditionGrowaveGetEarningRules);
    _defineProperty(this, "earningRulesSelector", document.querySelector('#points'));
    _defineProperty(this, "earningRulesSet", false);
    _defineProperty(this, "clubBisgaard", document.querySelector('club-bisgaard'));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector('.club-bisgaard_loader'));
    this.init = this.init.bind(this);
    this.getEarningRules = this.getEarningRules.bind(this);
    this.displayEarningRules = this.displayEarningRules.bind(this);
  }
  return _createClass(EditionGrowaveGetEarningRules, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get earning rules when the earning rules tab is selected.
      // If the earning rules have already been set, don't fetch them again.
      var earningRulesTab = document.querySelector("li.club-bisgaard_tab-club[data-type='points']");
      earningRulesTab.addEventListener('click', function () {
        if (_this.earningRulesSet === false) {
          _this.loader.style.display = 'block';
          // check if the earning rules are already cached
          var cachedEarningRules = sessionStorage.getItem('cachedEarningRules');
          if (!cachedEarningRules) {
            _this.getEarningRules(_this.customerId);
          } else {
            var earningRules = JSON.parse(cachedEarningRules);
            _this.displayEarningRules(earningRules);
          }
          _this.earningRulesSet = true;
        }
      });
    }
  }, {
    key: "getEarningRules",
    value: function () {
      var _getEarningRules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var customeridParam, response, data, rules, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              customeridParam = "customerid=".concat(id);
              _context.n = 1;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-earning-rules?".concat(customeridParam), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 1:
              response = _context.v;
              if (!response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.json();
            case 2:
              data = _context.v;
              // eslint-disable-next-line prefer-destructuring
              rules = data.rules;
              this.displayEarningRules(rules);
              sessionStorage.setItem('cachedEarningRules', JSON.stringify(rules));
              _context.n = 4;
              break;
            case 3:
              console.error("HTTP-Error: ".concat(response.status));
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error(_t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function getEarningRules(_x) {
        return _getEarningRules.apply(this, arguments);
      }
      return getEarningRules;
    }()
  }, {
    key: "displayEarningRules",
    value: function displayEarningRules(rules) {
      var _this2 = this;
      if (rules.length === 0) {
        this.earningRulesSelector.innerHTML = 'No earning rules found';
        return;
      }
      var rulesList = document.createElement('ul');
      rulesList.classList.add('earning-rules-grid');
      rules.forEach(function (rule) {
        var ruleItem = document.createElement('li');
        var points;
        var additionalInfo;
        if (rule.rewarding.amountSpent) {
          points = "".concat(rule.rewarding.points, " point for hver ").concat(rule.rewarding.amountSpent, " DKK");
        } else {
          points = "".concat(rule.rewarding.points, " point");
        }
        // Add additional info for birthday gift rule
        if (rule.type === 'birthday_gift') {
          if (_this2.clubBisgaard.dataset.birthday) {
            additionalInfo = "<a class=\"rule-additional-info\" href=\"#\">Din f\xF8dselsdag: ".concat(_this2.clubBisgaard.dataset.birthday, "</a>");
          } else {
            additionalInfo = "<a class=\"rule-additional-info\" href=\"#\" id=\"set-birthday\">Tilf\xF8j din f\xF8dselsdag</a>";
          }
        } else if (rule.type === 'newsletter_subscribe') {
          if (_this2.clubBisgaard.dataset.marketing === 'true') {
            additionalInfo = "<a class=\"rule-additional-info\" href=\"#\">Du er tilmeldt nyhedsbrevet</a>";
          } else {
            additionalInfo = "<a class=\"rule-additional-info\" href=\"#\" id=\"subscribe-newsletter\">Tilmeld dig nyhedsbrevet</a>";
          }
        } else {
          additionalInfo = '';
        }
        ruleItem.innerHTML = "\n          <div class=\"rule-icon\">\n          <img src=\"https://imgs.growave.io/qEMxIUmtCekFAGNHHuaYTghtUYzUdZAg-SD-DK6y_DY/rot:0/q:80/rs:auto:40:40/aHR0cHM6Ly9zc3dmaWxlcy5zMy5hbWF6b25hd3MuY29tL2NsaWVudDEzMzM2My9yZXdhcmRzLzY2ODI2YzZkMThjMmJfNjVkZjI5ZmE5OWI0ZV9kaXNjb3VudDEucG5n\"\n              alt=\"".concat(rule.title, "\"/>\n          </div>\n          <div>\n          <p class=\"rule-title\">").concat(rule.title, "</p>\n          </div>\n          <div>\n          <p class=\"rule-points\">").concat(points, "</p>\n          <p>").concat(additionalInfo, "</p>\n          </div>\n          ");
        rulesList.appendChild(ruleItem);
      });
      this.earningRulesSelector.appendChild(rulesList);
      // Add event listener to subscribe to newsletter
      var subscribeNewsletter = rulesList.querySelector('#subscribe-newsletter');
      subscribeNewsletter === null || subscribeNewsletter === void 0 || subscribeNewsletter.addEventListener('click', function (event) {
        event.preventDefault();
        subscribeNewsletter.innerHTML = 'Du er tilmeldt nyhedsbrevet';
        _this2.updateNewsletterSubscription(_this2.clubBisgaard.dataset.customerid);
      });
      // Add event listener to set birthday
      var setBirthday = rulesList.querySelector('#set-birthday');
      setBirthday === null || setBirthday === void 0 || setBirthday.addEventListener('click', function (event) {
        event.preventDefault();
        var birthday = prompt('Indtast din fødselsdag (dd-mm-yyyy)');
        if (birthday) {
          var day = Number(birthday.split('-')[0]);
          var month = Number(birthday.split('-')[1]);
          var year = Number(birthday.split('-')[2]);
          if (day > 31 || month > 12 || year > new Date().getFullYear()) {
            alert('Indtast en gyldig fødselsdag');
            return;
          }
          _this2.clubBisgaard.setAttribute('data-birthday', birthday);
          setBirthday.innerHTML = "Din f\xF8dselsdag: ".concat(birthday);
          _this2.updateBirthday(day, month, year);
        }
      });
      // fade elements in
      Array.from(rulesList.children).forEach(function (child, index) {
        (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_0__.fadeIn)(child, index, 750, 50);
      });
      this.loader.style.display = 'none';
    }
  }, {
    key: "updateBirthday",
    value: function () {
      var _updateBirthday = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(day, month, year) {
        var body, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              body = {
                customerid: this.customerId,
                day: day,
                month: month,
                year: year
              };
              _context2.n = 1;
              return fetch('https://club-bisgaard.vercel.app/apiv1/customer-update-birthday', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
              });
            case 1:
              response = _context2.v;
              if (response.ok) {
                console.log('Birthday updated');
                document.dispatchEvent(new CustomEvent('customerUpdated'));
              } else {
                console.error("HTTP-Error: ".concat(response.status));
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function updateBirthday(_x2, _x3, _x4) {
        return _updateBirthday.apply(this, arguments);
      }
      return updateBirthday;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "updateNewsletterSubscription",
    value: function () {
      var _updateNewsletterSubscription = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(customerid) {
        var body, response, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              body = {
                customerid: customerid
              };
              _context3.n = 1;
              return fetch('https://club-bisgaard.vercel.app/apiv1/update-customer-marketing', {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
              });
            case 1:
              response = _context3.v;
              if (response.ok) {
                console.log('Newsletter subscription updated');
                document.dispatchEvent(new CustomEvent('customerUpdated'));
              } else {
                console.error("HTTP-Error: ".concat(response.status));
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.error(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      function updateNewsletterSubscription(_x5) {
        return _updateNewsletterSubscription.apply(this, arguments);
      }
      return updateNewsletterSubscription;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetSpendingRules.ts":
/*!**************************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/GrowaveGetSpendingRules.ts ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowaveGetSpendingRules)
/* harmony export */ });
/* harmony import */ var _utils_Animations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../utils/Animations */ "./resources/scripts/utils/Animations.ts");
/* harmony import */ var _utils_ProductApiEndpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../utils/ProductApiEndpoints */ "./resources/scripts/utils/ProductApiEndpoints.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }


var EditionGrowaveGetSpendingRules = /*#__PURE__*/function () {
  function EditionGrowaveGetSpendingRules() {
    _classCallCheck(this, EditionGrowaveGetSpendingRules);
    _defineProperty(this, "spendSelector", document.querySelector('#spend'));
    _defineProperty(this, "spendingRulesSet", false);
    _defineProperty(this, "confirmationModal", document.querySelector('confirmation-modal'));
    _defineProperty(this, "clubBisgaard", document.querySelector('club-bisgaard'));
    _defineProperty(this, "customerId", this.clubBisgaard.dataset.customerid);
    _defineProperty(this, "loader", this.clubBisgaard.querySelector('.club-bisgaard_loader'));
    this.init = this.init.bind(this);
    this.getSpendingRules = this.getSpendingRules.bind(this);
    this.displaySpendingRules = this.displaySpendingRules.bind(this);
  }
  return _createClass(EditionGrowaveGetSpendingRules, [{
    key: "init",
    value: function init() {
      var _this = this;
      var spendingRulesTab = document.querySelector("li.club-bisgaard_tab-club[data-type='spend']");
      spendingRulesTab.addEventListener('click', function () {
        if (_this.spendingRulesSet === false) {
          _this.loader.style.display = 'block';
          // check if the spending rules are already cached
          var cachedSpendingRules = sessionStorage.getItem('cachedSpendingRules');
          _this.getSpendingRules(_this.customerId);
          _this.spendingRulesSet = true;
        }
      });
      document.addEventListener('customerUpdated', function () {
        _this.getSpendingRules(_this.customerId);
      });
    }
  }, {
    key: "getSpendingRules",
    value: function () {
      var _getSpendingRules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var customeridParam, response, data, rules, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              customeridParam = "customerid=".concat(id);
              _context.n = 1;
              return fetch("https://club-bisgaard.vercel.app/apiv1/get-spending-rules?".concat(customeridParam), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 1:
              response = _context.v;
              if (!response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.json();
            case 2:
              data = _context.v;
              console.log(data, 'data');
              // eslint-disable-next-line prefer-destructuring
              rules = data.rules;
              this.displaySpendingRules(rules);
              sessionStorage.setItem('cachedSpendingRules', JSON.stringify(rules));
              _context.n = 4;
              break;
            case 3:
              console.error("HTTP-Error ".concat(response.status));
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error(_t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[0, 5]]);
      }));
      function getSpendingRules(_x) {
        return _getSpendingRules.apply(this, arguments);
      }
      return getSpendingRules;
    }()
  }, {
    key: "displaySpendingRules",
    value: function displaySpendingRules(rules) {
      var _this2 = this;
      var pointsBalancesStorage = localStorage.getItem('customerPoints');
      var pointsBalance = Number(pointsBalancesStorage);
      // create spending rules selector for outputting the different spending rules
      var spendingRulesSelector = this.spendSelector.querySelector('#spending-rules');
      console.log(rules, 'rules');
      if ((rules === null || rules === void 0 ? void 0 : rules.length) === 0 || rules === undefined) {
        spendingRulesSelector.innerHTML = 'No spending rules found';
        this.loader.style.display = 'none';
        return;
      }
      spendingRulesSelector.innerHTML = '';
      var rulesList = document.createElement('ul');
      rulesList.classList.add('spending-rules-grid');
      rules.forEach(function (rule) {
        if (rule.title !== 'Fleksibel rabat') {
          var ruleItem = document.createElement('li');
          var iconSrc;
          var ruleDesc;
          var redeemEle;
          // set iconSrc based on the rule type
          if (rule.type === 'free_product') {
            iconSrc = rule.productImage;
          } else if (rule.icon) {
            iconSrc = rule.icon;
          } else {
            iconSrc = 'https://imgs.growave.io/qEMxIUmtCekFAGNHHuaYTghtUYzUdZAg-SD-DK6y_DY/rot:0/q:80/rs:auto:40:40/aHR0cHM6Ly9zc3dmaWxlcy5zMy5hbWF6b25hd3MuY29tL2NsaWVudDEzMzM2My9yZXdhcmRzLzY2ODI2YzZkMThjMmJfNjVkZjI5ZmE5OWI0ZV9kaXNjb3VudDEucG5n';
          }
          // set ruleDesc and redeemEle based on the rule type
          if (rule.pointsPrice > pointsBalance) {
            ruleDesc = "Optjen ".concat(rule.pointsPrice - pointsBalance, " point mere.");
            redeemEle = "<a href=\"#\" class=\"club-bisgaard_primary-btn button\" disabled>Optjen point</a>";
          } else {
            var productIdAttribute = rule.productId ? "data-productid=\"".concat(rule.productId, "\"") : '';
            var productHandleAttribute = rule.productHandle ? "data-producthandle=\"".concat(rule.productHandle, "\"") : '';
            ruleDesc = "Brug ".concat(rule.pointsPrice, " point og f\xE5 ").concat(rule.title, ".");
            redeemEle = "<a href=\"#\" class=\"club-bisgaard_primary-btn button\" data-rewardid=\"".concat(rule.id, "\" data-points=\"").concat(rule.pointsPrice, "\" ").concat(productIdAttribute, " ").concat(productHandleAttribute, ">Brug point</a>");
          }
          ruleItem.innerHTML = "\n          <div class=\"rule-icon\">\n          <img src=\"".concat(iconSrc, "\"\n              alt=\"").concat(rule.title, "\"/>\n          </div>\n          <div>\n            <p class=\"rule-title\">").concat(rule.title, "</p>\n          </div>\n          <div>\n            <p class=\"rule-points\">\n              ").concat(ruleDesc, "\n            </p>\n          </div>\n          <div class=\"tw-mt-auto\">\n            ").concat(redeemEle, "\n          </div>\n        ");
          rulesList.appendChild(ruleItem);
          ruleItem.querySelector('.club-bisgaard_primary-btn').addEventListener('click', function (event) {
            event.preventDefault();
            _this2.confirmationModal.toggleConfirmationBox();
            _this2.confirmationModal.initActions(function () {
              return _this2.purchaseReward(event.target);
            });
          });
        }
      });
      spendingRulesSelector.appendChild(rulesList);
      // fade elements in
      Array.from(rulesList.children).forEach(function (child, index) {
        (0,_utils_Animations__WEBPACK_IMPORTED_MODULE_0__.fadeUp)(child, index, 750, 50);
      });
      this.loader.style.display = 'none';
    }
  }, {
    key: "purchaseReward",
    value: function () {
      var _purchaseReward = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(target) {
        var points, customerId, rewardId, productId, productHandle, body, product, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              customerId = this.clubBisgaard.dataset.customerid;
              rewardId = target.dataset.rewardid;
              points = target.dataset.points;
              productId = target.dataset.productid;
              productHandle = target.dataset.producthandle;
              body = {};
              if (customerId) {
                body.customerid = customerId;
              }
              if (rewardId) {
                body.ruleid = Number(rewardId);
              }
              if (!productHandle) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return (0,_utils_ProductApiEndpoints__WEBPACK_IMPORTED_MODULE_1__.getProduct)(productHandle);
            case 1:
              product = _context2.v;
              body.selectedVariantId = product.variants[0].id;
            case 2:
              _context2.n = 3;
              return fetch('https://club-bisgaard.vercel.app/apiv1/redeem-reward', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
              });
            case 3:
              response = _context2.v;
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error(_t2);
            case 5:
              _context2.p = 5;
              setTimeout(function () {
                document.dispatchEvent(new CustomEvent('customerUpdated', {
                  detail: {
                    pointsSpent: points
                  }
                }));
              }, 1500);
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 4, 5, 6]]);
      }));
      function purchaseReward(_x2) {
        return _purchaseReward.apply(this, arguments);
      }
      return purchaseReward;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveWishlistActionsBtn.ts":
/*!****************************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/GrowaveWishlistActionsBtn.ts ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowaveWishlistActionsBtn)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var EditionGrowaveWishlistActionsBtn = /*#__PURE__*/function (_HTMLElement) {
  function EditionGrowaveWishlistActionsBtn() {
    var _this;
    _classCallCheck(this, EditionGrowaveWishlistActionsBtn);
    _this = _callSuper(this, EditionGrowaveWishlistActionsBtn);
    _defineProperty(_this, "parent", _this.closest('.club-bisgaard_wishlist-item-header_actions'));
    _defineProperty(_this, "actionsMenu", _this.parent.querySelector('.club-bisgaard_wishlist-item-header_actions-dropdown'));
    _defineProperty(_this, "clubBisgaard", document.querySelector('club-bisgaard'));
    _defineProperty(_this, "customerId", _this.clubBisgaard.dataset.customerid);
    _defineProperty(_this, "confirmationModal", document.querySelector('confirmation-modal'));
    _this.toggleActionsMenu = _this.toggleActionsMenu.bind(_this);
    return _this;
  }
  _inherits(EditionGrowaveWishlistActionsBtn, _HTMLElement);
  return _createClass(EditionGrowaveWishlistActionsBtn, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.toggleActionsMenu();
      });
      var renameWishlistBtn = this.parent.querySelector('.rename-wishlist');
      renameWishlistBtn.addEventListener('click', function (event) {
        event.preventDefault();
        // eslint-disable-next-line prefer-destructuring
        var wishlistid = renameWishlistBtn.dataset.wishlistid;
        _this2.renameWishlist(wishlistid);
      });
      var deleteWishlistBtn = this.parent.querySelector('.delete-wishlist');
      deleteWishlistBtn.addEventListener('click', function (event) {
        event.preventDefault();
        // eslint-disable-next-line prefer-destructuring
        var wishlistid = deleteWishlistBtn.dataset.wishlistid;
        // Open the confirmation modal
        _this2.confirmationModal.toggleConfirmationBox();
        _this2.confirmationModal.initActions(function () {
          return _this2.deleteWishlist(wishlistid, _this2.customerId);
        });
      });
      // Close the actions menu when clicking outside of it
      document.addEventListener('click', function (event) {
        if (_this2.actionsMenu.getAttribute('aria-hidden') === 'false') {
          if (!_this2.contains(event.target)) {
            _this2.actionsMenu.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }
  }, {
    key: "toggleActionsMenu",
    value: function toggleActionsMenu() {
      this.actionsMenu.setAttribute('aria-hidden', this.actionsMenu.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
    }
    // Hit our server to rename the wishlist
  }, {
    key: "renameWishlist",
    value: function () {
      var _renameWishlist = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(wishlistid) {
        var newTitle, response, data, newWishListTitle, wishlistItem, wishlistItemTitle, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              newTitle = prompt('Enter new title');
              if (newTitle) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return fetch("https://club-bisgaard.vercel.app/apiv1/wishlist-rename", {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  wishlistid: wishlistid,
                  newtitle: newTitle
                })
              });
            case 2:
              response = _context.v;
              if (!response.ok) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return response.json();
            case 3:
              data = _context.v;
              newWishListTitle = data.updatedWishlist.wishlistTitle;
              wishlistItem = this.closest('.club-bisgaard_wishlist-item');
              wishlistItemTitle = wishlistItem.querySelector('.club-bisgaard_wishlist-item-header_title .club-bisgaard_extra-small-heading');
              wishlistItemTitle.textContent = newWishListTitle;
              _context.n = 5;
              break;
            case 4:
              console.error("HTTP-Error: ".concat(response.status));
            case 5:
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error(_t);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[0, 6]]);
      }));
      function renameWishlist(_x) {
        return _renameWishlist.apply(this, arguments);
      }
      return renameWishlist;
    }() // Hit our server to delete the wishlist
  }, {
    key: "deleteWishlist",
    value: function () {
      var _deleteWishlist = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(wishlistid, customerId) {
        var response, wishlistItem, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return fetch("https://club-bisgaard.vercel.app/apiv1/wishlist-delete", {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  customerid: customerId,
                  wishlistid: wishlistid
                })
              });
            case 1:
              response = _context2.v;
              if (response.ok) {
                wishlistItem = this.closest('.club-bisgaard_wishlist-item');
                wishlistItem.remove();
              } else {
                console.error("HTTP-Error: ".concat(response.status));
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deleteWishlist(_x2, _x3) {
        return _deleteWishlist.apply(this, arguments);
      }
      return deleteWishlist;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ClubBisgaard/Growave/GrowaveWishlistCreateBtn.ts":
/*!***************************************************************************************!*\
  !*** ./resources/scripts/components/ClubBisgaard/Growave/GrowaveWishlistCreateBtn.ts ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionGrowaveWishlistCreateBtn)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var EditionGrowaveWishlistCreateBtn = /*#__PURE__*/function (_HTMLElement) {
  function EditionGrowaveWishlistCreateBtn() {
    var _this;
    _classCallCheck(this, EditionGrowaveWishlistCreateBtn);
    _this = _callSuper(this, EditionGrowaveWishlistCreateBtn);
    _defineProperty(_this, "clubBisgaard", document.querySelector('club-bisgaard'));
    _this.handleClick = _this.handleClick.bind(_this);
    _this.createWishlist = _this.createWishlist.bind(_this);
    return _this;
  }
  _inherits(EditionGrowaveWishlistCreateBtn, _HTMLElement);
  return _createClass(EditionGrowaveWishlistCreateBtn, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.handleClick();
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var customerId = this.clubBisgaard.dataset.customerid;
      var wishlistTitle = prompt('Enter wishlist title');
      if (!wishlistTitle || wishlistTitle === '') {
        return;
      }
      this.createWishlist(customerId, wishlistTitle);
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "createWishlist",
    value: function () {
      var _createWishlist = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(customerId, wishlistTitle) {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return fetch("https://club-bisgaard.vercel.app/apiv1/wishlist-create", {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  customerid: customerId,
                  wishlisttitle: wishlistTitle
                })
              });
            case 1:
              response = _context.v;
              if (response.ok) {
                document.dispatchEvent(new CustomEvent('wishlist-created'));
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('Error creating wishlist', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function createWishlist(_x, _x2) {
        return _createWishlist.apply(this, arguments);
      }
      return createWishlist;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Collection/ReadMoreCollection.ts":
/*!***********************************************************************!*\
  !*** ./resources/scripts/components/Collection/ReadMoreCollection.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initReadMoreCollection)
/* harmony export */ });
function initReadMoreCollection() {
  function toggleReadMoreLess() {
    var readmore = document.querySelectorAll('.readmore-open');
    var readless = document.querySelectorAll('.readmore-close');
    var readmoreContent = document.querySelectorAll('.readmore-content');
    if (readmore && readless && readmoreContent) {
      readmore.forEach(function (readmoreBtn, index) {
        readmoreBtn.addEventListener('click', function (event) {
          event.preventDefault();
          readmoreContent.forEach(function (content) {
            return content.classList.remove('readmore-content');
          });
          readmore.forEach(function (btn) {
            return btn.classList.add('tw-hidden');
          });
          readmore.forEach(function (btn) {
            return btn.classList.remove('md:tw-flex');
          });
          readless[index].classList.remove('tw-hidden');
          readless[index].classList.add('md:tw-flex');
        });
      });
      readless.forEach(function (readlessBtn, index) {
        readlessBtn.addEventListener('click', function (event) {
          event.preventDefault();
          readmoreContent.forEach(function (content) {
            return content.classList.add('readmore-content');
          });
          readless.forEach(function (btn) {
            return btn.classList.add('tw-hidden');
          });
          readless.forEach(function (btn) {
            return btn.classList.remove('md:tw-flex');
          });
          readmore[index].classList.remove('tw-hidden');
          readmore[index].classList.add('md:tw-flex');
        });
      });
    }
  }
  document.addEventListener('DOMContentLoaded', toggleReadMoreLess);
  window.addEventListener('resize', toggleReadMoreLess);
}

/***/ }),

/***/ "./resources/scripts/components/CookieConsent/RecallConsent.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/CookieConsent/RecallConsent.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initRecallConsent)
/* harmony export */ });
function initRecallConsent() {
  document.addEventListener('DOMContentLoaded', function () {
    var recallConsentElement = document.getElementById('recall-consent');
    if (!recallConsentElement) return;
    recallConsentElement.addEventListener('click', function (event) {
      var _window$Cookiebot;
      event.preventDefault();
      (_window$Cookiebot = window.Cookiebot) === null || _window$Cookiebot === void 0 || _window$Cookiebot.renew();
    });
  });
}

/***/ }),

/***/ "./resources/scripts/components/ExpectedDelivery/expectedDelivery.ts":
/*!***************************************************************************!*\
  !*** ./resources/scripts/components/ExpectedDelivery/expectedDelivery.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ getExpectedDeliveryDates)
/* harmony export */ });
function getExpectedDeliveryDates() {
  var today = new Date();
  var dayOfWeek = today.getDay();
  var extraDaysMondayOne = window.extraDaysMondayOne || 0;
  var extraDaysMondayTwo = window.extraDaysMondayTwo || 0;
  var extraDaysTuesdayOne = window.extraDaysTuesdayOne || 0;
  var extraDaysTuesdayTwo = window.extraDaysTuesdayTwo || 0;
  var extraDaysWednesdayOne = window.extraDaysWednesdayOne || 0;
  var extraDaysWednesdayTwo = window.extraDaysWednesdayTwo || 0;
  var extraDaysThursdayOne = window.extraDaysThursdayOne || 0;
  var extraDaysThursdayTwo = window.extraDaysThursdayTwo || 0;
  var extraDaysFridayOne = window.extraDaysFridayOne || 0;
  var extraDaysFridayTwo = window.extraDaysFridayTwo || 0;
  var extraDaysSaturday = window.extraDaysSaturday || 0;
  var extraDaysSunday = window.extraDaysSunday || 0;
  var deliveryDate;
  switch (dayOfWeek) {
    case 1:
      // Monday
      deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysMondayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysMondayTwo * 24 * 60 * 60 * 1000);
      break;
    case 2:
      // Tuesday
      deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysTuesdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysTuesdayTwo * 24 * 60 * 60 * 1000);
      break;
    case 3:
      // Wednesday
      deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysWednesdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysWednesdayTwo * 24 * 60 * 60 * 1000);
      break;
    case 4:
      // Thursday
      deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysThursdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysThursdayTwo * 24 * 60 * 60 * 1000);
      break;
    case 5:
      // Friday
      deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysFridayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysFridayTwo * 24 * 60 * 60 * 1000);
      break;
    case 6:
      // Saturday
      deliveryDate = new Date(today.getTime() + extraDaysSaturday * 24 * 60 * 60 * 1000);
      break;
    case 0:
      // Sunday
      deliveryDate = new Date(today.getTime() + extraDaysSunday * 24 * 60 * 60 * 1000);
      break;
    default:
      throw new Error('Invalid day of the week');
  }
  /* const lang = (window as any).storeLangSetting || 'da'; */
  var storeLangSetting = window.storeLang || 'da';
  var options = {
    day: 'numeric',
    month: 'long'
  };
  var deliveryStr = deliveryDate.toLocaleDateString(storeLangSetting, options);
  return deliveryStr;
}

/***/ }),

/***/ "./resources/scripts/components/ExpectedDelivery/updateCartDelivery.ts":
/*!*****************************************************************************!*\
  !*** ./resources/scripts/components/ExpectedDelivery/updateCartDelivery.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartDelivery)
/* harmony export */ });
/* harmony import */ var _expectedDelivery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./expectedDelivery */ "./resources/scripts/components/ExpectedDelivery/expectedDelivery.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var CartDelivery = /*#__PURE__*/function (_HTMLElement) {
  function CartDelivery() {
    var _this;
    _classCallCheck(this, CartDelivery);
    _this = _callSuper(this, CartDelivery);
    _defineProperty(_this, "observer", void 0);
    _this.updateCartDeliveryText = _this.updateCartDeliveryText.bind(_this);
    _this.handleEvent = _this.handleEvent.bind(_this);
    _this.handleCartContentLoaded = _this.handleCartContentLoaded.bind(_this);
    _this.init = _this.init.bind(_this);
    return _this;
  }
  // Function to update the delivery text for all elements
  // eslint-disable-next-line class-methods-use-this
  _inherits(CartDelivery, _HTMLElement);
  return _createClass(CartDelivery, [{
    key: "updateCartDeliveryText",
    value: function updateCartDeliveryText() {
      var cartdeliveryTextElements = document.querySelectorAll('.cart-estimated-delivery-text');
      cartdeliveryTextElements.forEach(function (element) {
        element.innerText = "".concat((0,_expectedDelivery__WEBPACK_IMPORTED_MODULE_0__["default"])());
      });
    }
    // Lifecycle method called when the element is added to the DOM
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.observer = new MutationObserver(function () {
        var cartdeliveryTextElements = document.querySelectorAll('.cart-estimated-delivery-text');
        if (cartdeliveryTextElements.length > 0) {
          _this2.updateCartDeliveryText();
          _this2.observer.disconnect();
        }
      });
      this.init();
    }
    // Initialize event listeners and observer
  }, {
    key: "init",
    value: function init() {
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      document.addEventListener('cart:updated', this.handleEvent);
      document.addEventListener('ajaxProduct:added', this.handleEvent);
      document.addEventListener('DOMContentLoaded', this.handleEvent);
      this.handleCartContentLoaded();
    }
    // Handle custom events
  }, {
    key: "handleEvent",
    value: function handleEvent() {
      var cartdeliveryTextElements = document.querySelectorAll('.cart-estimated-delivery-text');
      if (cartdeliveryTextElements.length > 0) {
        this.updateCartDeliveryText();
      } else {
        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
    // Handle the DOMContentLoaded event
  }, {
    key: "handleCartContentLoaded",
    value: function handleCartContentLoaded() {
      var cartdeliveryTextElements = document.querySelectorAll('.cart-estimated-delivery-text');
      if (cartdeliveryTextElements.length > 0) {
        this.updateCartDeliveryText();
      }
    }
    // Lifecycle method called when the element is removed from the DOM
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Clean up listeners and observers when the element is removed
      this.observer.disconnect();
      document.removeEventListener('cart:updated', this.handleEvent);
      document.removeEventListener('ajaxProduct:added', this.handleEvent);
      document.removeEventListener('variant:change', this.handleEvent);
      document.removeEventListener('DOMContentLoaded', this.handleCartContentLoaded);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Filter/Filter.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/Filter/Filter.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _default)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var _default = /*#__PURE__*/function (_HTMLElement) {
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    _this = _callSuper(this, _default);
    _defineProperty(_this, "filterValueDropdowns", void 0);
    _defineProperty(_this, "filterValueToggles", void 0);
    _this.initElements = _this.initElements.bind(_this);
    return _this;
  }
  _inherits(_default, _HTMLElement);
  return _createClass(_default, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initElements();
      this.addEventListeners();
    }
  }, {
    key: "initElements",
    value: function initElements() {
      this.filterValueDropdowns = Array.from(this.querySelectorAll('.filter-values-dropdown'));
      this.filterValueToggles = Array.from(this.querySelectorAll('.filter-values-toggle'));
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      this.filterValueToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.toggleFilterDropdown(toggle);
        });
      });
    }
  }, {
    key: "toggleFilterDropdown",
    value: function toggleFilterDropdown(toggle) {
      var dropdown = toggle.nextElementSibling;
      this.filterValueDropdowns.forEach(function (_dropdown) {
        if (_dropdown === dropdown) return;
        _dropdown.classList.add('tw-hidden');
        _dropdown.classList.remove('tw-flex');
      });
      if (dropdown) {
        dropdown.classList.toggle('tw-hidden');
        dropdown.classList.toggle('tw-flex');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var GEOLOCATION_COOKIE = 'geolocation';
// Cookies don't cross domains, and each store is its own domain (bisgaardshoes.de vs .fr vs .com…).
// When a redirect crosses stores, this param carries the "already chosen" signal along in the URL
// so the destination store can set its own cookie instead of re-prompting on arrival.
var GEOLOCATION_PARAM = 'geo';
var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "countryData", void 0);
    _defineProperty(_this, "euCountryCodes", ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'EE', 'FI', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE']);
    _this.countryData = window.countryData;
    // bind methods
    _this.connectedCallback = _this.connectedCallback.bind(_this);
    _this.initGeolocator = _this.initGeolocator.bind(_this);
    _this.getSelectedCountry = _this.getSelectedCountry.bind(_this);
    _this.getVisitorCountry = _this.getVisitorCountry.bind(_this);
    _this.showGeoPopup = _this.showGeoPopup.bind(_this);
    _this.confirmCountry = _this.confirmCountry.bind(_this);
    _this.handleStay = _this.handleStay.bind(_this);
    _this.handleRedirect = _this.handleRedirect.bind(_this);
    _this.handleShowAgain = _this.handleShowAgain.bind(_this);
    _this.resetGeolocator = _this.resetGeolocator.bind(_this);
    _this.consumeRedirectParam = _this.consumeRedirectParam.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var heading = this.querySelector('#geolocator-heading');
      var closeBtn = this.querySelector('#geolocator-close-btn');
      if (!heading) return;
      // The list itself is how you pick a destination — this button is just a close action.
      closeBtn.addEventListener('click', this.handleStay);
      // Always bind "show geolocator again" buttons
      var showAgainButtons = document.querySelectorAll('.show-geolocator-again');
      showAgainButtons.forEach(function (btn) {
        btn.removeEventListener('click', _this2.handleShowAgain);
        btn.addEventListener('click', _this2.handleShowAgain);
      });
      // Delay initialization until 1 seconds after DOMContentLoaded
      var runInit = function runInit() {
        return setTimeout(function () {
          return _this2.initGeolocator();
        }, 1000);
      };
      if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', runInit, {
          once: true
        });
      } else {
        runInit();
      }
    }
  }, {
    key: "initGeolocator",
    value: function () {
      var _initGeolocator = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var hasChosen, selectedCountry, visitorCountry, matchHandle, hasVisitor, visitor, primary;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.consumeRedirectParam();
              hasChosen = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)(GEOLOCATION_COOKIE);
              selectedCountry = this.getSelectedCountry(); // Update button text if a country is already selected
              if (selectedCountry) {
                document.querySelectorAll('.show-geolocator-again').forEach(function (button) {
                  button.innerHTML = "\n          ".concat(selectedCountry.flag ? "<img src=\"".concat(selectedCountry.flag, "\" width=\"100\" height=\"auto\" alt=\"").concat(selectedCountry.countryCode, "\" style=\"width: 20px; vertical-align: middle; margin-right: 4px;\" />") : selectedCountry.country, "\n        ");
                });
              }
              // If user has already chosen or in designMode, only bind reset logic
              if (!(hasChosen || Shopify.designMode === true)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.getVisitorCountry();
            case 2:
              visitorCountry = _context.v;
              matchHandle = visitorCountry.handle;
              hasVisitor = this.countryData.some(function (c) {
                return c.countryCode === matchHandle;
              });
              if (!hasVisitor && this.euCountryCodes.includes(visitorCountry.handle)) {
                matchHandle = 'EU';
                hasVisitor = this.countryData.some(function (c) {
                  return c.countryCode === matchHandle;
                });
              }
              if (hasVisitor) {
                visitor = this.countryData.find(function (c) {
                  return c.countryCode === matchHandle;
                });
                if (!selectedCountry || selectedCountry.countryCode !== visitor.countryCode) {
                  this.showGeoPopup(visitor);
                }
              } else {
                // fallback to primary
                primary = this.countryData.find(function (c) {
                  return c.primaryCountry === true;
                });
                if (primary && (!selectedCountry || selectedCountry.countryCode !== primary.countryCode)) {
                  this.showGeoPopup(primary);
                }
              }
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initGeolocator() {
        return _initGeolocator.apply(this, arguments);
      }
      return initGeolocator;
    }()
  }, {
    key: "getSelectedCountry",
    value: function getSelectedCountry() {
      return this.countryData.find(function (country) {
        return country.locale === Shopify.locale;
      });
    }
  }, {
    key: "getVisitorCountry",
    value: function () {
      var _getVisitorCountry = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, visitor;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch('/browsing_context_suggestions.json');
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              visitor = data.detected_values.country;
              this.setAttribute('data-visitor-country', visitor.handle);
              return _context2.a(2, visitor);
          }
        }, _callee2, this);
      }));
      function getVisitorCountry() {
        return _getVisitorCountry.apply(this, arguments);
      }
      return getVisitorCountry;
    }()
  }, {
    key: "buildDestinationList",
    value: function buildDestinationList(detected) {
      var _this3 = this;
      var list = this.querySelector('#geolocator-list');
      list.innerHTML = '';
      // Customizer block order, except the detected/most relevant destination floats to the top.
      var ordered = detected ? [detected].concat(_toConsumableArray(this.countryData.filter(function (c) {
        return c.countryCode !== detected.countryCode;
      }))) : this.countryData;
      ordered.forEach(function (country) {
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'geolocator-list-row';
        var flag = document.createElement('img');
        flag.className = 'geolocator-list-row__flag';
        flag.alt = '';
        if (country.flag) {
          flag.src = country.flag;
          flag.onerror = function () {
            flag.hidden = true;
          };
        } else {
          flag.hidden = true;
        }
        var name = document.createElement('span');
        name.className = 'geolocator-list-row__name';
        name.textContent = country.country;
        var currency = document.createElement('span');
        currency.className = 'geolocator-list-row__currency';
        currency.textContent = country.currency;
        row.append(flag, name, currency);
        row.addEventListener('click', function () {
          return _this3.confirmCountry(country);
        });
        list.appendChild(row);
      });
    }
  }, {
    key: "showGeoPopup",
    value: function showGeoPopup(countryObject) {
      // Store last shown country code
      this.setAttribute('data-last-country', countryObject.countryCode);
      this.classList.add('is-visible');
      var strings = window.geolocatorStrings;
      var heading = this.querySelector('#geolocator-heading');
      var subtext = this.querySelector('#geolocator-subtext');
      heading.textContent = strings.heading;
      subtext.textContent = strings.subtext;
      this.buildDestinationList(countryObject);
    }
  }, {
    key: "confirmCountry",
    value: function confirmCountry(country) {
      var targetHost = country.link.replace(/^https?:\/\//, '').split('/')[0];
      if (targetHost === window.location.host) {
        this.handleStay();
      } else {
        this.handleRedirect(country.link);
      }
    }
  }, {
    key: "handleStay",
    value: function handleStay() {
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)(GEOLOCATION_COOKIE, 'true', 10);
      this.hidePopup();
    }
  }, {
    key: "handleRedirect",
    value: function handleRedirect(redirectUrl) {
      // Cookie covers this domain (e.g. if they come back here later); the URL param
      // carries the same signal across to the destination domain, which can't read it.
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)(GEOLOCATION_COOKIE, 'true', 10);
      this.hidePopup();
      var target = this.buildRedirectTarget(redirectUrl);
      // eslint-disable-next-line no-return-assign
      setTimeout(function () {
        return window.location.href = target.toString();
      }, 300);
    }
    // new URL(), not string concat — redirectUrl (the block's store link) may already
    // carry its own query string, path, or #fragment, and searchParams.set() merges
    // into that correctly either way.
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "buildRedirectTarget",
    value: function buildRedirectTarget(redirectUrl) {
      var current = new URL(window.location.href);
      var target = new URL(redirectUrl, window.location.href);
      // On a product page, follow the visitor to the same product on the destination
      // store instead of dropping them on its homepage (handles match across stores).
      if (/^\/products\//.test(current.pathname)) {
        target.pathname = current.pathname;
      }
      // Carry over whatever else was on the URL (UTM params, discount codes, etc.).
      current.searchParams.forEach(function (value, key) {
        target.searchParams.set(key, value);
      });
      target.searchParams.set(GEOLOCATION_PARAM, 'true');
      return target;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "consumeRedirectParam",
    value: function consumeRedirectParam() {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(GEOLOCATION_PARAM)) return;
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)(GEOLOCATION_COOKIE, 'true', 10);
      url.searchParams["delete"](GEOLOCATION_PARAM);
      window.history.replaceState({}, '', url.toString());
    }
  }, {
    key: "handleShowAgain",
    value: function handleShowAgain(event) {
      event.preventDefault();
      // Show the last country popup again
      var lastCode = this.getAttribute('data-last-country');
      var country = this.countryData.find(function (c) {
        return c.countryCode === lastCode;
      }) || this.countryData.find(function (c) {
        return c.primaryCountry === true;
      });
      if (country) this.showGeoPopup(country);
    }
  }, {
    key: "resetGeolocator",
    value: function resetGeolocator(event) {
      event.preventDefault();
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.deleteCookie)(GEOLOCATION_COOKIE);
      this.initGeolocator();
    }
  }, {
    key: "hidePopup",
    value: function hidePopup() {
      this.classList.remove('is-visible');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/GlobalSizeGuide/GlobalSizeGuide.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/GlobalSizeGuide/GlobalSizeGuide.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GlobalSizeGuide)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var GlobalSizeGuide = /*#__PURE__*/function (_HTMLElement) {
  function GlobalSizeGuide() {
    var _this;
    _classCallCheck(this, GlobalSizeGuide);
    _this = _callSuper(this, GlobalSizeGuide);
    _defineProperty(_this, "modal", null);
    _defineProperty(_this, "viewSizeChartBtn", null);
    _defineProperty(_this, "viewSizeChartLink", null);
    _defineProperty(_this, "sizingInfoContainer", null);
    _defineProperty(_this, "productUrl", null);
    _defineProperty(_this, "sizeguideCloseBtn", null);
    _defineProperty(_this, "sizeguideTabHeaders", []);
    _defineProperty(_this, "sizeguideTabs", []);
    _defineProperty(_this, "recommendedSizeElement", null);
    _defineProperty(_this, "fitPositionElement", null);
    _defineProperty(_this, "sizeguideVariantBtns", []);
    _defineProperty(_this, "sizeguideVariantBtnHolder", null);
    _defineProperty(_this, "prevNextBtns", []);
    _defineProperty(_this, "dataHolder", void 0);
    _defineProperty(_this, "sizeInfo", []);
    _defineProperty(_this, "debounceTimer", null);
    _defineProperty(_this, "fitElementContainer", null);
    _defineProperty(_this, "noMatchTextElement", null);
    _defineProperty(_this, "closeAndSelectVariantElement", null);
    _defineProperty(_this, "klaviyoBisButton", null);
    _defineProperty(_this, "sizeInput", null);
    _defineProperty(_this, "sizeInputForTable", null);
    _defineProperty(_this, "sizeInfoTextElement", null);
    _defineProperty(_this, "growthAllowanceTextElement", null);
    // Localized template captured from DOM (e.g., "{{ 'sizeguide.size_info' | t }}")
    _defineProperty(_this, "growthAllowanceTemplate", '');
    _defineProperty(_this, "selectedSize", '');
    _defineProperty(_this, "url", '');
    _this.initDataAndElements = _this.initDataAndElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    return _this;
  }
  _inherits(GlobalSizeGuide, _HTMLElement);
  return _createClass(GlobalSizeGuide, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$sizeguideVarian;
      this.initDataAndElements();
      this.addEventListeners();
      var activeButton = this.sizeguideVariantBtns.find(function (b) {
        return b.classList.contains('active-btn');
      });
      var initialSize = (activeButton === null || activeButton === void 0 ? void 0 : activeButton.dataset.size) || ((_this$sizeguideVarian = this.sizeguideVariantBtns[0]) === null || _this$sizeguideVarian === void 0 ? void 0 : _this$sizeguideVarian.getAttribute('data-size')) || '';
      if (initialSize) {
        this.selectedSize = initialSize;
        this.updateCloseAndSelectVisibility(initialSize);
        this.updateKlaviyoBisVisibility(initialSize);
      }
      // Restore previously typed foot length (if any)
      this.restorePersistedFootLength();
    }
  }, {
    key: "initDataAndElements",
    value: function initDataAndElements() {
      var _this$dataHolder;
      this.modal = this.querySelector('.sizeguide-modal');
      this.viewSizeChartBtn = document.querySelector('#view-sizechart');
      this.viewSizeChartLink = document.querySelector('#view-sizechart-link');
      this.sizingInfoContainer = document.querySelector('#sizing-info');
      this.productUrl = this.getAttribute('data-producturl');
      this.sizeguideCloseBtn = this.querySelector('.sizeguide-close-btn');
      this.sizeguideTabHeaders = Array.from(this.querySelectorAll('.sizeguide-tab-header'));
      this.sizeguideTabs = Array.from(this.querySelectorAll('.sizeguide-tab-content'));
      this.sizeInput = this.querySelector('#sizeguide-input');
      this.sizeInputForTable = this.querySelector('#sizeguide-input-table');
      this.recommendedSizeElement = this.querySelector('#recommended-size');
      this.fitPositionElement = this.querySelector('#fit-position');
      this.sizeguideVariantBtns = Array.from(this.querySelectorAll('.sizeguide-variant-btn'));
      this.sizeguideVariantBtnHolder = this.querySelector('#sizeguide-variant-btn-holder');
      this.prevNextBtns = Array.from(this.querySelectorAll('.prev-next-btn'));
      this.fitElementContainer = this.querySelector('.fit_element_container');
      this.noMatchTextElement = this.querySelector('#no-match-text');
      this.closeAndSelectVariantElement = this.querySelector('#close-and-select-variant');
      this.klaviyoBisButton = this.querySelector('#klaviyo-bis-button');
      this.dataHolder = this.querySelector('.data-holder');
      var sizeInfoJson = this.dataHolder.getAttribute('data-sizeinfo');
      this.sizeInfo = sizeInfoJson ? JSON.parse(sizeInfoJson) : [];
      this.url = ((_this$dataHolder = this.dataHolder) === null || _this$dataHolder === void 0 ? void 0 : _this$dataHolder.dataset.url) || '';
      this.sizeInfoTextElement = document.querySelector('#size-info-text');
      this.growthAllowanceTextElement = document.querySelector('#growth-allowance-text');
      if (this.growthAllowanceTextElement && !this.growthAllowanceTemplate) {
        this.growthAllowanceTemplate = (this.growthAllowanceTextElement.textContent || '').trim();
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$viewSizeChartBt,
        _this2 = this,
        _this$viewSizeChartLi,
        _this$sizeguideCloseB,
        _this$closeAndSelectV;
      (_this$viewSizeChartBt = this.viewSizeChartBtn) === null || _this$viewSizeChartBt === void 0 || _this$viewSizeChartBt.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.toggleSizeguide();
      });
      (_this$viewSizeChartLi = this.viewSizeChartLink) === null || _this$viewSizeChartLi === void 0 || _this$viewSizeChartLi.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.toggleSizeguide();
      });
      (_this$sizeguideCloseB = this.sizeguideCloseBtn) === null || _this$sizeguideCloseB === void 0 || _this$sizeguideCloseB.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.toggleSizeguide();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && _this2.modal && !_this2.modal.classList.contains('tw-hidden')) {
          _this2.toggleSizeguide();
        }
      });
      document.addEventListener('variant:change', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          var detail, variant;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                detail = event.detail;
                variant = detail.variant;
                _this2.selectedSize = ((variant === null || variant === void 0 ? void 0 : variant.option1) || '').toString();
                _context.n = 1;
                return _this2.reninitSizingInfo(variant.id);
              case 1:
                _this2.sizeInfoTextElement = document.querySelector('#size-info-text');
                _this2.growthAllowanceTextElement = document.querySelector('#growth-allowance-text');
                if (_this2.growthAllowanceTextElement) {
                  _this2.growthAllowanceTemplate = (_this2.growthAllowanceTextElement.textContent || '').trim();
                }
                if (_this2.sizeInputForTable && _this2.sizeInputForTable.value) {
                  _this2.updateGrowthAllowanceText(Number(_this2.sizeInputForTable.value));
                }
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.sizeguideTabHeaders.forEach(function (header) {
        header.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.toggleSizeguideTab(header);
        });
      });
      (_this$closeAndSelectV = this.closeAndSelectVariantElement) === null || _this$closeAndSelectV === void 0 || _this$closeAndSelectV.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.handleCloseAndSelectVariant();
      });
      document.addEventListener('variant:change', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
          var detail, variant, selectedSize;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                detail = event.detail;
                variant = detail.variant;
                selectedSize = variant.option1;
                _this2.selectedSize = (selectedSize || '').toString();
                if (_this2.sizeInputForTable && _this2.sizeInputForTable.value) {
                  _this2.updateGrowthAllowanceText(Number(_this2.sizeInputForTable.value));
                }
                return _context2.a(2, _this2.selectedSize);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
      if (this.sizeInput) {
        this.sizeInput.addEventListener('input', function (event) {
          var target = event.target;
          var raw = target.value;
          _this2.handleDebouncedSizeInput(raw);
          var numeric = _this2.parseFootLength(raw);
          if (!raw.length || !Number.isFinite(numeric) || numeric <= 0) {
            _this2.resetGrowthAllowanceUi();
          } else {
            _this2.updateGrowthAllowanceText(numeric);
          }
          _this2.persistFootLength(raw);
        });
      }
      if (this.sizeInputForTable) {
        this.sizeInputForTable.addEventListener('input', function (event) {
          var target = event.target;
          var growthValues = document.querySelectorAll('.growth_value');
          var innerMeasureValues = document.querySelectorAll('.inner_measure');
          growthValues.forEach(function (growthEl, index) {
            var innerMeasureValue = innerMeasureValues[index];
            if (!innerMeasureValue) return;
            var inner = parseFloat((innerMeasureValue.textContent || '').replace(/[^\d.]/g, '')) || 0;
            var input = parseFloat(target.value) || 0;
            growthEl.innerHTML = "".concat(inner - input, "mm");
          });
          if (target.value.length === 0) {
            growthValues.forEach(function (growthEl) {
              var growthValue = growthEl.getAttribute('data-growth-value') || '';
              growthEl.innerHTML = growthValue;
            });
            _this2.resetGrowthAllowanceUi();
          }
          _this2.handleDebouncedSizeInput(target.value);
          var numeric = _this2.parseFootLength(target.value);
          if (!Number.isFinite(numeric) || numeric <= 0) {
            _this2.resetGrowthAllowanceUi();
          } else {
            _this2.updateGrowthAllowanceText(numeric);
          }
          _this2.persistFootLength(target.value);
        });
      }
      if (this.sizeInputForTable) {
        this.sizeInputForTable.addEventListener('input', function () {});
      }
      this.sizeguideVariantBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          var _target$dataset;
          event.preventDefault();
          var target = event.currentTarget;
          var size = (target === null || target === void 0 || (_target$dataset = target.dataset) === null || _target$dataset === void 0 ? void 0 : _target$dataset.size) || '';
          if (!size) return;
          _this2.handleSizeSelection(size, btn, false);
          _this2.selectVariantBySize(size);
          _this2.updateCloseAndSelectVisibility(size);
          _this2.updateKlaviyoBisVisibility(size);
          _this2.selectedSize = size;
          if (_this2.sizeInputForTable && _this2.sizeInputForTable.value) {
            _this2.updateGrowthAllowanceText(Number(_this2.sizeInputForTable.value));
          }
        });
      });
      this.prevNextBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var direction = btn.dataset.direction;
          _this2.handlePrevNext(direction || 'next');
        });
      });
      // Keep visibility in sync if variant is changed outside the sizeguide UI
      document.addEventListener('change', function (e) {
        var _target$matches;
        var target = e.target;
        if (target && (_target$matches = target.matches) !== null && _target$matches !== void 0 && _target$matches.call(target, '.product_size_variants input[type="radio"]')) {
          var input = target;
          var size = (input.getAttribute('data-option-value') || input.value || '').trim();
          if (size) {
            _this2.selectedSize = size;
            _this2.updateCloseAndSelectVisibility(size);
            _this2.updateKlaviyoBisVisibility(size);
            if (_this2.sizeInputForTable && _this2.sizeInputForTable.value) {
              _this2.updateGrowthAllowanceText(Number(_this2.sizeInputForTable.value));
            }
          }
        }
      });
    }
  }, {
    key: "handleCloseAndSelectVariant",
    value: function handleCloseAndSelectVariant() {
      var _this$sizeguideVarian2;
      var activeButton = (_this$sizeguideVarian2 = this.sizeguideVariantBtnHolder) === null || _this$sizeguideVarian2 === void 0 ? void 0 : _this$sizeguideVarian2.querySelector('.active-btn');
      var activeSize = (activeButton === null || activeButton === void 0 ? void 0 : activeButton.dataset.size) || '';
      if (activeSize) {
        this.selectVariantBySize(activeSize);
        this.toggleSizeguide();
      }
    }
  }, {
    key: "selectVariantBySize",
    value: function selectVariantBySize(size) {
      var input = this.getVariantInputForSize(size);
      if (!input) {
        this.updateCloseAndSelectVisibility(size);
        this.updateKlaviyoBisVisibility(size);
        return false;
      }
      if (this.isVariantUnavailable(input)) {
        this.updateCloseAndSelectVisibility(size);
        this.updateKlaviyoBisVisibility(size);
        return false;
      }
      if (!input.checked) input.checked = true;
      input.dispatchEvent(new Event('input', {
        bubbles: true
      }));
      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      if (typeof input.click === 'function') input.click();
      this.updateCloseAndSelectVisibility(size);
      this.updateKlaviyoBisVisibility(size);
      return true;
    }
  }, {
    key: "toggleSizeguideTab",
    value: function toggleSizeguideTab(header) {
      var id = header.dataset.id;
      this.sizeguideTabHeaders.forEach(function (tabHeader) {
        return tabHeader.classList.remove('active-tab');
      });
      this.sizeguideTabs.forEach(function (tab) {
        return tab.classList.remove('active-tab-content');
      });
      header.classList.add('active-tab');
      var tabContent = this.sizeguideTabs.find(function (tab) {
        return tab.dataset.id === id;
      });
      if (tabContent) tabContent.classList.add('active-tab-content');
    }
  }, {
    key: "reninitSizingInfo",
    value: function () {
      var _reninitSizingInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(variantId) {
        var _this3 = this;
        var response, text, parser, doc, newSizingInfo, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              if (!(!this.productUrl || !this.sizingInfoContainer)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return fetch("".concat(this.productUrl, "?variant=").concat(variantId));
            case 2:
              response = _context3.v;
              _context3.n = 3;
              return response.text();
            case 3:
              text = _context3.v;
              parser = new DOMParser();
              doc = parser.parseFromString(text, 'text/html');
              newSizingInfo = doc.querySelector('#sizing-info');
              if (newSizingInfo) {
                this.sizingInfoContainer.innerHTML = newSizingInfo.innerHTML;
                // Re-bind elements that live inside #sizing-info after DOM replacement
                this.viewSizeChartLink = document.querySelector('#view-sizechart-link');
                if (this.viewSizeChartLink) {
                  this.viewSizeChartLink.addEventListener('click', function (event) {
                    event.preventDefault();
                    _this3.toggleSizeguide();
                  });
                }
                // Refresh references and localized template
                this.sizeInfoTextElement = document.querySelector('#size-info-text');
                this.growthAllowanceTextElement = document.querySelector('#growth-allowance-text');
                if (this.growthAllowanceTextElement) {
                  this.growthAllowanceTemplate = (this.growthAllowanceTextElement.textContent || '').trim();
                }
              }
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t = _context3.v;
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 4]]);
      }));
      function reninitSizingInfo(_x3) {
        return _reninitSizingInfo.apply(this, arguments);
      }
      return reninitSizingInfo;
    }()
  }, {
    key: "toggleSizeguide",
    value: function toggleSizeguide() {
      var _this$modal, _this$modal2;
      var modalContent = (_this$modal = this.modal) === null || _this$modal === void 0 ? void 0 : _this$modal.querySelector('.sizeguide-modal-content');
      (_this$modal2 = this.modal) === null || _this$modal2 === void 0 || _this$modal2.classList.toggle('tw-hidden');
      setTimeout(function () {
        modalContent === null || modalContent === void 0 || modalContent.classList.toggle('active');
      }, 100);
      document.body.style.overflow = this.modal && !this.modal.classList.contains('tw-hidden') ? 'hidden' : '';
    }
  }, {
    key: "handleDebouncedSizeInput",
    value: function handleDebouncedSizeInput(value) {
      var _this4 = this;
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(function () {
        return _this4.handleSizeInput(value);
      }, 300);
    }
  }, {
    key: "handleSizeInput",
    value: function handleSizeInput(value) {
      var numericValue = Number(value);
      var recommendedSize = this.getRecommendedSize(numericValue);
      if (recommendedSize) {
        var _this$fitElementConta, _this$noMatchTextElem;
        if (this.recommendedSizeElement) {
          this.recommendedSizeElement.textContent = recommendedSize;
        }
        var recommendedButton = this.sizeguideVariantBtns.find(function (btn) {
          return btn.dataset.size === recommendedSize;
        });
        if (recommendedButton) {
          this.handleSizeSelection(recommendedSize, recommendedButton, true);
          this.selectVariantBySize(recommendedSize);
          this.updateCloseAndSelectVisibility(recommendedSize);
          this.updateKlaviyoBisVisibility(recommendedSize);
        }
        (_this$fitElementConta = this.fitElementContainer) === null || _this$fitElementConta === void 0 || _this$fitElementConta.classList.remove('tw-hidden');
        (_this$noMatchTextElem = this.noMatchTextElement) === null || _this$noMatchTextElem === void 0 || _this$noMatchTextElem.classList.add('tw-hidden');
      } else {
        var _this$fitElementConta2, _this$noMatchTextElem2;
        (_this$fitElementConta2 = this.fitElementContainer) === null || _this$fitElementConta2 === void 0 || _this$fitElementConta2.classList.add('tw-hidden');
        (_this$noMatchTextElem2 = this.noMatchTextElement) === null || _this$noMatchTextElem2 === void 0 || _this$noMatchTextElem2.classList.remove('tw-hidden');
        if (this.noMatchTextElement) {
          var _this$getMinMaxFromRa = this.getMinMaxFromRange(),
            lowest = _this$getMinMaxFromRa.lowest,
            highest = _this$getMinMaxFromRa.highest;
          this.noMatchTextElement.innerHTML = this.noMatchTextElement.innerHTML.replace('(min)', lowest.toString()).replace('(max)', highest.toString());
        }
        if (this.recommendedSizeElement) {
          this.recommendedSizeElement.textContent = '';
        }
      }
    }
  }, {
    key: "setFitPositionElement",
    value: function setFitPositionElement(value, sizeInfo) {
      if (!this.fitPositionElement) return;
      var footMeasureMin = Number(sizeInfo.foot_measure_min);
      var footMeasureMax = Number(sizeInfo.foot_measure_max);
      var fitPosition = (footMeasureMax - value) / (footMeasureMax - footMeasureMin) * 100;
      fitPosition = Math.max(0, Math.min(100, fitPosition));
      this.fitPositionElement.style.left = "".concat(fitPosition, "%");
    }
  }, {
    key: "getRecommendedSize",
    value: function getRecommendedSize(value) {
      var recommendedSize = this.sizeInfo.find(function (info) {
        var footMeasureMin = Number(info.foot_measure_min);
        var footMeasureMax = Number(info.foot_measure_max);
        return value >= footMeasureMin && value <= footMeasureMax;
      });
      return recommendedSize ? recommendedSize.size : '';
    }
  }, {
    key: "handleSizeSelection",
    value: function handleSizeSelection(size, button, scroll) {
      var _this$sizeInput;
      var sizeInfo = this.sizeInfo.find(function (info) {
        return info.size === size;
      });
      if (!sizeInfo) return;
      this.sizeguideVariantBtns.forEach(function (btn) {
        return btn.classList.remove('active-btn');
      });
      button.classList.add('active-btn');
      var currentValue = (_this$sizeInput = this.sizeInput) === null || _this$sizeInput === void 0 ? void 0 : _this$sizeInput.value;
      if (currentValue) {
        this.setFitPositionElement(Number(currentValue), sizeInfo);
      }
      if (scroll && this.sizeguideVariantBtnHolder) {
        var buttonPosition = button.getBoundingClientRect().left;
        var holderPosition = this.sizeguideVariantBtnHolder.getBoundingClientRect().left;
        var scrollPosition = buttonPosition - holderPosition;
        this.sizeguideVariantBtnHolder.scrollBy({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
      this.updateCloseAndSelectVisibility(size);
      this.updateKlaviyoBisVisibility(size);
      this.selectedSize = size;
      if (this.sizeInputForTable && this.sizeInputForTable.value) {
        this.updateGrowthAllowanceText(Number(this.sizeInputForTable.value));
      }
    }
  }, {
    key: "getMinMaxFromRange",
    value: function getMinMaxFromRange() {
      var lowest = Math.min.apply(Math, _toConsumableArray(this.sizeInfo.map(function (info) {
        return Number(info.foot_measure_min);
      })));
      var highest = Math.max.apply(Math, _toConsumableArray(this.sizeInfo.map(function (info) {
        return Number(info.foot_measure_max);
      })));
      return {
        lowest: lowest,
        highest: highest
      };
    }
  }, {
    key: "getSizeRange",
    value: function getSizeRange(value) {
      var _this$fitElementConta4;
      var _this$getMinMaxFromRa2 = this.getMinMaxFromRange(),
        lowest = _this$getMinMaxFromRa2.lowest,
        highest = _this$getMinMaxFromRa2.highest;
      if (value >= lowest && value <= highest) {
        var matchingSize = this.sizeInfo.find(function (info) {
          var footMeasureMin = Number(info.foot_measure_min);
          var footMeasureMax = Number(info.foot_measure_max);
          return value >= footMeasureMin && value <= footMeasureMax;
        });
        if (matchingSize) {
          var _this$fitElementConta3, _this$noMatchTextElem3;
          (_this$fitElementConta3 = this.fitElementContainer) === null || _this$fitElementConta3 === void 0 || _this$fitElementConta3.classList.remove('tw-hidden');
          (_this$noMatchTextElem3 = this.noMatchTextElement) === null || _this$noMatchTextElem3 === void 0 || _this$noMatchTextElem3.classList.add('tw-hidden');
          return {
            sizeInfo: matchingSize,
            min: Number(matchingSize.foot_measure_min),
            max: Number(matchingSize.foot_measure_max)
          };
        }
      }
      (_this$fitElementConta4 = this.fitElementContainer) === null || _this$fitElementConta4 === void 0 || _this$fitElementConta4.classList.add('tw-hidden');
      if (this.noMatchTextElement) {
        this.noMatchTextElement.classList.remove('tw-hidden');
        this.noMatchTextElement.innerHTML = this.noMatchTextElement.innerHTML.replace('(min)', lowest.toString()).replace('(max)', highest.toString());
      }
      return null;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "parseFootLength",
    value: function parseFootLength(raw) {
      var normalized = (raw || '').toString().trim().replace(',', '.').replace(/[^\d.]/g, '');
      var num = parseFloat(normalized);
      return Number.isFinite(num) ? num : NaN;
    }
    // Build a storage key (global, not per product)
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getFootLengthStorageKey",
    value: function getFootLengthStorageKey() {
      return 'sizeguide:footLength';
    }
    // Persist current foot length (raw string to preserve user intent)
  }, {
    key: "persistFootLength",
    value: function persistFootLength(raw) {
      try {
        var key = this.getFootLengthStorageKey();
        if (!raw) {
          localStorage.removeItem(key);
          return;
        }
        localStorage.setItem(key, raw);
      } catch (_unused) {
        // ignore storage errors
      }
    }
    // Restore foot length from localStorage and update UI accordingly
  }, {
    key: "restorePersistedFootLength",
    value: function restorePersistedFootLength() {
      try {
        var key = this.getFootLengthStorageKey();
        var raw = localStorage.getItem(key);
        if (!raw) return;
        // Set value into available inputs
        if (this.sizeInputForTable) this.sizeInputForTable.value = raw;
        if (this.sizeInput) this.sizeInput.value = raw;
        // Update table growth values if the table is present
        var growthValues = document.querySelectorAll('.growth_value');
        var innerMeasureValues = document.querySelectorAll('.inner_measure');
        if (growthValues.length && innerMeasureValues.length) {
          growthValues.forEach(function (growthEl, index) {
            var innerMeasureValue = innerMeasureValues[index];
            if (!innerMeasureValue) return;
            var inner = parseFloat((innerMeasureValue.textContent || '').replace(/[^\d.]/g, '')) || 0;
            var input = parseFloat(raw) || 0;
            growthEl.innerHTML = "".concat(inner - input, "mm");
          });
        }
        // Update recommendation + growth text
        this.handleDebouncedSizeInput(raw);
        var numeric = this.parseFootLength(raw);
        if (Number.isFinite(numeric) && numeric > 0) {
          this.updateGrowthAllowanceText(numeric);
        } else {
          this.resetGrowthAllowanceUi();
        }
      } catch (_unused2) {
        // ignore storage errors
      }
    }
  }, {
    key: "updateGrowthAllowanceText",
    value: function updateGrowthAllowanceText(footLengthMm) {
      if (!Number.isFinite(footLengthMm) || footLengthMm <= 0) {
        this.resetGrowthAllowanceUi();
        return;
      }
      if (!this.sizeInfoTextElement) {
        this.sizeInfoTextElement = document.querySelector('#size-info-text');
      }
      if (!this.growthAllowanceTextElement) {
        this.growthAllowanceTextElement = document.querySelector('#growth-allowance-text');
      }
      // Try multiple sources for size: tracked selection, checked radio in product form, active button, or recommended
      var sizeLabel = this.selectedSize || '';
      if (!sizeLabel) {
        var checkedRadio = document.querySelector('.product_size_variants input[type="radio"]:checked, variant-radios input[type="radio"]:checked, input[name^="options["][type="radio"]:checked');
        if (checkedRadio) {
          sizeLabel = (checkedRadio.getAttribute('data-option-value') || checkedRadio.value || '').trim();
        }
      }
      if (!sizeLabel) {
        var _this$sizeguideVarian3;
        var activeBtnSize = ((_this$sizeguideVarian3 = this.sizeguideVariantBtnHolder) === null || _this$sizeguideVarian3 === void 0 || (_this$sizeguideVarian3 = _this$sizeguideVarian3.querySelector('.active-btn')) === null || _this$sizeguideVarian3 === void 0 ? void 0 : _this$sizeguideVarian3.getAttribute('data-size')) || '';
        if (activeBtnSize) sizeLabel = activeBtnSize;
      }
      if (!sizeLabel) {
        sizeLabel = this.getRecommendedSize(footLengthMm);
      }
      if (!sizeLabel) {
        this.resetGrowthAllowanceUi();
        return;
      }
      // Prefer JSON-provided inner_measure, but fallback to DOM table if missing
      var info = this.sizeInfo.find(function (s) {
        return s.size === sizeLabel;
      });
      var inner = info ? Number(info.inner_measure) : NaN;
      if (!Number.isFinite(inner) || inner <= 0) {
        var fallbackInner = this.getInnerMeasureBySizeFromDom(sizeLabel);
        if (fallbackInner !== null) inner = fallbackInner;
      }
      if (!Number.isFinite(inner) || inner <= 0) {
        this.resetGrowthAllowanceUi();
        return;
      }
      var growth = inner - footLengthMm;
      var growthRounded = Math.round(growth);
      if (this.growthAllowanceTextElement) {
        var template = this.growthAllowanceTemplate || this.growthAllowanceTextElement.textContent || '';
        var localized = template.replace(/\{\{\s*growth_allowance\s*\}\}/g, String(growthRounded)).replace(/\{\{\s*size\s*\}\}/g, sizeLabel);
        this.growthAllowanceTextElement.textContent = localized;
        this.growthAllowanceTextElement.classList.remove('tw-hidden');
        this.growthAllowanceTextElement.style.display = '';
      }
      if (this.sizeInfoTextElement) {
        this.sizeInfoTextElement.classList.add('tw-hidden');
        this.sizeInfoTextElement.style.display = 'none';
      }
    }
  }, {
    key: "resetGrowthAllowanceUi",
    value: function resetGrowthAllowanceUi() {
      if (!this.sizeInfoTextElement) {
        this.sizeInfoTextElement = document.querySelector('#size-info-text');
      }
      if (!this.growthAllowanceTextElement) {
        this.growthAllowanceTextElement = document.querySelector('#growth-allowance-text');
      }
      if (this.sizeInfoTextElement) {
        this.sizeInfoTextElement.classList.remove('tw-hidden');
        this.sizeInfoTextElement.style.display = '';
      }
      if (this.growthAllowanceTextElement) {
        this.growthAllowanceTextElement.classList.add('tw-hidden');
        this.growthAllowanceTextElement.style.display = 'none';
      }
    }
    // Attempt to build a size -> inner_measure map from the modal table markup
  }, {
    key: "getInnerMeasureBySizeFromDom",
    value: function getInnerMeasureBySizeFromDom(sizeLabel) {
      var modalRoot = this.modal || this.querySelector('.sizeguide-modal');
      if (!modalRoot) return null;
      var innerEls = modalRoot.querySelectorAll('.sizeguide-table .inner_measure');
      for (var i = 0; i < innerEls.length; i += 1) {
        var _innerEl$parentElemen, _sizeCell$querySelect;
        var innerEl = innerEls[i];
        var innerText = (innerEl.textContent || '').replace(/[^\d.,]/g, '').replace(',', '.');
        var inner = parseFloat(innerText);
        var sizeCell = ((_innerEl$parentElemen = innerEl.parentElement) === null || _innerEl$parentElemen === void 0 ? void 0 : _innerEl$parentElemen.previousElementSibling) || null;
        var sizeText = sizeCell === null || sizeCell === void 0 || (_sizeCell$querySelect = sizeCell.querySelector('p')) === null || _sizeCell$querySelect === void 0 || (_sizeCell$querySelect = _sizeCell$querySelect.textContent) === null || _sizeCell$querySelect === void 0 ? void 0 : _sizeCell$querySelect.trim();
        if (sizeText && sizeText.toLowerCase() === sizeLabel.toLowerCase() && Number.isFinite(inner)) {
          return inner;
        }
      }
      return null;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getVariantInputForSize",
    value: function getVariantInputForSize(size) {
      if (!size) return null;
      var selectors = ['.product_size_variants input[type="radio"]', 'variant-radios input[type="radio"]', 'input[name^="options["][type="radio"]'];
      var wanted = size.trim().toLowerCase();
      for (var i = 0; i < selectors.length; i += 1) {
        var sel = selectors[i];
        var nodes = Array.from(document.querySelectorAll(sel));
        var foundInput = nodes.find(function (input) {
          var val = (input.value || '').trim().toLowerCase();
          var dataVal = (input.getAttribute('data-option-value') || '').trim().toLowerCase();
          return val === wanted || dataVal === wanted;
        });
        if (foundInput) return foundInput;
      }
      return null;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "isVariantUnavailable",
    value: function isVariantUnavailable(input) {
      if (input.disabled) return true;
      if (input.getAttribute('aria-disabled') === 'true') return true;
      var dataAvailable = input.getAttribute('data-available');
      if (dataAvailable === 'false') return true;
      if (input.hasAttribute('data-crossout')) return true;
      var label = input.closest('label, .variant-option, .product-form__input, .product-option');
      if (label && (label.classList.contains('is-unavailable') || label.getAttribute('data-sold-out') === 'true')) {
        return true;
      }
      return false;
    }
  }, {
    key: "updateCloseAndSelectVisibility",
    value: function updateCloseAndSelectVisibility(size) {
      if (!this.closeAndSelectVariantElement) return;
      var input = this.getVariantInputForSize(size);
      var unavailable = !input || this.isVariantUnavailable(input);
      this.closeAndSelectVariantElement.classList.toggle('tw-hidden', unavailable);
      if (unavailable) {
        this.closeAndSelectVariantElement.style.display = 'none';
        this.closeAndSelectVariantElement.setAttribute('aria-hidden', 'true');
        this.closeAndSelectVariantElement.disabled = true;
      } else {
        this.closeAndSelectVariantElement.style.display = '';
        this.closeAndSelectVariantElement.removeAttribute('aria-hidden');
        this.closeAndSelectVariantElement.disabled = false;
      }
    }
  }, {
    key: "updateKlaviyoBisVisibility",
    value: function updateKlaviyoBisVisibility(size) {
      if (!this.klaviyoBisButton) return;
      var input = this.getVariantInputForSize(size);
      var unavailable = !input || this.isVariantUnavailable(input);
      if (input) {
        var _input$closest;
        var variantId = input.getAttribute('data-variant-id') || ((_input$closest = input.closest('[data-variant-id]')) === null || _input$closest === void 0 ? void 0 : _input$closest.getAttribute('data-variant-id')) || '';
        if (variantId) {
          this.klaviyoBisButton.setAttribute('data-variant-id', variantId);
        }
        if (this.url) this.klaviyoBisButton.setAttribute('data-product-url', this.url);
        var productIdEl = document.querySelector('[data-product-id]');
        if (productIdEl !== null && productIdEl !== void 0 && productIdEl.dataset.productId) {
          this.klaviyoBisButton.setAttribute('data-product-id', productIdEl.dataset.productId);
        }
        var productTitleEl = document.querySelector('[data-product-title]');
        if (productTitleEl !== null && productTitleEl !== void 0 && productTitleEl.dataset.productTitle) {
          this.klaviyoBisButton.setAttribute('data-product-title', productTitleEl.dataset.productTitle);
        }
      }
      if (unavailable) {
        this.enforceFlexDisplay(this.klaviyoBisButton);
        if (this.closeAndSelectVariantElement) {
          this.closeAndSelectVariantElement.classList.add('tw-hidden');
          this.closeAndSelectVariantElement.style.display = 'none';
          this.closeAndSelectVariantElement.setAttribute('aria-hidden', 'true');
          this.closeAndSelectVariantElement.disabled = true;
        }
      } else {
        this.hideBis(this.klaviyoBisButton);
        if (this.closeAndSelectVariantElement) {
          this.closeAndSelectVariantElement.classList.remove('tw-hidden');
          this.closeAndSelectVariantElement.style.display = '';
          this.closeAndSelectVariantElement.removeAttribute('aria-hidden');
          this.closeAndSelectVariantElement.disabled = false;
        }
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "enforceFlexDisplay",
    value: function enforceFlexDisplay(el) {
      el.setAttribute('data-bis-state', 'visible');
      el.classList.add('bis-visible', '!tw-flex');
      el.classList.remove('tw-hidden');
      el.style.display = 'flex';
      el.setAttribute('aria-hidden', 'false');
      var key = '__bisObserver';
      var mo = el[key];
      if (!mo) {
        mo = new MutationObserver(function () {
          if (el.getAttribute('data-bis-state') !== 'visible') return;
          var computed = getComputedStyle(el).display;
          if (computed !== 'flex') {
            el.classList.add('bis-visible', '!tw-flex');
            el.classList.remove('tw-hidden');
            el.style.display = 'flex';
            el.setAttribute('aria-hidden', 'false');
          }
        });
        el[key] = mo;
      }
      mo.disconnect();
      mo.observe(el, {
        attributes: true,
        attributeFilter: ['style', 'class', 'aria-hidden'],
        subtree: false
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "hideBis",
    value: function hideBis(el) {
      el.setAttribute('data-bis-state', 'hidden');
      var key = '__bisObserver';
      var mo = el[key];
      if (mo) mo.disconnect();
      el.classList.remove('bis-visible', '!tw-flex');
      el.classList.add('tw-hidden');
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: "handlePrevNext",
    value: function handlePrevNext(direction) {
      if (!this.sizeguideVariantBtnHolder || !this.sizeguideVariantBtnHolder.children.length) return;
      var scrollLength = this.sizeguideVariantBtnHolder.children[0].clientWidth * 3;
      var scrollDirection = direction === 'prev' ? -scrollLength : scrollLength;
      this.sizeguideVariantBtnHolder.scrollBy({
        left: scrollDirection,
        behavior: 'smooth'
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Header/HeaderDrawer.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/Header/HeaderDrawer.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initHeaderDrawer)
/* harmony export */ });
// headerDrawer.ts
function initHeaderDrawer() {
  document.addEventListener('DOMContentLoaded', function () {
    var grandchildDetails = document.querySelectorAll('.details-grandchildlink');
    grandchildDetails.forEach(function (grandchildDetail) {
      grandchildDetail.addEventListener('toggle', function () {
        var isOpen = grandchildDetail.hasAttribute('open');
        var customDetailArrows = grandchildDetail.querySelectorAll('.arrow-down-move');
        customDetailArrows.forEach(function (arrow) {
          if (isOpen) {
            arrow.classList.add('active');
          } else {
            arrow.classList.remove('active');
          }
        });
      });
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    var grandchildDetails = document.querySelectorAll('.details-grandchildlink');
    grandchildDetails.forEach(function (grandchildDetail) {
      var content = grandchildDetail.querySelector('.childlink_links_custom');
      if (content) {
        content.style.maxHeight = '0';
        content.style.overflow = 'hidden';
        content.style.transition = 'max-height 0.3s ease';
        grandchildDetail.addEventListener('toggle', function () {
          if (grandchildDetail.open) {
            content.style.maxHeight = "".concat(content.scrollHeight, "px");
            content.addEventListener('transitionend', function handleOpen() {
              content.style.maxHeight = 'none';
              content.style.overflow = 'visible';
              content.removeEventListener('transitionend', handleOpen);
            });
          } else {
            content.style.maxHeight = "".concat(content.scrollHeight, "px");
            requestAnimationFrame(function () {
              content.style.maxHeight = '0';
            });
            content.style.overflow = 'hidden';
          }
        });
      }
    });
  });
}

/***/ }),

/***/ "./resources/scripts/components/Product/ProductSidebar.ts":
/*!****************************************************************!*\
  !*** ./resources/scripts/components/Product/ProductSidebar.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductSidebar)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var ProductSidebar = /*#__PURE__*/function (_HTMLElement) {
  function ProductSidebar() {
    var _this;
    _classCallCheck(this, ProductSidebar);
    _this = _callSuper(this, ProductSidebar);
    _defineProperty(_this, "initialZeroheight", 0);
    _defineProperty(_this, "mutationObserver", null);
    _this.getProductInfoSectionsHeight = _this.getProductInfoSectionsHeight.bind(_this);
    return _this;
  }
  _inherits(ProductSidebar, _HTMLElement);
  return _createClass(ProductSidebar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setHeightOfSideBar();
      this.addWindowEventListenerResize();
      this.observeSectionHeightChanges();
    }
  }, {
    key: "getProductInfoSectionsHeight",
    value: function getProductInfoSectionsHeight() {
      var productInfoSections = Array.from(document.querySelectorAll('[data-section="info"]'));
      var productInfoSectionParents = [];
      var totalHeight = this.initialZeroheight;
      productInfoSections.forEach(function (section) {
        var closestParent = section.closest('.shopify-section');
        if (closestParent) {
          productInfoSectionParents.push(closestParent);
        }
      });
      productInfoSectionParents.forEach(function (section) {
        var computedStyle = getComputedStyle(section);
        var sectionClientHeight = section.clientHeight;
        var sectionHeight = sectionClientHeight - (parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom));
        totalHeight += sectionHeight;
      });
      return totalHeight;
    }
  }, {
    key: "setHeightOfSideBar",
    value: function setHeightOfSideBar() {
      var extraHeight = 0;
      if (this.dataset.margintop) {
        extraHeight += parseInt(this.dataset.margintop, 10);
      }
      var totalHeightOfSections = this.getProductInfoSectionsHeight();
      var productSideBarHeight = document.querySelector('.cc-product-showcase').clientHeight;
      var totalHeight = totalHeightOfSections + productSideBarHeight + extraHeight;
      this.style.height = "".concat(totalHeight, "px");
    }
  }, {
    key: "addWindowEventListenerResize",
    value: function addWindowEventListenerResize() {
      var _this2 = this;
      window.addEventListener('resize', function () {
        _this2.setHeightOfSideBar();
      });
    }
  }, {
    key: "observeSectionHeightChanges",
    value: function observeSectionHeightChanges() {
      var _this3 = this;
      var sections = document.querySelectorAll('[data-section="info"]');
      var config = {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      };
      this.mutationObserver = new MutationObserver(function () {
        _this3.setHeightOfSideBar();
      });
      sections.forEach(function (section) {
        var closestParent = section.closest('.shopify-section');
        if (closestParent) {
          _this3.mutationObserver.observe(closestParent, config);
        }
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ReloadCart/reloadCart.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/ReloadCart/reloadCart.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ReloadCart)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
// document.dispatchEvent(new CustomEvent('edition:cart:reload'));
var ReloadCart = /*#__PURE__*/function () {
  function ReloadCart() {
    _classCallCheck(this, ReloadCart);
    this.reloadCart = this.init.bind(this);
    this.init = this.init.bind(this);
  }
  return _createClass(ReloadCart, [{
    key: "init",
    value: function init() {
      var _this = this;
      document.addEventListener('edition:cart:reload', function () {
        _this.reloadCart();
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "reloadCart",
    value: function () {
      var _reloadCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, responseText, fresh, cart, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return window.fetch("".concat(window.Shopify.routes.root_url, "?section_id=mini-cart"));
            case 1:
              response = _context.v;
              if (!response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.text();
            case 2:
              responseText = _context.v;
              fresh = document.createElement('div');
              fresh.innerHTML = responseText;
              cart = document.getElementById('cart');
              if (cart) {
                cart.innerHTML = fresh.innerHTML;
              } else {
                console.error('Cart element not found');
              }
              _context.n = 4;
              break;
            case 3:
              console.error('Failed to fetch cart');
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error('Error fetching cart:', _t);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[0, 5]]);
      }));
      function reloadCart() {
        return _reloadCart.apply(this, arguments);
      }
      return reloadCart;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/Scrollbar/Scrollbar.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/Scrollbar/Scrollbar.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initScrollbar)
/* harmony export */ });
function initScrollbar() {
  document.addEventListener('DOMContentLoaded', function () {
    var scrollContainers = document.querySelectorAll('.scroll-container');
    scrollContainers.forEach(function (scrollContainer) {
      var ulElement = scrollContainer.querySelector('.slider-wrapper');
      var scrollbar = scrollContainer.querySelector('.custom-scrollbar');
      var thumb = scrollbar.querySelector('.custom-scrollbar-thumb');
      var updateThumbWidth = function updateThumbWidth() {
        var ulClientWidth = ulElement.clientWidth,
          ulScrollWidth = ulElement.scrollWidth;
        var scrollbarClientWidth = scrollbar.clientWidth;
        var ratio = ulClientWidth / ulScrollWidth;
        thumb.style.width = "".concat(ratio * scrollbarClientWidth, "px");
        thumb.style.display = ratio >= 1 ? 'none' : 'block';
      };
      var onScroll = function onScroll() {
        var scrollLeft = ulElement.scrollLeft,
          ulClientWidth = ulElement.clientWidth,
          ulScrollWidth = ulElement.scrollWidth;
        var scrollbarClientWidth = scrollbar.clientWidth;
        var maxScrollLeft = ulScrollWidth - ulClientWidth;
        var maxThumbLeft = scrollbarClientWidth - thumb.clientWidth;
        var thumbLeft = scrollLeft / maxScrollLeft * maxThumbLeft;
        thumb.style.left = "".concat(thumbLeft, "px");
      };
      var onThumbMouseDown = function onThumbMouseDown(_ref) {
        var startX = _ref.clientX;
        var thumbLeft = parseInt(thumb.style.left, 10) || 0;
        var onMouseMove = function onMouseMove(_ref2) {
          var clientX = _ref2.clientX;
          var deltaX = clientX - startX;
          var maxThumbLeft = scrollbar.clientWidth - thumb.clientWidth;
          var newThumbLeft = Math.max(0, Math.min(thumbLeft + deltaX, maxThumbLeft));
          thumb.style.left = "".concat(newThumbLeft, "px");
          var scrollRatio = newThumbLeft / maxThumbLeft;
          var maxScrollLeft = ulElement.scrollWidth - ulElement.clientWidth;
          ulElement.scrollLeft = scrollRatio * maxScrollLeft;
        };
        var _onMouseUp = function onMouseUp() {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', _onMouseUp);
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', _onMouseUp);
      };
      thumb.addEventListener('mousedown', onThumbMouseDown);
      ulElement.addEventListener('scroll', onScroll);
      window.addEventListener('resize', updateThumbWidth);
      updateThumbWidth();
    });
  });
}

/***/ }),

/***/ "./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts":
/*!***************************************************************************!*\
  !*** ./resources/scripts/components/ShowMoreVariants/ShowMoreVariants.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ShowMoreVariants)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ShowMoreVariants = /*#__PURE__*/function (_HTMLElement) {
  function ShowMoreVariants() {
    var _this;
    _classCallCheck(this, ShowMoreVariants);
    _this = _callSuper(this, ShowMoreVariants);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  _inherits(ShowMoreVariants, _HTMLElement);
  return _createClass(ShowMoreVariants, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var closestVariantHolder = this.closest('.ProductMeta__Variants');
      var elementsToHide = closestVariantHolder.querySelectorAll('.hide');
      elementsToHide.forEach(function (element) {
        element.classList.remove('hide');
      });
      this.remove();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/SiblingsSlider/SiblingsSlider.ts":
/*!***********************************************************************!*\
  !*** ./resources/scripts/components/SiblingsSlider/SiblingsSlider.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SiblingsSlider)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var SiblingsSlider = /*#__PURE__*/function (_HTMLElement) {
  function SiblingsSlider() {
    var _this;
    _classCallCheck(this, SiblingsSlider);
    _this = _callSuper(this, SiblingsSlider);
    _defineProperty(_this, "leftArrow", void 0);
    _defineProperty(_this, "rightArrow", void 0);
    _defineProperty(_this, "productContainer", void 0);
    _defineProperty(_this, "siblingItem", void 0);
    // number of items per “page”
    _defineProperty(_this, "siblingsPerPage", 3);
    _defineProperty(_this, "gap", 12);
    _defineProperty(_this, "pageWidth", 0);
    _this.goRight = _this.goRight.bind(_this);
    _this.goLeft = _this.goLeft.bind(_this);
    _this.updateArrows = _this.updateArrows.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    return _this;
  }
  _inherits(SiblingsSlider, _HTMLElement);
  return _createClass(SiblingsSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // grab DOM nodes
      this.leftArrow = this.querySelector('.siblings_arrow_left');
      this.rightArrow = this.querySelector('.siblings_arrow_right');
      this.productContainer = this.querySelector('.ProductMeta__Variants');
      this.siblingItem = this.querySelector('.colors__item');
      // wire up events
      if (!this.leftArrow || !this.rightArrow || !this.productContainer || !this.siblingItem) {
        return;
      }
      this.leftArrow.addEventListener('click', this.goLeft);
      this.rightArrow.addEventListener('click', this.goRight);
      this.productContainer.addEventListener('scroll', this.updateArrows);
      window.addEventListener('resize', this.onResize);
      // initial setup
      this.computePageWidth();
      this.updateArrows();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.leftArrow.removeEventListener('click', this.goLeft);
      this.rightArrow.removeEventListener('click', this.goRight);
      this.productContainer.removeEventListener('scroll', this.updateArrows);
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "computePageWidth",
    value: function computePageWidth() {
      var itemWidth = this.siblingItem.offsetWidth;
      this.pageWidth = (itemWidth + this.gap) * this.siblingsPerPage;
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.computePageWidth();
      this.updateArrows();
    }
  }, {
    key: "goRight",
    value: function goRight() {
      var _this2 = this;
      this.productContainer.style.scrollBehavior = 'smooth';
      this.productContainer.scrollLeft += this.pageWidth;
      setTimeout(function () {
        _this2.productContainer.style.scrollBehavior = 'auto';
        _this2.updateArrows();
      }, 400);
    }
  }, {
    key: "goLeft",
    value: function goLeft() {
      var _this3 = this;
      this.productContainer.style.scrollBehavior = 'smooth';
      this.productContainer.scrollLeft -= this.pageWidth;
      setTimeout(function () {
        _this3.productContainer.style.scrollBehavior = 'auto';
        _this3.updateArrows();
      }, 400);
    }
  }, {
    key: "updateArrows",
    value: function updateArrows() {
      var _this$productContaine = this.productContainer,
        scrollLeft = _this$productContaine.scrollLeft,
        scrollWidth = _this$productContaine.scrollWidth,
        clientWidth = _this$productContaine.clientWidth;
      var maxScroll = scrollWidth - clientWidth;
      // assuming you hide via a utility class like Tailwind’s `tw-hidden`
      this.leftArrow.classList.toggle('tw-hidden', scrollLeft <= 0);
      this.rightArrow.classList.toggle('tw-hidden', scrollLeft >= maxScroll);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Sizeguide/Sizeguide.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/Sizeguide/Sizeguide.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Sizeguide)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var Sizeguide = /*#__PURE__*/function (_HTMLElement) {
  function Sizeguide() {
    var _this;
    _classCallCheck(this, Sizeguide);
    _this = _callSuper(this, Sizeguide);
    _defineProperty(_this, "url", void 0);
    _defineProperty(_this, "modal", void 0);
    _defineProperty(_this, "sizeInput", void 0);
    _defineProperty(_this, "recommendedSizeElement", void 0);
    _defineProperty(_this, "fitPositionElement", void 0);
    _defineProperty(_this, "sizeguideVariantBtns", void 0);
    _defineProperty(_this, "sizeguideVariantBtnHolder", void 0);
    _defineProperty(_this, "prevNexBtns", void 0);
    _defineProperty(_this, "dataHolder", void 0);
    _defineProperty(_this, "sizes", void 0);
    _defineProperty(_this, "measurements", void 0);
    _defineProperty(_this, "debounceTimer", null);
    _defineProperty(_this, "sizeguideTabHeaders", void 0);
    _defineProperty(_this, "sizeguideTabs", void 0);
    _defineProperty(_this, "sizeguideCloseBtn", void 0);
    _defineProperty(_this, "sizeChartElement", void 0);
    _defineProperty(_this, "viewSizeChartBtn", void 0);
    _defineProperty(_this, "viewSizeChartLink", void 0);
    _defineProperty(_this, "fitElementContainer", void 0);
    _defineProperty(_this, "noMatchText", void 0);
    _defineProperty(_this, "closeAndSelectVariant", void 0);
    _defineProperty(_this, "klaviyoBisButton", void 0);
    _this.initDataAndElements = _this.initDataAndElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    return _this;
  }
  _inherits(Sizeguide, _HTMLElement);
  return _createClass(Sizeguide, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$sizeguideVarian;
      this.initDataAndElements();
      this.addEventListeners();
      // Initial visibility based on the currently active/first button
      var activeButton = this.sizeguideVariantBtns.find(function (b) {
        return b.classList.contains('active-btn');
      });
      var initialSize = (activeButton === null || activeButton === void 0 ? void 0 : activeButton.dataset.size) || ((_this$sizeguideVarian = this.sizeguideVariantBtns[0]) === null || _this$sizeguideVarian === void 0 ? void 0 : _this$sizeguideVarian.getAttribute('data-size')) || '';
      if (initialSize) {
        this.updateCloseAndSelectVisibility(initialSize);
        this.updateKlaviyoBisVisibility(initialSize);
      }
    }
  }, {
    key: "initDataAndElements",
    value: function initDataAndElements() {
      var _this$dataHolder, _this$dataHolder2, _this$dataHolder3;
      this.modal = this.querySelector('.sizeguide-modal');
      this.sizeInput = this.querySelector('#sizeguide-input');
      this.recommendedSizeElement = this.querySelector('#recommended-size');
      this.fitPositionElement = this.querySelector('#fit-position');
      this.sizeguideVariantBtns = Array.from(this.querySelectorAll('.sizeguide-variant-btn'));
      this.sizeguideVariantBtnHolder = this.querySelector('#sizeguide-variant-btn-holder');
      this.prevNexBtns = Array.from(this.querySelectorAll('.prev-next-btn'));
      this.fitElementContainer = this.querySelector('.fit_element_container');
      this.noMatchText = this.querySelector('#no-match-text');
      this.closeAndSelectVariant = this.querySelector('#closeAndSelectVariant');
      this.klaviyoBisButton = this.querySelector('#klaviyo-bis-button');
      this.sizeChartElement = this.querySelector('#size-chart');
      this.viewSizeChartBtn = document.querySelector('#view-sizechart');
      this.viewSizeChartLink = document.querySelector('#view-sizechart-link');
      this.sizeguideTabHeaders = Array.from(this.querySelectorAll('.sizeguide-tab-header'));
      this.sizeguideTabs = Array.from(this.querySelectorAll('.sizeguide-tab-content'));
      this.sizeguideCloseBtn = this.querySelector('.sizeguide-close-btn');
      this.dataHolder = this.querySelector('.data-holder');
      this.sizes = (((_this$dataHolder = this.dataHolder) === null || _this$dataHolder === void 0 ? void 0 : _this$dataHolder.dataset.sizes) || '').split(',').filter(Boolean);
      this.measurements = (((_this$dataHolder2 = this.dataHolder) === null || _this$dataHolder2 === void 0 ? void 0 : _this$dataHolder2.dataset.measurements) || '').split(',').filter(Boolean);
      this.url = ((_this$dataHolder3 = this.dataHolder) === null || _this$dataHolder3 === void 0 ? void 0 : _this$dataHolder3.dataset.url) || '';
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      if (this.viewSizeChartBtn) {
        this.viewSizeChartBtn.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.toggleSizeguide();
        });
      }
      if (this.viewSizeChartLink) {
        this.viewSizeChartLink.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.toggleSizeguide();
        });
      }
      if (this.closeAndSelectVariant) {
        this.closeAndSelectVariant.addEventListener('click', function (event) {
          event.preventDefault();
          var activeButton = _this2.sizeguideVariantBtns.find(function (btn) {
            return btn.classList.contains('active-btn');
          });
          var activeSize = (activeButton === null || activeButton === void 0 ? void 0 : activeButton.dataset.size) || '';
          if (activeSize) _this2.selectVariantBySize(activeSize);
          _this2.toggleSizeguide();
        });
      }
      if (this.sizeInput) {
        this.sizeInput.addEventListener('input', function (event) {
          var target = event.target;
          var value = target.value;
          _this2.handleDebouncedSizeInput(value);
        });
      }
      this.sizeguideVariantBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          var _target$dataset;
          event.preventDefault();
          var target = event.currentTarget;
          var size = (target === null || target === void 0 || (_target$dataset = target.dataset) === null || _target$dataset === void 0 ? void 0 : _target$dataset.size) || '';
          if (!size) return;
          _this2.handleSizeSelection(size, btn, false);
          _this2.selectVariantBySize(size);
          _this2.updateCloseAndSelectVisibility(size);
          _this2.updateKlaviyoBisVisibility(size);
        });
      });
      this.prevNexBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var direction = btn.dataset.direction;
          _this2.handlePrevNext(direction || 'next');
        });
      });
      this.sizeguideTabHeaders.forEach(function (header) {
        header.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.toggleSizeguideTab(header);
        });
      });
      if (this.sizeguideCloseBtn) {
        this.sizeguideCloseBtn.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.toggleSizeguide();
        });
      }
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && _this2.modal && !_this2.modal.classList.contains('tw-hidden')) {
          _this2.toggleSizeguide();
        }
      });
      if (this.viewSizeChartBtn) {
        this.viewSizeChartBtn.addEventListener('click', function (event) {
          event.preventDefault();
          if (_this2.sizeChartElement) _this2.sizeChartElement.classList.toggle('!tw-grid');
        });
      }
      // Keep visibility in sync if variant is changed outside the sizeguide UI
      document.addEventListener('change', function (e) {
        var _target$matches;
        var target = e.target;
        if (target && (_target$matches = target.matches) !== null && _target$matches !== void 0 && _target$matches.call(target, '.product_size_variants input[type="radio"]')) {
          var input = target;
          var size = (input.getAttribute('data-option-value') || input.value || '').trim();
          if (size) {
            _this2.updateCloseAndSelectVisibility(size);
            _this2.updateKlaviyoBisVisibility(size);
          }
        }
      });
    }
  }, {
    key: "toggleSizeguideTab",
    value: function toggleSizeguideTab(header) {
      var id = header.dataset.id;
      this.sizeguideTabHeaders.forEach(function (tabHeader) {
        return tabHeader.classList.remove('active-tab');
      });
      this.sizeguideTabs.forEach(function (tab) {
        return tab.classList.remove('active-tab-content');
      });
      header.classList.add('active-tab');
      var tabContent = this.sizeguideTabs.find(function (tab) {
        return tab.dataset.id === id;
      });
      if (tabContent) tabContent.classList.add('active-tab-content');
    }
  }, {
    key: "handleDebouncedSizeInput",
    value: function handleDebouncedSizeInput(value) {
      var _this3 = this;
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(function () {
        return _this3.handleSizeInput(value);
      }, 300);
    }
  }, {
    key: "handleSizeInput",
    value: function handleSizeInput(value) {
      var range = this.getSizeRange(Number(value));
      if (!range) return;
      var min = range.min,
        max = range.max;
      var recommendedSize = this.getRecommendedSize(min, max);
      if (!recommendedSize) return;
      this.recommendedSizeElement.textContent = recommendedSize;
      var recommendedButton = this.sizeguideVariantBtns.find(function (btn) {
        return btn.dataset.size === recommendedSize;
      });
      if (recommendedButton) {
        this.handleSizeSelection(recommendedSize, recommendedButton, true);
        this.selectVariantBySize(recommendedSize);
        this.updateCloseAndSelectVisibility(recommendedSize);
        this.updateKlaviyoBisVisibility(recommendedSize);
      }
    }
  }, {
    key: "setFitPositionElement",
    value: function setFitPositionElement(value, min, max) {
      var numericValue = Number(value);
      var minValue = min - 2;
      var maxValue = max + 2;
      if (numericValue < min || numericValue > max) numericValue += 3;
      var fitPosition = Math.round((maxValue - numericValue) / (maxValue - minValue) * 100);
      fitPosition = Math.max(0, Math.min(100, fitPosition));
      this.fitPositionElement.style.left = "".concat(fitPosition, "%");
    }
  }, {
    key: "getRecommendedSize",
    value: function getRecommendedSize(min, max) {
      var _this4 = this;
      var recommendedSize = this.sizes.find(function (size) {
        var sizeIndex = _this4.getSizeIndex(size);
        var _this4$getMeasurement = _this4.getMeasurements(sizeIndex),
          minValue = _this4$getMeasurement.min,
          maxValue = _this4$getMeasurement.max;
        return min >= minValue && max <= maxValue;
      });
      return recommendedSize || '';
    }
  }, {
    key: "handleSizeSelection",
    value: function handleSizeSelection(size, button, scroll) {
      var _this$sizeInput;
      var sizeIndex = this.getSizeIndex(size);
      if (sizeIndex < 0) return;
      var _this$getMeasurements = this.getMeasurements(sizeIndex),
        min = _this$getMeasurements.min,
        max = _this$getMeasurements.max;
      this.sizeguideVariantBtns.forEach(function (btn) {
        return btn.classList.remove('active-btn');
      });
      button.classList.add('active-btn');
      var currentValue = (_this$sizeInput = this.sizeInput) === null || _this$sizeInput === void 0 ? void 0 : _this$sizeInput.value;
      if (currentValue) this.setFitPositionElement(currentValue, min, max);
      if (scroll && this.sizeguideVariantBtnHolder) {
        var buttonPosition = button.getBoundingClientRect().left;
        var holderPosition = this.sizeguideVariantBtnHolder.getBoundingClientRect().left;
        var scrollPosition = buttonPosition - holderPosition;
        this.sizeguideVariantBtnHolder.scrollBy({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
      this.updateCloseAndSelectVisibility(size);
      this.updateKlaviyoBisVisibility(size);
    }
  }, {
    key: "getMinMaxFromRange",
    value: function getMinMaxFromRange() {
      var lows = this.measurements.map(function (range) {
        return Number(range.split('-')[0]);
      });
      var highs = this.measurements.map(function (range) {
        return Number(range.split('-')[1]);
      });
      return {
        lowest: Math.min.apply(Math, _toConsumableArray(lows)),
        highest: Math.max.apply(Math, _toConsumableArray(highs))
      };
    }
  }, {
    key: "getMeasurements",
    value: function getMeasurements(sizeIndex) {
      var _split$map = (this.measurements[sizeIndex] || '0-0').split('-').map(Number),
        _split$map2 = _slicedToArray(_split$map, 2),
        min = _split$map2[0],
        max = _split$map2[1];
      return {
        min: min,
        max: max
      };
    }
  }, {
    key: "getSizeIndex",
    value: function getSizeIndex(size) {
      return this.sizes.findIndex(function (_size) {
        return _size === size;
      });
    }
  }, {
    key: "getSizeRange",
    value: function getSizeRange(value) {
      var _this$fitElementConta2;
      var range = this.measurements.find(function (_range) {
        var _range$split$map = _range.split('-').map(Number),
          _range$split$map2 = _slicedToArray(_range$split$map, 2),
          min = _range$split$map2[0],
          max = _range$split$map2[1];
        return value >= min && value <= max;
      });
      if (range) {
        var _this$fitElementConta, _this$noMatchText;
        (_this$fitElementConta = this.fitElementContainer) === null || _this$fitElementConta === void 0 || _this$fitElementConta.classList.remove('tw-hidden');
        (_this$noMatchText = this.noMatchText) === null || _this$noMatchText === void 0 || _this$noMatchText.classList.add('tw-hidden');
        var _range$split$map3 = range.split('-').map(Number),
          _range$split$map4 = _slicedToArray(_range$split$map3, 2),
          min = _range$split$map4[0],
          max = _range$split$map4[1];
        return {
          min: min,
          max: max
        };
      }
      // outside ranges
      (_this$fitElementConta2 = this.fitElementContainer) === null || _this$fitElementConta2 === void 0 || _this$fitElementConta2.classList.add('tw-hidden');
      var _this$getMinMaxFromRa = this.getMinMaxFromRange(),
        lowest = _this$getMinMaxFromRa.lowest,
        highest = _this$getMinMaxFromRa.highest;
      if (this.noMatchText) {
        this.noMatchText.classList.remove('tw-hidden');
        this.noMatchText.innerHTML = this.noMatchText.innerHTML.replace('(min)', lowest.toString()).replace('(max)', highest.toString());
      }
      return null;
    }
    /** Robustly find the variant input by size text (value or data-option-value) */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getVariantInputForSize",
    value: function getVariantInputForSize(size) {
      if (!size) return null;
      var selectors = ['.product_size_variants input[type="radio"]', 'variant-radios input[type="radio"]', 'input[name^="options["][type="radio"]'];
      var wanted = size.trim().toLowerCase();
      for (var i = 0; i < selectors.length; i += 1) {
        var sel = selectors[i];
        var nodes = Array.from(document.querySelectorAll(sel));
        var foundInput = nodes.find(function (input) {
          var val = (input.value || '').trim().toLowerCase();
          var dataVal = (input.getAttribute('data-option-value') || '').trim().toLowerCase();
          return val === wanted || dataVal === wanted;
        });
        if (foundInput) return foundInput;
      }
      return null;
    }
    /** Detect multiple "unavailable" signals beyond .disabled */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "isVariantUnavailable",
    value: function isVariantUnavailable(input) {
      if (input.disabled) return true;
      if (input.getAttribute('aria-disabled') === 'true') return true;
      var dataAvailable = input.getAttribute('data-available');
      if (dataAvailable === 'false') return true;
      if (input.hasAttribute('data-crossout')) return true;
      var label = input.closest('label, .variant-option, .product-form__input, .product-option');
      if (label && (label.classList.contains('is-unavailable') || label.getAttribute('data-sold-out') === 'true')) {
        return true;
      }
      return false;
    }
    /** Show/hide the Close & Select button (uses tw-hidden + inline style fallback) */
  }, {
    key: "updateCloseAndSelectVisibility",
    value: function updateCloseAndSelectVisibility(size) {
      if (!this.closeAndSelectVariant) return;
      var input = this.getVariantInputForSize(size);
      var unavailable = !input || this.isVariantUnavailable(input);
      this.closeAndSelectVariant.classList.toggle('tw-hidden', unavailable);
      if (unavailable) {
        this.closeAndSelectVariant.style.display = 'none';
        this.closeAndSelectVariant.setAttribute('aria-hidden', 'true');
        this.closeAndSelectVariant.disabled = true;
      } else {
        this.closeAndSelectVariant.style.display = '';
        this.closeAndSelectVariant.removeAttribute('aria-hidden');
        this.closeAndSelectVariant.disabled = false;
      }
    }
    /**
     * Keep Klaviyo BIS in sync with current variant and **force display:flex**
     * whenever the targeted size is unavailable.
     */
  }, {
    key: "updateKlaviyoBisVisibility",
    value: function updateKlaviyoBisVisibility(size) {
      if (!this.klaviyoBisButton) return;
      var input = this.getVariantInputForSize(size);
      var unavailable = !input || this.isVariantUnavailable(input);
      // Update variant metadata for Klaviyo if we can find it on the input/DOM
      if (input) {
        var _input$closest;
        var variantId = input.getAttribute('data-variant-id') || ((_input$closest = input.closest('[data-variant-id]')) === null || _input$closest === void 0 ? void 0 : _input$closest.getAttribute('data-variant-id')) || '';
        if (variantId) {
          this.klaviyoBisButton.setAttribute('data-variant-id', variantId);
        }
        if (this.url) this.klaviyoBisButton.setAttribute('data-product-url', this.url);
        var productIdEl = document.querySelector('[data-product-id]');
        if (productIdEl !== null && productIdEl !== void 0 && productIdEl.dataset.productId) {
          this.klaviyoBisButton.setAttribute('data-product-id', productIdEl.dataset.productId);
        }
        var productTitleEl = document.querySelector('[data-product-title]');
        if (productTitleEl !== null && productTitleEl !== void 0 && productTitleEl.dataset.productTitle) {
          this.klaviyoBisButton.setAttribute('data-product-title', productTitleEl.dataset.productTitle);
        }
      }
      // If unavailable → show BIS as FLEX; If available → hide BIS.
      if (unavailable) {
        this.enforceFlexDisplay(this.klaviyoBisButton);
        // Make sure default Close&Select is not competing
        if (this.closeAndSelectVariant) {
          this.closeAndSelectVariant.classList.add('tw-hidden');
          this.closeAndSelectVariant.style.display = 'none';
          this.closeAndSelectVariant.setAttribute('aria-hidden', 'true');
          this.closeAndSelectVariant.disabled = true;
        }
      } else {
        this.hideBis(this.klaviyoBisButton);
        // If available, ensure the primary CTA is visible
        if (this.closeAndSelectVariant) {
          this.closeAndSelectVariant.classList.remove('tw-hidden');
          this.closeAndSelectVariant.style.display = '';
          this.closeAndSelectVariant.removeAttribute('aria-hidden');
          this.closeAndSelectVariant.disabled = false;
        }
      }
      // Optionally notify other scripts that BIS state changed:
      // document.dispatchEvent(new CustomEvent('klaviyo:bis:update', { detail: { unavailable } }));
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "enforceFlexDisplay",
    value: function enforceFlexDisplay(el) {
      el.setAttribute('data-bis-state', 'visible');
      // Classes + inline for immediate effect
      el.classList.add('bis-visible', '!tw-flex');
      el.classList.remove('tw-hidden');
      el.style.display = 'flex';
      el.setAttribute('aria-hidden', 'false');
      var key = '__bisObserver';
      var mo = el[key];
      if (!mo) {
        mo = new MutationObserver(function () {
          if (el.getAttribute('data-bis-state') !== 'visible') return;
          var computed = getComputedStyle(el).display;
          if (computed !== 'flex') {
            el.classList.add('bis-visible', '!tw-flex');
            el.classList.remove('tw-hidden');
            el.style.display = 'flex';
            el.setAttribute('aria-hidden', 'false');
          }
        });
        el[key] = mo;
      }
      mo.disconnect();
      mo.observe(el, {
        attributes: true,
        attributeFilter: ['style', 'class', 'aria-hidden'],
        subtree: false
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "hideBis",
    value: function hideBis(el) {
      el.setAttribute('data-bis-state', 'hidden');
      var key = '__bisObserver';
      var mo = el[key];
      if (mo) mo.disconnect();
      el.classList.remove('bis-visible', '!tw-flex');
      el.classList.add('tw-hidden');
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    }
    /** Select the product size variant matching the given size */
  }, {
    key: "selectVariantBySize",
    value: function selectVariantBySize(size) {
      var input = this.getVariantInputForSize(size);
      if (!input) {
        this.updateCloseAndSelectVisibility(size);
        this.updateKlaviyoBisVisibility(size);
        return false;
      }
      if (this.isVariantUnavailable(input)) {
        this.updateCloseAndSelectVisibility(size);
        this.updateKlaviyoBisVisibility(size);
        return false;
      }
      if (!input.checked) input.checked = true;
      input.dispatchEvent(new Event('input', {
        bubbles: true
      }));
      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      if (typeof input.click === 'function') input.click();
      this.updateCloseAndSelectVisibility(size);
      this.updateKlaviyoBisVisibility(size);
      return true;
    }
  }, {
    key: "setVariantAndClick",
    value: function setVariantAndClick() {
      var activeButton = this.sizeguideVariantBtns.find(function (btn) {
        return btn.classList.contains('active-btn');
      });
      var activeSize = activeButton ? activeButton.dataset.size : '';
      if (activeSize) this.selectVariantBySize(activeSize);
    }
  }, {
    key: "handlePrevNext",
    value: function handlePrevNext(direction) {
      if (!this.sizeguideVariantBtnHolder || !this.sizeguideVariantBtnHolder.children.length) return;
      var scrollLength = this.sizeguideVariantBtnHolder.children[0].clientWidth * 3;
      var scrollDirection = direction === 'prev' ? -scrollLength : scrollLength;
      this.sizeguideVariantBtnHolder.scrollBy({
        left: scrollDirection,
        behavior: 'smooth'
      });
    }
  }, {
    key: "toggleSizeguide",
    value: function toggleSizeguide() {
      if (!this.modal) return;
      var modalContent = this.modal.querySelector('.sizeguide-modal-content');
      this.modal.classList.toggle('tw-hidden');
      setTimeout(function () {
        return modalContent === null || modalContent === void 0 ? void 0 : modalContent.classList.toggle('active');
      }, 100);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Slider/Slider.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/Slider/Slider.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SliderSection)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var SliderSection = /*#__PURE__*/function (_HTMLElement) {
  function SliderSection() {
    var _this;
    _classCallCheck(this, SliderSection);
    _this = _callSuper(this, SliderSection);
    _defineProperty(_this, "autoSlideInterval", null);
    _defineProperty(_this, "autoSlideTimeout", null);
    _defineProperty(_this, "isUserInteracting", false);
    var slider = _this;
    var scrollContainer = slider.closest('.scroll-container');
    var sliderCards = Array.from(slider.querySelectorAll('.slide'));
    var sliderCardsWidth = sliderCards.length > 0 ? sliderCards[0].offsetWidth + 12 : 0;
    var sliderBtns = Array.from(scrollContainer.querySelectorAll('.sliderbtn'));
    sliderBtns.forEach(function (sliderBtn) {
      sliderBtn.addEventListener('click', function () {
        var direction = sliderBtn.getAttribute('data-id');
        if (direction === 'right') {
          slider.scrollLeft += sliderCardsWidth;
        } else if (direction === 'left') {
          slider.scrollLeft -= sliderCardsWidth;
        }
      });
    });
    if (_this.getAttribute('data-type-auto-slide') === 'true') {
      _this.startAutoSlide(slider, sliderCardsWidth);
      scrollContainer.addEventListener('mouseenter', function () {
        _this.stopAutoSlide();
        _this.isUserInteracting = true;
      });
      scrollContainer.addEventListener('mouseleave', function () {
        _this.isUserInteracting = false;
        _this.startAutoSlide(slider, sliderCardsWidth);
      });
      scrollContainer.addEventListener('scroll', function () {
        if (!_this.isUserInteracting) {
          _this.stopAutoSlide();
          clearTimeout(_this.autoSlideTimeout);
          _this.autoSlideTimeout = setTimeout(function () {
            if (!_this.isUserInteracting) {
              _this.startAutoSlide(slider, sliderCardsWidth);
            }
          }, 2000);
        }
      });
    }
    return _this;
  }
  _inherits(SliderSection, _HTMLElement);
  return _createClass(SliderSection, [{
    key: "startAutoSlide",
    value: function startAutoSlide(sliderElement, slideWidth) {
      var slideDelay = parseInt(this.getAttribute('data-slide-delay') || '3000', 10); // Use delay from attribute or default to 3000ms (3 seconds)
      this.autoSlideInterval = setInterval(function () {
        var maxScrollLeft = sliderElement.scrollWidth - sliderElement.clientWidth;
        if (sliderElement.scrollLeft + slideWidth >= maxScrollLeft) {
          sliderElement.scrollLeft = 0;
        } else {
          sliderElement.scrollLeft += slideWidth;
        }
      }, slideDelay);
    }
  }, {
    key: "stopAutoSlide",
    value: function stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.stopAutoSlide();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/SliderDots/SliderDots.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/SliderDots/SliderDots.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SliderDots)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var SliderDots = /*#__PURE__*/function (_HTMLElement) {
  function SliderDots() {
    var _this;
    _classCallCheck(this, SliderDots);
    _this = _callSuper(this, SliderDots);
    _defineProperty(_this, "sectionId", void 0);
    _defineProperty(_this, "ul", void 0);
    _defineProperty(_this, "dotsWrapper", void 0);
    _defineProperty(_this, "dots", []);
    _defineProperty(_this, "slideWidth", 0);
    _defineProperty(_this, "resizeObserver", void 0);
    _this.onDotClick = _this.onDotClick.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    return _this;
  }
  _inherits(SliderDots, _HTMLElement);
  return _createClass(SliderDots, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Read section-id attribute
      this.sectionId = this.getAttribute('section-id') || '';
      if (!this.sectionId) {
        console.error('SliderDots: "section-id" attribute is required.');
        return;
      }
      // Query the gallery container and dots wrapper
      this.ul = this.querySelector("#Slider-Gallery-".concat(this.sectionId));
      this.dotsWrapper = this.querySelector(".slider__dots[data-dots-for=\"Slider-Gallery-".concat(this.sectionId, "\"]"));
      if (!this.ul || !this.dotsWrapper) {
        console.error("SliderDots: Unable to find gallery or dots for section ".concat(this.sectionId, "."));
        return;
      }
      // Dynamically generate dots based on number of slides
      var slides = Array.from(this.ul.children);
      this.dotsWrapper.innerHTML = ''; // Clear any static dots
      slides.forEach(function (_, idx) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.classList.add('dot');
        btn.setAttribute('aria-label', "G\xE5 til billede ".concat(idx + 1));
        btn.setAttribute('data-slide-index', idx.toString());
        li.appendChild(btn);
        _this2.dotsWrapper.appendChild(li);
      });
      // Cache generated dots
      this.dots = Array.from(this.dotsWrapper.querySelectorAll('button.dot'));
      // Set up scroll snapping behavior and event listeners
      this.updateSlideWidth();
      this.ul.addEventListener('scroll', this.onScroll);
      this.dotsWrapper.addEventListener('click', this.onDotClick);
      // Observe resize to recalc slide width
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.ul);
      // Initial active state
      this.syncActiveDot(0);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.ul.removeEventListener('scroll', this.onScroll);
      this.dotsWrapper.removeEventListener('click', this.onDotClick);
      this.resizeObserver.disconnect();
    }
  }, {
    key: "updateSlideWidth",
    value: function updateSlideWidth() {
      // width of one slide (assumes full container width per slide)
      this.slideWidth = this.ul.clientWidth;
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.updateSlideWidth();
      var idx = Math.round(this.ul.scrollLeft / this.slideWidth);
      this.syncActiveDot(idx);
    }
  }, {
    key: "onDotClick",
    value: function onDotClick(event) {
      var btn = event.target.closest('button.dot');
      if (!btn) return;
      var idx = parseInt(btn.getAttribute('data-slide-index') || '0', 10);
      this.ul.scrollTo({
        left: idx * this.slideWidth,
        behavior: 'smooth'
      });
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var _this3 = this;
      window.requestAnimationFrame(function () {
        var idx = Math.round(_this3.ul.scrollLeft / _this3.slideWidth);
        _this3.syncActiveDot(idx);
      });
    }
  }, {
    key: "syncActiveDot",
    value: function syncActiveDot(activeIdx) {
      this.dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === activeIdx);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/SubCollectionSlider/SubCollectionSlider.ts":
/*!*********************************************************************************!*\
  !*** ./resources/scripts/components/SubCollectionSlider/SubCollectionSlider.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SubCollectionSlider)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var SubCollectionSlider = /*#__PURE__*/function (_HTMLElement) {
  function SubCollectionSlider() {
    var _this;
    _classCallCheck(this, SubCollectionSlider);
    _this = _callSuper(this, SubCollectionSlider);
    _defineProperty(_this, "leftArrow", void 0);
    _defineProperty(_this, "rightArrow", void 0);
    _defineProperty(_this, "sliderContainer", void 0);
    _defineProperty(_this, "slideItem", void 0);
    // adjust these to suit your design
    _defineProperty(_this, "itemsPerPage", 3);
    _defineProperty(_this, "gap", 12);
    _defineProperty(_this, "pageWidth", 0);
    _this.goRight = _this.goRight.bind(_this);
    _this.goLeft = _this.goLeft.bind(_this);
    _this.updateArrows = _this.updateArrows.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    return _this;
  }
  _inherits(SubCollectionSlider, _HTMLElement);
  return _createClass(SubCollectionSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.leftArrow = this.querySelector('.subcol-slider__arrow--left');
      this.rightArrow = this.querySelector('.subcol-slider__arrow--right');
      this.sliderContainer = this.querySelector('.subcol-slider__list');
      this.slideItem = this.querySelector('.subcol-slider__item');
      this.leftArrow.addEventListener('click', this.goLeft);
      this.rightArrow.addEventListener('click', this.goRight);
      this.sliderContainer.addEventListener('scroll', this.updateArrows);
      window.addEventListener('resize', this.onResize);
      this.computePageWidth();
      this.updateArrows();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.leftArrow.removeEventListener('click', this.goLeft);
      this.rightArrow.removeEventListener('click', this.goRight);
      this.sliderContainer.removeEventListener('scroll', this.updateArrows);
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "computePageWidth",
    value: function computePageWidth() {
      var itemWidth = this.slideItem.getBoundingClientRect().width;
      this.pageWidth = (itemWidth + this.gap) * this.itemsPerPage;
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.computePageWidth();
      this.updateArrows();
    }
  }, {
    key: "goRight",
    value: function goRight() {
      var _this2 = this;
      this.sliderContainer.style.scrollBehavior = 'smooth';
      this.sliderContainer.scrollLeft += this.pageWidth;
      setTimeout(function () {
        _this2.sliderContainer.style.scrollBehavior = 'auto';
        _this2.updateArrows();
      }, 400);
    }
  }, {
    key: "goLeft",
    value: function goLeft() {
      var _this3 = this;
      this.sliderContainer.style.scrollBehavior = 'smooth';
      this.sliderContainer.scrollLeft -= this.pageWidth;
      setTimeout(function () {
        _this3.sliderContainer.style.scrollBehavior = 'auto';
        _this3.updateArrows();
      }, 400);
    }
  }, {
    key: "updateArrows",
    value: function updateArrows() {
      var _this$sliderContainer = this.sliderContainer,
        scrollLeft = _this$sliderContainer.scrollLeft,
        scrollWidth = _this$sliderContainer.scrollWidth,
        clientWidth = _this$sliderContainer.clientWidth;
      var maxScroll = scrollWidth - clientWidth;
      this.leftArrow.classList.toggle('hidden', scrollLeft <= 0);
      this.rightArrow.classList.toggle('hidden', scrollLeft >= maxScroll);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/TradeConditions/TradeConditions.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/TradeConditions/TradeConditions.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ TradeConditions)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var TradeConditions = /*#__PURE__*/function (_HTMLElement) {
  function TradeConditions() {
    var _this;
    _classCallCheck(this, TradeConditions);
    _this = _callSuper(this, TradeConditions);
    // Bind methods to maintain 'this' context
    _defineProperty(_this, "acceptTerms", void 0);
    _defineProperty(_this, "observer", void 0);
    _defineProperty(_this, "termsCheckmark", void 0);
    _defineProperty(_this, "acceptsContainer", void 0);
    _defineProperty(_this, "acceptTermsClose", void 0);
    _defineProperty(_this, "termsCheckbox", void 0);
    _defineProperty(_this, "addToCartButton", void 0);
    _defineProperty(_this, "acceptTermsButton", void 0);
    _this.mutationCallback = _this.mutationCallback.bind(_this);
    _this.cartUpdateHandler = _this.cartUpdateHandler.bind(_this);
    _this.documentClickHandler = _this.documentClickHandler.bind(_this);
    _this.addToCartButtonHandler = _this.addToCartButtonHandler.bind(_this);
    _this.initializeCartListeners = _this.initializeCartListeners.bind(_this);
    _this.acceptTermsCloseHandler = _this.acceptTermsCloseHandler.bind(_this);
    _this.acceptTermsButtonHandler = _this.acceptTermsButtonHandler.bind(_this);
    _this.termsCheckboxChangeHandler = _this.termsCheckboxChangeHandler.bind(_this);
    // Initialize elements within this custom element's scope
    _this.acceptTerms = _this.querySelector('#acceptTerms');
    _this.acceptsContainer = _this.querySelector('.acceptsContainer');
    _this.acceptTermsClose = _this.querySelector('#acceptTermsClose');
    _this.addToCartButton = _this.querySelector('.CartDrawer-Checkout');
    _this.acceptTermsButton = _this.querySelector('#acceptTermsButton');
    _this.termsCheckmark = _this.querySelector('.termsContainer .termsCheckmark');
    _this.termsCheckbox = _this.querySelector('.termsContainer input[type="checkbox"]');
    // Initialize MutationObserver
    _this.observer = new MutationObserver(_this.mutationCallback);
    return _this;
  }
  _inherits(TradeConditions, _HTMLElement);
  return _createClass(TradeConditions, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initializeCartListeners();
      // Observe changes in the cart drawer if necessary
      var targetNode = document.getElementById('CartDrawer');
      var config = {
        childList: true,
        subtree: true
      };
      if (targetNode) {
        this.observer.observe(targetNode, config);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.observer.disconnect();
      this.removeEventListeners();
    }
  }, {
    key: "initializeCartListeners",
    value: function initializeCartListeners() {
      if (this.addToCartButton && this.termsCheckbox) {
        document.addEventListener('click', this.documentClickHandler);
        this.addToCartButton.addEventListener('click', this.addToCartButtonHandler);
        this.acceptTermsClose.addEventListener('click', this.acceptTermsCloseHandler);
        this.termsCheckbox.addEventListener('change', this.termsCheckboxChangeHandler);
        this.acceptTermsButton.addEventListener('click', this.acceptTermsButtonHandler);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (this.addToCartButton && this.termsCheckbox) {
        document.removeEventListener('click', this.documentClickHandler);
        this.addToCartButton.removeEventListener('click', this.addToCartButtonHandler);
        this.acceptTermsClose.removeEventListener('click', this.acceptTermsCloseHandler);
        this.termsCheckbox.removeEventListener('change', this.termsCheckboxChangeHandler);
        this.acceptTermsButton.removeEventListener('click', this.acceptTermsButtonHandler);
      }
    }
  }, {
    key: "addToCartButtonHandler",
    value: function addToCartButtonHandler(e) {
      if (!this.termsCheckbox.checked) {
        this.acceptTerms.classList.remove('tw-hidden');
        e.preventDefault();
      }
    }
  }, {
    key: "termsCheckboxChangeHandler",
    value: function termsCheckboxChangeHandler() {
      if (this.termsCheckbox.checked) {
        this.addToCartButton.setAttribute('name', 'checkout');
        this.addToCartButton.setAttribute('type', 'submit');
      } else {
        this.addToCartButton.removeAttribute('name');
        this.addToCartButton.removeAttribute('type');
      }
      this.cartUpdateHandler();
    }
  }, {
    key: "acceptTermsButtonHandler",
    value: function acceptTermsButtonHandler() {
      var _this2 = this;
      this.termsCheckbox.click();
      this.termsCheckboxChangeHandler();
      setTimeout(function () {
        if (_this2.termsCheckbox.checked) {
          _this2.addToCartButton.click();
        }
      }, 100);
    }
  }, {
    key: "documentClickHandler",
    value: function documentClickHandler(e) {
      var target = e.target;
      if (this.acceptTerms && !this.acceptsContainer.contains(target) && !this.addToCartButton.contains(target)) {
        this.acceptTerms.classList.add('tw-hidden');
      }
    }
  }, {
    key: "acceptTermsCloseHandler",
    value: function acceptTermsCloseHandler(e) {
      e.preventDefault();
      this.acceptTerms.classList.add('tw-hidden');
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "cartUpdateHandler",
    value: function cartUpdateHandler() {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {}
      }));
    }
  }, {
    key: "mutationCallback",
    value: function mutationCallback(mutationsList) {
      // eslint-disable-next-line no-restricted-syntax
      var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          if (mutation.type === 'childList') {
            this.initializeCartListeners();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Wishlist/VariantSelecter.ts":
/*!******************************************************************!*\
  !*** ./resources/scripts/components/Wishlist/VariantSelecter.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ VariantSelector)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var VariantSelector = /*#__PURE__*/function (_HTMLElement) {
  function VariantSelector() {
    var _this;
    _classCallCheck(this, VariantSelector);
    _this = _callSuper(this, VariantSelector);
    _defineProperty(_this, "dropdown", void 0);
    _defineProperty(_this, "button", void 0);
    _defineProperty(_this, "content", void 0);
    _defineProperty(_this, "addToCartButton", void 0);
    _this.openDropdown = _this.openDropdown.bind(_this);
    _this.closeDropdown = _this.closeDropdown.bind(_this);
    _this.addToCart = _this.addToCart.bind(_this);
    return _this;
  }
  _inherits(VariantSelector, _HTMLElement);
  return _createClass(VariantSelector, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.dropdown = this.querySelector('.custom-dropdown');
      this.button = this.dropdown.querySelector('.dropdown-button');
      this.content = this.dropdown.querySelector('.dropdown-content');
      this.addToCartButton = this.querySelector('.add-to-cart-button');
      if (this.button) {
        this.button.addEventListener('click', function () {
          _this2.openDropdown();
        });
      }
      if (this.content) {
        this.content.addEventListener('click', function (event) {
          var target = event.target;
          if (target.matches('div[data-value]')) {
            if (_this2.button) {
              _this2.button.textContent = target.textContent;
            }
            if (_this2.addToCartButton && target.dataset.variantId) {
              _this2.addToCartButton.setAttribute('data-variant-id', target.dataset.variantId);
              if (_this2.addToCartButton.dataset.buttonText) {
                _this2.addToCartButton.textContent = _this2.addToCartButton.dataset.buttonText;
              }
            }
            _this2.closeDropdown();
          }
        });
      }
      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', this.addToCart);
      }
    }
  }, {
    key: "openDropdown",
    value: function openDropdown() {
      if (this.content) {
        if (this.content.classList.contains('tw-hidden')) {
          this.content.classList.remove('tw-hidden');
        } else {
          this.content.classList.add('tw-hidden');
        }
      }
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      if (this.content) {
        this.content.classList.add('tw-hidden');
      }
    }
  }, {
    key: "addToCart",
    value: function addToCart(event) {
      event.preventDefault();
      if (this.addToCartButton) {
        var variantId = this.addToCartButton.getAttribute('data-variant-id');
        if (!variantId) {
          return;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        }).then(function (data) {
          window.dispatchEvent(new CustomEvent('edition:cart:reload', {
            detail: data
          }));
          var cartbutton = document.querySelector('.cart_icon_header');
          if (cartbutton) {
            cartbutton.click();
          }
        })["catch"](function (error) {
          console.error('Error adding to cart:', error);
        });
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Wishlist/Wishlist.ts":
/*!***********************************************************!*\
  !*** ./resources/scripts/components/Wishlist/Wishlist.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Wishlist)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var Wishlist = /*#__PURE__*/function (_HTMLElement) {
  function Wishlist() {
    var _this;
    _classCallCheck(this, Wishlist);
    _this = _callSuper(this, Wishlist);
    _defineProperty(_this, "url", _this.dataset.url);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.handleShareWishlist = _this.handleShareWishlist.bind(_this);
    _this.setCounter = _this.setCounter.bind(_this);
    _this.renderWishlistItems = _this.renderWishlistItems.bind(_this);
    _this.generateWishlistItems = _this.generateWishlistItems.bind(_this);
    _this.createSkeletonLoader = _this.createSkeletonLoader.bind(_this);
    _this.checkForSharedWishlist = _this.checkForSharedWishlist.bind(_this);
    return _this;
  }
  _inherits(Wishlist, _HTMLElement);
  return _createClass(Wishlist, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var currentWishlist, parsedWishlist;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.addEventListeners();
              _context.n = 1;
              return this.renderWishlistItems();
            case 1:
              currentWishlist = localStorage.getItem('wishlist');
              parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : [];
              this.setCounter(parsedWishlist.length);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      var shareButton = document.getElementById('share-wishlist');
      if (shareButton) {
        shareButton.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleShareWishlist();
        });
      }
      this.checkForSharedWishlist();
      document.addEventListener('wishlistUpdated', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this2.setCounter(event.detail.wishlistCount);
                _context2.n = 1;
                return _this2.renderWishlistItems();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "renderWishlistItems",
    value: function () {
      var _renderWishlistItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this3 = this;
        var currentWishlist, parsedWishlist, wishlistItemsHtml;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              currentWishlist = localStorage.getItem('wishlist');
              parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : []; // clear the content of the wishlist-items element
              this.innerHTML = '';
              if (!(parsedWishlist.length === 0)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.innerHTML = "\n      ".concat(parsedWishlist.map(function () {
                return _this3.createSkeletonLoader();
              }).join(''), "\n    ");
              _context3.n = 2;
              return this.generateWishlistItems(parsedWishlist);
            case 2:
              wishlistItemsHtml = _context3.v;
              this.innerHTML = wishlistItemsHtml;
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function renderWishlistItems() {
        return _renderWishlistItems.apply(this, arguments);
      }
      return renderWishlistItems;
    }()
  }, {
    key: "generateWishlistItems",
    value: function () {
      var _generateWishlistItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(parsedWishlist) {
        var _this4 = this;
        var batchSize, batches, idsArray, i, responses, template, wishlitItemsHtml, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              batchSize = 20;
              batches = [];
              idsArray = parsedWishlist.map(function (id) {
                return "id:".concat(id);
              });
              for (i = 0; i < idsArray.length; i += batchSize) {
                batches.push(idsArray.slice(i, i + batchSize).join(' OR '));
              }
              _context4.n = 1;
              return Promise.all(batches.map(function (batchQuery) {
                return fetch("".concat(_this4.url, "&q=").concat(batchQuery)).then(function (res) {
                  if (!res.ok) throw new Error('Network response was not ok');
                  return res.text();
                });
              }));
            case 1:
              responses = _context4.v;
              template = document.createElement('template');
              wishlitItemsHtml = responses.map(function (response) {
                template.innerHTML = response;
                var wishlistItemsWrapper = template.content.querySelector('wishlist-component');
                return wishlistItemsWrapper ? Array.from(wishlistItemsWrapper.children).map(function (child) {
                  return child.outerHTML;
                }).join('') : '';
              }).join('');
              return _context4.a(2, wishlitItemsHtml);
            case 2:
              _context4.p = 2;
              _t = _context4.v;
              // eslint-disable-next-line no-console
              console.error(_t);
              return _context4.a(2, '');
          }
        }, _callee4, null, [[0, 2]]);
      }));
      function generateWishlistItems(_x2) {
        return _generateWishlistItems.apply(this, arguments);
      }
      return generateWishlistItems;
    }()
  }, {
    key: "createSkeletonLoader",
    value: function createSkeletonLoader() {
      return "\n      <div class=\"tw-animate-pulse tw-rounded-lg tw-border tw-bg-gray-200 tw-shadow-md tw-overflow-hidden\">\n        <div class=\"tw-w-full tw-h-[165px] tw-md:h-[250px] tw-bg-gray-300 !tw-block\"></div>\n        <div class=\"tw-p-6 tw-flex tw-flex-col tw-gap-4\">\n          <div class=\"tw-w-3/4 tw-h-6 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-1/2 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-1/3 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-1/4 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-1/2 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-1/3 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-1/4 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-1/2 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-full tw-h-10 tw-bg-gray-300 tw-rounded !tw-block\"></div>\n          <div class=\"tw-w-1/2 tw-h-4 tw-mx-auto tw-bg-gray-300 tw-rounded !tw-block\"></div>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "checkForSharedWishlist",
    value: function checkForSharedWishlist() {
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      var wishlist = params.get('wishlist');
      if (wishlist) {}
    }
  }, {
    key: "handleShareWishlist",
    value: function () {
      var _handleShareWishlist = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var currentWishlist, parsedWishlist, queryString, shareUrl;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              currentWishlist = localStorage.getItem('wishlist');
              parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : [];
              if (!(parsedWishlist.length === 0)) {
                _context5.n = 1;
                break;
              }
              // eslint-disable-next-line no-alert
              alert('Your wishlist is empty');
              return _context5.a(2);
            case 1:
              queryString = parsedWishlist.join(',');
              shareUrl = "".concat(window.location.href, "?wishlist=").concat(queryString); // copy to clipboard
              _context5.n = 2;
              return navigator.clipboard.writeText(shareUrl);
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      function handleShareWishlist() {
        return _handleShareWishlist.apply(this, arguments);
      }
      return handleShareWishlist;
    }()
  }, {
    key: "setCounter",
    value: function setCounter(count) {
      var counter = document.getElementById('counter-indicator');
      if (!counter) return;
      counter.textContent = count.toString();
      counter.classList.toggle('tw-hidden', count === 0);
      counter.classList.toggle('tw-flex', count > 0);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Wishlist/WishlistButton.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/Wishlist/WishlistButton.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ WishlistButton)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var WishlistButton = /*#__PURE__*/function (_HTMLElement) {
  function WishlistButton() {
    var _this;
    _classCallCheck(this, WishlistButton);
    _this = _callSuper(this, WishlistButton);
    _defineProperty(_this, "id", _this.dataset.id);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.toggleProductInWishlist = _this.toggleProductInWishlist.bind(_this);
    _this.checkIfProductIsInWishlist = _this.checkIfProductIsInWishlist.bind(_this);
    return _this;
  }
  _inherits(WishlistButton, _HTMLElement);
  return _createClass(WishlistButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.checkIfProductIsInWishlist();
      this.addEventListeners();
      console.log('WishlistButton connected');
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      this.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.toggleProductInWishlist();
        _this2.animateWishlistButton(event);
      });
    }
  }, {
    key: "toggleProductInWishlist",
    value: function toggleProductInWishlist() {
      var _this3 = this;
      var wishlist = localStorage.getItem('wishlist');
      var parsedWishlist = wishlist ? JSON.parse(wishlist) : [];
      // Wishlist is an array of handles
      var productIndex = parsedWishlist.findIndex(function (item) {
        return item === _this3.id;
      });
      if (productIndex !== -1) {
        parsedWishlist.splice(productIndex, 1); // Remove product
      } else {
        parsedWishlist.push(this.id); // Add product
      }
      localStorage.setItem('wishlist', JSON.stringify(parsedWishlist));
      this.classList.toggle('added-to-wishlist');
      // Dispatch event to update wishlist count
      var wishlistUpdatedEvent = new CustomEvent('wishlistUpdated', {
        detail: {
          wishlistCount: parsedWishlist.length,
          rerender: true
        }
      });
      document.dispatchEvent(wishlistUpdatedEvent);
    }
  }, {
    key: "checkIfProductIsInWishlist",
    value: function checkIfProductIsInWishlist() {
      var wishlist = localStorage.getItem('wishlist');
      if (wishlist) {
        var parsedWishlist = JSON.parse(wishlist);
        if (parsedWishlist.includes(this.id)) {
          this.classList.add('added-to-wishlist');
        }
      }
    }
  }, {
    key: "animateWishlistButton",
    value: function animateWishlistButton(event) {
      var particleWrapper = this.querySelector('.particles-wrapper');
      if (!particleWrapper) return;
      // Get the correct coordinates based on the event type
      var clientX;
      var clientY;
      if (event instanceof MouseEvent) {
        clientX = event.clientX;
        clientY = event.clientY;
      } else if (event instanceof TouchEvent) {
        clientX = event.touches[0].clientX;
        clientY = event.touches[0].clientY;
      } else {
        return;
      }
      // Calculate position relative to particleWrapper
      var rect = particleWrapper.getBoundingClientRect();
      var offsetX = clientX - rect.left;
      var offsetY = clientY - rect.top;
      var _loop = function _loop() {
        var particle = document.createElement('div');
        particle.classList.add('particles');
        // Randomize movement direction
        var angle = Math.random() * 2 * Math.PI;
        var distance = Math.random() * 20 + 10; // Spread particles outwards
        var x = Math.cos(angle) * distance;
        var y = Math.sin(angle) * distance;
        // Position relative to click/touch
        particle.style.left = "".concat(offsetX, "px");
        particle.style.top = "".concat(offsetY, "px");
        particle.style.setProperty('--x', "".concat(x, "px"));
        particle.style.setProperty('--y', "".concat(y, "px"));
        particleWrapper.appendChild(particle);
        // Remove particle after animation (matching duration in CSS)
        setTimeout(function () {
          return particle.remove();
        }, 2000);
      };
      for (var i = 0; i < 15; i += 1) {
        _loop();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/Animations.ts":
/*!***********************************************!*\
  !*** ./resources/scripts/utils/Animations.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fadeIn": () => (/* binding */ fadeIn),
/* harmony export */   "fadeUp": () => (/* binding */ fadeUp)
/* harmony export */ });
var fadeIn = function fadeIn(element, index, duration, timeOut) {
  element.style.willChange = 'opacity';
  element.style.opacity = '0';
  requestAnimationFrame(function () {
    setTimeout(function () {
      element.style.transition = "opacity ".concat(duration, "ms");
      element.style.opacity = '1';
    }, index * timeOut);
  });
};
var fadeUp = function fadeUp(element, index, duration, timeOut) {
  // Apply initial styles
  element.style.willChange = 'transform, opacity';
  element.style.transform = 'translateY(70px)';
  element.style.opacity = '0';
  element.style.transition = 'none'; // Temporarily disable transition
  // Define the fade-up animation
  var animate = function animate(delay) {
    setTimeout(function () {
      requestAnimationFrame(function () {
        element.style.transition = "opacity ".concat(duration, "ms, transform ").concat(duration, "ms");
        element.style.opacity = '1';
        element.style.transform = 'translateY(0)';
      });
    }, delay);
  };
  // Helper function to check if the element is visible from the top of the window
  // eslint-disable-next-line @typescript-eslint/no-shadow
  var isVisibleFromTop = function isVisibleFromTop(element, threshold) {
    var rect = element.getBoundingClientRect();
    return rect.top < threshold;
  };
  var threshold = 350; // Adjust this value as needed
  // Initial check for elements visible from the top of the window
  if (isVisibleFromTop(element, threshold)) {
    animate(index * timeOut); // Apply animation with index-based timeout for initial elements visible from the top
  } else {
    // Create and set up IntersectionObserver for elements not initially visible from the top
    var observer = new IntersectionObserver(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Only apply the animation once
          if (!element.classList.contains('animated')) {
            element.classList.add('animated');
            animate(timeOut); // Apply animation with a fixed timeout for elements scrolled into view
          }
          // Stop observing after animation to improve performance
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: [0.1]
    });
    // Start observing the element
    observer.observe(element);
  }
};

/***/ }),

/***/ "./resources/scripts/utils/CartApiEndpoints.ts":
/*!*****************************************************!*\
  !*** ./resources/scripts/utils/CartApiEndpoints.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addVariantToCart": () => (/* binding */ addVariantToCart)
/* harmony export */ });
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// eslint-disable-next-line import/prefer-default-export
function addVariantToCart(_x) {
  return _addVariantToCart.apply(this, arguments);
}
function _addVariantToCart() {
  _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(variantId) {
    var response, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch("/cart/add.js", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
        case 1:
          response = _context.v;
          if (response.ok) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          }
          _context.n = 3;
          break;
        case 2:
          _context.p = 2;
          _t = _context.v;
          console.error(_t);
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _addVariantToCart.apply(this, arguments);
}

/***/ }),

/***/ "./resources/scripts/utils/CookieMethods.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deleteCookie": () => (/* binding */ deleteCookie),
/* harmony export */   "getCookie": () => (/* binding */ getCookie),
/* harmony export */   "setCookie": () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ }),

/***/ "./resources/scripts/utils/DiscountCode.ts":
/*!*************************************************!*\
  !*** ./resources/scripts/utils/DiscountCode.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fetchDiscountCode": () => (/* binding */ fetchDiscountCode)
/* harmony export */ });
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// eslint-disable-next-line import/prefer-default-export
function fetchDiscountCode(_x) {
  return _fetchDiscountCode.apply(this, arguments);
}
function _fetchDiscountCode() {
  _fetchDiscountCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(discountCode) {
    var response, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch("/discount/".concat(discountCode));
        case 1:
          response = _context.v;
          if (response.ok) {
            setTimeout(function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }, 1500);
          }
          _context.n = 3;
          break;
        case 2:
          _context.p = 2;
          _t = _context.v;
          console.error(_t);
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _fetchDiscountCode.apply(this, arguments);
}

/***/ }),

/***/ "./resources/scripts/utils/ProductApiEndpoints.ts":
/*!********************************************************!*\
  !*** ./resources/scripts/utils/ProductApiEndpoints.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getProduct": () => (/* binding */ getProduct),
/* harmony export */   "restapiGetProducts": () => (/* binding */ restapiGetProducts)
/* harmony export */ });
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// eslint-disable-next-line consistent-return
function getProduct(_x) {
  return _getProduct.apply(this, arguments);
}
// function to get products using an array of ids
// eslint-disable-next-line consistent-return
function _getProduct() {
  _getProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(productHandle) {
    var response, data, product, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch("/products/".concat(productHandle, ".json"));
        case 1:
          response = _context.v;
          if (!response.ok) {
            _context.n = 3;
            break;
          }
          _context.n = 2;
          return response.json();
        case 2:
          data = _context.v;
          product = data.product.product;
          return _context.a(2, product);
        case 3:
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[0, 4]]);
  }));
  return _getProduct.apply(this, arguments);
}
function restapiGetProducts(_x2) {
  return _restapiGetProducts.apply(this, arguments);
}
function _restapiGetProducts() {
  _restapiGetProducts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(ids) {
    var response, data, products, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetch("https://club-bisgaard.vercel.app/apiv1/get-products?ids=".concat(ids));
        case 1:
          response = _context2.v;
          if (!response.ok) {
            _context2.n = 3;
            break;
          }
          _context2.n = 2;
          return response.json();
        case 2:
          data = _context2.v;
          products = data.products.products;
          return _context2.a(2, products);
        case 3:
          _context2.n = 5;
          break;
        case 4:
          _context2.p = 4;
          _t2 = _context2.v;
        case 5:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 4]]);
  }));
  return _restapiGetProducts.apply(this, arguments);
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/src/assets/app": 0,
/******/ 			"src/assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbisgaardshoes_dk"] = self["webpackChunkbisgaardshoes_dk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;